import _, { get, uniqBy, sortBy, isEmpty, mapKeys, keyBy, uniq, isEqual, cloneDeep, map, forEach, omit, find, chain } from 'lodash';
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import axios from 'axios';
import { notification, Alert, List, Icon, Row, Button, Form, Input, Col, Tag, Typography, Select, Table, Radio, Switch, Card, Collapse, Spin, PageHeader } from 'antd';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useCallback, createContext, memo, useLayoutEffect, useState, cloneElement, isValidElement, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, defineMessages, injectIntl } from 'react-intl';
import { useDispatch, useSelector, connect, Provider } from 'react-redux';
import { jsx } from 'react/jsx-runtime';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _library = true;

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode: 'pure',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var f$1 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$1
};

var f$2 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$2
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 19.1.2.1 Object.assign(target, source, ...)






var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

var assign = _core.Object.assign;

var assign$1 = createCommonjsModule(function (module) {
module.exports = { "default": assign, __esModule: true };
});

var _Object$assign = unwrapExports(assign$1);

var _extends = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _assign2 = _interopRequireDefault(assign$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
});

var _extends$1 = unwrapExports(_extends);

var objectWithoutProperties = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};
});

var _objectWithoutProperties = unwrapExports(objectWithoutProperties);

var FETCH_CONNECTION_SETTINGS_REQUEST = 'FETCH_CONNECTION_SETTINGS_REQUEST';
var FETCH_CONNECTION_SETTINGS_FAILURE = 'FETCH_CONNECTION_SETTINGS_FAILURE';
var FETCH_CONNECTION_SETTINGS_SUCCESS = 'FETCH_CONNECTION_SETTINGS_SUCCESS';

var UPDATE_CONNECTION_SETTINGS_REQUEST = 'UPDATE_CONNECTION_SETTINGS_REQUEST';
var UPDATE_CONNECTION_SETTINGS_FAILURE = 'UPDATE_CONNECTION_SETTINGS_FAILURE';
var UPDATE_CONNECTION_SETTINGS_SUCCESS = 'UPDATE_CONNECTION_SETTINGS_SUCCESS';

var classCallCheck = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
});

var _classCallCheck = unwrapExports(classCallCheck);

var ConnectionSettings = function ConnectionSettings(_ref) {
  var organizationId = _ref.organizationId,
      baseUrl = _ref.baseUrl,
      username = _ref.username,
      password = _ref.password,
      certificateKey = _ref.certificateKey;

  _classCallCheck(this, ConnectionSettings);

  this.organizationId = organizationId;
  this.baseUrl = baseUrl;
  this.username = username;
  this.password = password;
  this.certificateKey = certificateKey;
};

var initialState = new ConnectionSettings({});

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case FETCH_CONNECTION_SETTINGS_SUCCESS:
      var newIntegrationSettings = new ConnectionSettings(get(action.payload.data, 'connectionSetting'));
      return _extends$1({}, newIntegrationSettings);

    case FETCH_CONNECTION_SETTINGS_FAILURE:
      return _extends$1({}, state, {
        isNew: true
      });

    default:
      return state;
  }
};

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var _iterators = {};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!_library && typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$1 = _wks('iterator');
var ArrayProto = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
  else object[index] = value;
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$1 = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var ITERATOR$2 = _wks('iterator');

var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$2]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var ITERATOR$3 = _wks('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$3]();
  riter['return'] = function () { SAFE_CLOSING = true; };
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$3]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$3] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

_export(_export.S + _export.F * !_iterDetect(function (iter) { }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

var from_1 = _core.Array.from;

var from_1$1 = createCommonjsModule(function (module) {
module.exports = { "default": from_1, __esModule: true };
});

unwrapExports(from_1$1);

var toConsumableArray = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _from2 = _interopRequireDefault(from_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
});

var _toConsumableArray = unwrapExports(toConsumableArray);

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

var $Object = _core.Object;
var defineProperty = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$1 = createCommonjsModule(function (module) {
module.exports = { "default": defineProperty, __esModule: true };
});

unwrapExports(defineProperty$1);

var defineProperty$3 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
});

var _defineProperty = unwrapExports(defineProperty$3);

var CREATE_MAPPING_FOR_APP_REQUEST = 'CREATE_MAPPING_FOR_APP_REQUEST';
var CREATE_MAPPING_FOR_APP_SUCCESS = 'CREATE_MAPPING_FOR_APP_SUCCESS';
var CREATE_MAPPING_FOR_APP_FAILURE = 'CREATE_MAPPING_FOR_APP_FAILURE';

var FETCH_MAPPING_FOR_APP_REQUEST = 'FETCH_MAPPING_FOR_APP_REQUEST';
var FETCH_MAPPING_FOR_APP_SUCCESS = 'FETCH_MAPPING_FOR_APP_SUCCESS';
var FETCH_MAPPING_FOR_APP_FAILURE = 'FETCH_MAPPING_FOR_APP_FAILURE';

var RESET_MAPPING_FOR_APP = 'RESET_MAPPING_FOR_APP';

var TEST_MAPPING_FOR_OBJECT_TYPE_REQUEST = 'TEST_MAPPING_FOR_OBJECT_TYPE_REQUEST';
var TEST_MAPPING_FOR_OBJECT_TYPE_SUCCESS = 'TEST_MAPPING_FOR_OBJECT_TYPE_SUCCESS';
var TEST_MAPPING_FOR_OBJECT_TYPE_FAILURE = 'TEST_MAPPING_FOR_OBJECT_TYPE_FAILURE';

var TEST_MAPPING_FOR_ALL_OBJECT_TYPES_REQUEST = 'TEST_MAPPING_FOR_ALL_OBJECT_TYPES_REQUEST';
var TEST_MAPPING_FOR_ALL_OBJECT_TYPES_SUCCESS = 'TEST_MAPPING_FOR_ALL_OBJECT_TYPES_SUCCESS';
var TEST_MAPPING_FOR_ALL_OBJECT_TYPES_FAILURE = 'TEST_MAPPING_FOR_ALL_OBJECT_TYPES_FAILURE';

var ADD_NEW_OBJECT_TYPE = 'ADD_NEW_OBJECT_TYPE';
var UPDATE_LABEL_FOR_OBJECT_TYPE = 'UPDATE_LABEL_FOR_OBJECT_TYPE';
var UPDATE_FIELD_MAPPING_MODE_FOR_OBJECT_TYPE = 'UPDATE_FIELD_MAPPING_MODE_FOR_OBJECT_TYPE';
var UPDATE_FOR_OBJECT_TYPE = 'UPDATE_FOR_OBJECT_TYPE';
var UPDATE_OBJECT_TYPE_EXT_ID_FOR_OBJECT_TYPE = 'UPDATE_OBJECT_TYPE_EXT_ID_FOR_OBJECT_TYPE';

var UPDATE_LABEL_FOR_FIELD_IN_OBJECT_TYPE = 'UPDATE_LABEL_FOR_FIELD_IN_OBJECT_TYPE';
var UPDATE_EXTID_FOR_FIELD_IN_OBJECT_TYPE = 'UPDATE_EXTID_FOR_FIELD_IN_OBJECT_TYPE';
var UPDATE_FOR_FIELD_IN_OBJECT_TYPE = 'UPDATE_FOR_FIELD_IN_OBJECT_TYPE';

var SAVE_MAPPING_FOR_APP_REQUEST = 'SAVE_MAPPING_FOR_APP_REQUEST';
var SAVE_MAPPING_FOR_APP_SUCCESS = 'SAVE_MAPPING_FOR_APP_SUCCESS';
var SAVE_MAPPING_FOR_APP_FAILURE = 'SAVE_MAPPING_FOR_APP_FAILURE';

var DELETE_OBJECT_TYPE_FOR_APP_REQUEST = 'DELETE_OBJECT_TYPE_FOR_APP_REQUEST';
var DELETE_OBJECT_TYPE_FOR_APP_SUCCESS = 'DELETE_OBJECT_TYPE_FOR_APP_SUCCESS';
var DELETE_OBJECT_TYPE_FOR_APP_FAILURE = 'DELETE_OBJECT_TYPE_FOR_APP_FAILURE';

var SAVE_EXAM_SHOULD_PUBLISH_REQUEST = 'SAVE_EXAM_SHOULD_PUBLISH_REQUEST';
var SAVE_EXAM_SHOULD_PUBLISH_FAILURE = 'SAVE_EXAM_SHOULD_PUBLISH_FAILURE';
var SAVE_EXAM_SHOULD_PUBLISH_SUCCESS = 'SAVE_EXAM_SHOULD_PUBLISH_SUCCESS';

var objectTypeMappingTypes = {
  STATIC: 'STATIC', // Static requires applicationObjectTypeName
  DYNAMIC: 'DYNAMIC' // Should not have applicationObjectTypeName prop but at least one of the fields must have appProperty = appProperties.LABEL
};

var _objectTypeMappingSta;

var objectTypeMappingStatuses = {
  NOT_TESTED: 'NOT_TESTED',
  NOT_MAPPED: 'NOT_MAPPED',
  MAPPED: 'MAPPED',
  TESTED: 'TESTED',
  FAILED: 'FAILED'
};

var objectTypeMappingStatusProps = (_objectTypeMappingSta = {}, _defineProperty(_objectTypeMappingSta, objectTypeMappingStatuses.NOT_TESTED, {
  label: 'Not mapped',
  color: '#ffdd5c'
}), _defineProperty(_objectTypeMappingSta, objectTypeMappingStatuses.NOT_MAPPED, {
  label: 'Not mapped',
  color: '#ffdd5c'
}), _defineProperty(_objectTypeMappingSta, objectTypeMappingStatuses.MAPPED, {
  label: 'Mapped',
  color: '#3fa5b3'
}), _defineProperty(_objectTypeMappingSta, objectTypeMappingStatuses.TESTED, {
  label: 'Tested',
  color: '#29b68f'
}), _defineProperty(_objectTypeMappingSta, objectTypeMappingStatuses.FAILED, {
  label: 'Failed',
  color: '#ff6357'
}), _objectTypeMappingSta);

var ObjectTypeMapping = function ObjectTypeMapping(_ref) {
  var _ref$objectTypeMappin = _ref.objectTypeMappingType,
      objectTypeMappingType = _ref$objectTypeMappin === undefined ? objectTypeMappingTypes.DYNAMIC : _ref$objectTypeMappin,
      _ref$applicationObjec = _ref.applicationObjectTypeName,
      applicationObjectTypeName = _ref$applicationObjec === undefined ? null : _ref$applicationObjec,
      _ref$applicationObjec2 = _ref.applicationObjectTypeGroup,
      applicationObjectTypeGroup = _ref$applicationObjec2 === undefined ? null : _ref$applicationObjec2,
      _ref$objectTypeExtId = _ref.objectTypeExtId,
      objectTypeExtId = _ref$objectTypeExtId === undefined ? null : _ref$objectTypeExtId,
      applicationObjectTypeLabel = _ref.applicationObjectTypeLabel,
      fieldMappingMode = _ref.fieldMappingMode,
      _ref$status = _ref.status,
      status = _ref$status === undefined ? objectTypeMappingStatuses.NOT_MAPPED : _ref$status,
      _ref$labelField = _ref.labelField,
      labelField = _ref$labelField === undefined ? null : _ref$labelField,
      _ref$secondaryLabelFi = _ref.secondaryLabelField,
      secondaryLabelField = _ref$secondaryLabelFi === undefined ? null : _ref$secondaryLabelFi,
      _ref$fields = _ref.fields,
      fields = _ref$fields === undefined ? [] : _ref$fields,
      _ref$sampleObjects = _ref.sampleObjects,
      sampleObjects = _ref$sampleObjects === undefined ? [] : _ref$sampleObjects,
      _ref$errors = _ref.errors,
      errors = _ref$errors === undefined ? [] : _ref$errors;

  _classCallCheck(this, ObjectTypeMapping);

  this.objectTypeMappingType = objectTypeMappingType;
  this.applicationObjectTypeName = applicationObjectTypeName;
  this.applicationObjectTypeGroup = applicationObjectTypeGroup;
  this.objectTypeExtId = objectTypeExtId;
  this.applicationObjectTypeLabel = applicationObjectTypeLabel;
  this.fieldMappingMode = fieldMappingMode;
  this.status = status;
  this.labelField = labelField;
  this.secondaryLabelField = secondaryLabelField;
  this.fields = fields;
  this.sampleObjects = sampleObjects;
  this.errors = errors;
};

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var keys = _core.Object.keys;

var keys$1 = createCommonjsModule(function (module) {
module.exports = { "default": keys, __esModule: true };
});

var _Object$keys = unwrapExports(keys$1);

var appNames = {
  TE_EXAM: 'teExam',
  TE_PREFERENNCES: 'tePref',
  TE_PRICING: 'tePricing',
  TE_REPORTING: 'teReporting',
  HOOTDESK: 'teHootdesk'
};

var _fieldMappingModeProp;

var fieldMappingModes = {
  RAW: 'RAW',
  FREE_MAPPING: 'FREE_MAPPING',
  MAPPED: 'MAPPED'
};

var fieldMappingModeProps = (_fieldMappingModeProp = {}, _defineProperty(_fieldMappingModeProp, fieldMappingModes.RAW, {
  label: 'Only first primary field'
}), _defineProperty(_fieldMappingModeProp, fieldMappingModes.FREE_MAPPING, {
  label: 'Free field selection'
}), _defineProperty(_fieldMappingModeProp, fieldMappingModes.MAPPED, {
  label: 'Predetermined fields'
}), _fieldMappingModeProp);

var ApplicationMappingTemplate = // general errors, mostly in local

function ApplicationMappingTemplate(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      objectTypes = _ref.objectTypes,
      _ref$allowDynamicObje = _ref.allowDynamicObjectTypes,
      allowDynamicObjectTypes = _ref$allowDynamicObje === undefined ? false : _ref$allowDynamicObje,
      _ref$allowedMappingMo = _ref.allowedMappingModes,
      allowedMappingModes = _ref$allowedMappingMo === undefined ? [fieldMappingModes.RAW, fieldMappingModes.MAPPED, fieldMappingModes.FREE_MAPPING] : _ref$allowedMappingMo;

  _classCallCheck(this, ApplicationMappingTemplate);

  this.errors = [];

  this.appName = appName;
  this.organizationId = organizationId;
  this.objectTypes = objectTypes;
  this.allowDynamicObjectTypes = allowDynamicObjectTypes;
  this.allowedMappingModes = allowedMappingModes;
};

var FieldMapping = function FieldMapping(_ref) {
  var appFieldName = _ref.appFieldName,
      _ref$appProperty = _ref.appProperty,
      appProperty = _ref$appProperty === undefined ? null : _ref$appProperty,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === undefined ? true : _ref$isSearchable,
      fieldExtId = _ref.fieldExtId,
      fieldLabel = _ref.fieldLabel,
      isActive = _ref.isActive;

  _classCallCheck(this, FieldMapping);

  this.appFieldName = appFieldName || fieldExtId; // Statically mapped object types should have appFieldName
  this.appProperty = appProperty; // only for free mapping to understand if the field has a specialsignificance in the application
  this.isSearchable = isSearchable;
  this.fieldExtId = fieldExtId;
  this.fieldLabel = fieldLabel || fieldExtId;
  this.isActive = isActive;
};

var _objectTypeGroupProps;

var objectTypeGroups = {
  ROOM: 'ROOM',
  PROFESSOR: 'PROFESSOR',
  COURSE_INFORMATION: 'COURSE_INFORMATION',
  INVOICING: 'INVOICING'
};

var objectTypeGroupProps = (_objectTypeGroupProps = {}, _defineProperty(_objectTypeGroupProps, objectTypeGroups.ROOM, {
  label: 'Room'
}), _defineProperty(_objectTypeGroupProps, objectTypeGroups.PROFESSOR, {
  label: 'Professor'
}), _defineProperty(_objectTypeGroupProps, objectTypeGroups.COURSE_INFORMATION, {
  label: 'Course Information'
}), _defineProperty(_objectTypeGroupProps, objectTypeGroups.INVOICING, {
  label: 'Invoicing'
}), _objectTypeGroupProps);

var teExamObjectTypes = [new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'room',
  applicationObjectTypeGroup: objectTypeGroups.ROOM,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Room', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'description',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Description' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'capacity',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Capacity' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'building',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Building' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'campus',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Campus' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'floor',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Floor' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'address',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Address' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'pricePerSeatPerHour',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Price per seat per hour' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'roomType',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Room type' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'professor',
  applicationObjectTypeGroup: objectTypeGroups.PROFESSOR,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Professor', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'id',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Id' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'email',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Email' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'department',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Department' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'coordinator',
  applicationObjectTypeGroup: objectTypeGroups.PROFESSOR,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Coordinator', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'id',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Id' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'email',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Email' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'department',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Department' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'course',
  applicationObjectTypeGroup: objectTypeGroups.COURSE_INFORMATION,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Course', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'code',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Code' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'credits',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Credits' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'courseEvent',
  applicationObjectTypeGroup: objectTypeGroups.COURSE_INFORMATION,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Course Event', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'id',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Id' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'number',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Number' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'courseName',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Course name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'courseCode',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Course code' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'department',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Department' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'module',
  applicationObjectTypeGroup: objectTypeGroups.COURSE_INFORMATION,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Module', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'id',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Id' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'credits',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Credits' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'coursePart',
  applicationObjectTypeGroup: objectTypeGroups.COURSE_INFORMATION,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Course Part', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'id',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Id' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'credits',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Credits' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'program',
  applicationObjectTypeGroup: objectTypeGroups.COURSE_INFORMATION,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Program', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'id',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Id' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'number',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Number' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'studentGroup',
  applicationObjectTypeGroup: objectTypeGroups.COURSE_INFORMATION,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Student Group', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'id',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Id' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'number',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Number' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'courseName',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Course name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'courseCode',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Course code' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'department',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Department' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'costCenter',
  applicationObjectTypeGroup: objectTypeGroups.INVOICING,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Cost center', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'id',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Id' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'department',
  applicationObjectTypeGroup: objectTypeGroups.INVOICING,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Department', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'code',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'code' // User can override but we provide default
  })]
}), new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'externalCustomer',
  applicationObjectTypeGroup: objectTypeGroups.INVOICING,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'External Customer', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  labelField: 'name',
  secondaryLabelField: 'name',
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'id',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Id' // User can override but we provide default
  })]
})];

var teExamMappingTemplate = new ApplicationMappingTemplate({
  appName: appNames.TE_EXAM,
  organizationId: null, // Set at runtime for the specific org doing the mapping
  allowDynamicObjectTypes: false,
  objectTypes: teExamObjectTypes,
  allowedMappingModes: [fieldMappingModes.MAPPED]
});

var tePrefsMappingTemplate = new ApplicationMappingTemplate({
  appName: appNames.TE_PREFERENCES,
  organizationId: null, // Set at runtime for the specific org doing the mapping
  allowDynamicObjectTypes: true,
  objectTypes: [],
  allowedMappingModes: [fieldMappingModes.FREE_MAPPING]
});

var tePricingMappingTemplate = new ApplicationMappingTemplate({
  appName: appNames.TE_PRICING,
  organizationId: null, // Set at runtime for the specific org doing the mapping
  allowDynamicObjectTypes: true,
  objectTypes: [],
  allowedMappingModes: [fieldMappingModes.FREE_MAPPING]
});

var teReportingMappingTemplate = new ApplicationMappingTemplate({
  appName: appNames.TE_REPORTING,
  organizationId: null, // Set at runtime for the specific org doing the mapping
  allowDynamicObjectTypes: true,
  objectTypes: [],
  allowedMappingModes: [fieldMappingModes.FREE_MAPPING]
});

var teHootdeskObjectTypes = [new ObjectTypeMapping({
  objectTypeMappingType: objectTypeMappingTypes.STATIC,
  applicationObjectTypeName: 'bookable',
  applicationObjectTypeGroup: objectTypeGroups.ROOM,
  objectTypeExtId: null, // This is set in the mapping by the user, not in the template
  applicationObjectTypeLabel: 'Bookabke', // User is free to override, but we provide a default
  fieldMappingMode: fieldMappingModes.MAPPED,
  status: objectTypeMappingStatuses.NOT_MAPPED,
  fields: [new FieldMapping({
    appFieldName: 'name',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Name' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'description',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Description' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'capacity',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Capacity' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'building',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Building' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'campus',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Campus' // User can override but we provide default
  }), new FieldMapping({
    appFieldName: 'roomType',
    appProperty: null, // Static type, don't need an app property
    fieldExtId: null, // Set by user in mapping
    fieldLabel: 'Room type' // User can override but we provide default
  })]
})];

var teHootdeskMappingTemplate = new ApplicationMappingTemplate({
  appName: appNames.HOOTDESK,
  organizationId: null, // Set at runtime for the specific org doing the mapping
  allowDynamicObjectTypes: false,
  objectTypes: teHootdeskObjectTypes,
  allowedMappingModes: [fieldMappingModes.MAPPED]
});

var _appTemplates;

var appTemplates = (_appTemplates = {}, _defineProperty(_appTemplates, appNames.TE_EXAM, teExamMappingTemplate), _defineProperty(_appTemplates, appNames.TE_PREFERENNCES, tePrefsMappingTemplate), _defineProperty(_appTemplates, appNames.TE_PRICING, tePricingMappingTemplate), _defineProperty(_appTemplates, appNames.HOOTDESK, teHootdeskMappingTemplate), _defineProperty(_appTemplates, appNames.TE_REPORTING, teReportingMappingTemplate), _appTemplates);

var createNewApplicationTemplateMapping = function createNewApplicationTemplateMapping(appName) {
  return appTemplates[appName] || null;
};

var createNewObjectTypeForApplication = function createNewObjectTypeForApplication(fieldMappingMode) {
  return new ObjectTypeMapping({
    objectTypeMappingType: objectTypeMappingTypes.DYNAMIC,
    fieldMappingMode: fieldMappingMode
  });
};

var initialState$1 = _Object$keys(appNames).reduce(function (state, appName) {
  return _extends$1({}, state, _defineProperty({}, appNames[appName], createNewApplicationTemplateMapping(appNames[appName])));
}, {});

var reducer$1 = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments[1];

  switch (action.type) {
    case FETCH_MAPPING_FOR_APP_SUCCESS:
      {
        var _appName = action.payload.actionPayload.appName;

        if (!state[_appName]) return _extends$1({}, state);

        // const objectTypes = (state[appName].objectTypes || []).map(item => {
        //   const foundObj = action.payload.data.mapping.objectTypes.find(obj => obj.applicationObjectTypeName === item.applicationObjectTypeName);
        //   if (foundObj) {
        //     return new ObjectTypeMapping(foundObj);
        //   }
        //   return item;
        // });

        var appObjectTypes = state[_appName].objectTypes;
        var objectTypes = uniqBy(action.payload.data.mapping.objectTypes.concat(appObjectTypes), function (item) {
          return item.applicationObjectTypeName;
        }).map(function (obj) {
          var fields = obj.fields.map(function (field) {
            return new FieldMapping(_extends$1({}, field, { isActive: true }));
          });
          if (!obj.labelField || !obj.secondaryLabelField) {
            var initialObjectType = initialState$1[_appName].objectTypes.find(function (type) {
              return type.applicationObjectTypeName === obj.applicationObjectTypeName;
            });
            if (initialObjectType) {
              if (initialObjectType.labelField && !obj.labelField) {
                obj.labelField = initialObjectType.labelField;
              }
              if (initialObjectType.secondaryLabelField && !obj.secondaryLabelField) {
                obj.secondaryLabelField = initialObjectType.secondaryLabelField;
              }
            }
          }

          return new ObjectTypeMapping(_extends$1({}, obj, { fields: fields }));
        });
        return _extends$1({}, state, _defineProperty({}, _appName, _extends$1({}, state[_appName], {
          objectTypes: objectTypes
        })));
      }

    case FETCH_MAPPING_FOR_APP_FAILURE:
      {
        var _appName2 = action.payload.actionPayload.appName;

        return _extends$1({}, state, _defineProperty({}, _appName2, _extends$1({}, state[_appName2], {
          isNew: true
        })));
      }

    case CREATE_MAPPING_FOR_APP_SUCCESS:
    case CREATE_MAPPING_FOR_APP_FAILURE:
      {
        var _appName3 = action.payload.actionPayload.appName;

        return _extends$1({}, state, _defineProperty({}, _appName3, _extends$1({}, state[_appName3], {
          isNew: false
        })));
      }

    case RESET_MAPPING_FOR_APP:
      return _extends$1({}, state, _defineProperty({}, action.payload.appName, _extends$1({}, initialState$1[action.payload.appName])));

    case TEST_MAPPING_FOR_OBJECT_TYPE_SUCCESS:
      {
        var _action$payload = action.payload,
            _appName4 = _action$payload.appName,
            objectTypeIdx = _action$payload.objectTypeIdx,
            data = _action$payload.data,
            errors = _action$payload.meta.errors;


        var status = errors && errors.length > 0 ? objectTypeMappingStatuses.FAILED : objectTypeMappingStatuses.TESTED;

        return _extends$1({}, state, _defineProperty({}, _appName4, _extends$1({}, state[_appName4], {
          errors: [],
          objectTypes: [].concat(_toConsumableArray(state[_appName4].objectTypes.slice(0, objectTypeIdx)), [_extends$1({}, state[_appName4].objectTypes[objectTypeIdx], {
            sampleObjects: data.map(function (_ref) {
              var fields = _ref.fields;
              return fields;
            }),
            status: status,
            errors: errors
          })], _toConsumableArray(state[_appName4].objectTypes.slice(objectTypeIdx + 1)))
        })));
      }

    case TEST_MAPPING_FOR_ALL_OBJECT_TYPES_SUCCESS:
      {
        var _action$payload2 = action.payload,
            _appName5 = _action$payload2.appName,
            _data = _action$payload2.data,
            meta = _action$payload2.meta;

        // todo: IMPORTANT implement displaying mandatory object types not mapped feature
        //  (currently BE still not support)

        return _extends$1({}, state, _defineProperty({}, _appName5, _extends$1({}, state[_appName5], {
          errors: [],
          objectTypes: state[_appName5].objectTypes.map(function (type) {
            if (meta[type.applicationObjectTypeName] && type.status !== objectTypeMappingStatuses.NOT_MAPPED) {
              var _errors = meta[type.applicationObjectTypeName].errors;


              type.status = _errors && _errors.length > 0 ? objectTypeMappingStatuses.FAILED : objectTypeMappingStatuses.TESTED;
              type.errors = _errors;
              type.sampleObjects = (_data[type.applicationObjectTypeName] || []).map(function (_ref2) {
                var fields = _ref2.fields;
                return fields;
              });
            }
            return type;
          })
        })));
      }

    case TEST_MAPPING_FOR_ALL_OBJECT_TYPES_FAILURE:
      var _action$payload3 = action.payload,
          appName = _action$payload3.appName,
          message = _action$payload3.message;


      return _extends$1({}, state, _defineProperty({}, appName, _extends$1({}, state[appName], {
        errors: [message]
      })));

    case ADD_NEW_OBJECT_TYPE:
      {
        var _action$payload4 = action.payload,
            _appName6 = _action$payload4.appName,
            objectType = _action$payload4.objectType;

        if (!_appName6 || !objectType) return state;
        return _extends$1({}, state, _defineProperty({}, _appName6, _extends$1({}, state[_appName6], {
          objectTypes: [].concat(_toConsumableArray(state[_appName6].objectTypes), [objectType])
        })));
      }

    case UPDATE_LABEL_FOR_OBJECT_TYPE:
    case UPDATE_FIELD_MAPPING_MODE_FOR_OBJECT_TYPE:
    case UPDATE_FOR_OBJECT_TYPE:
      {
        var _action$payload5 = action.payload,
            _appName7 = _action$payload5.appName,
            _objectTypeIdx = _action$payload5.objectTypeIdx,
            update = _objectWithoutProperties(_action$payload5, ['appName', 'objectTypeIdx']);
        // TODO: reset all objectFieldsId to null, should do it here ?


        if (!_appName7 || _objectTypeIdx == null) return state;

        // update testing status (when update mapping mode)
        if (update.hasOwnProperty('fieldMappingMode')) {
          var objectTypeExtId = state[_appName7].objectTypes[_objectTypeIdx].objectTypeExtId;

          if (objectTypeExtId) {
            update.status = objectTypeMappingStatuses.MAPPED;
          }
        }

        return _extends$1({}, state, _defineProperty({}, _appName7, _extends$1({}, state[_appName7], {
          objectTypes: [].concat(_toConsumableArray(state[_appName7].objectTypes.slice(0, _objectTypeIdx)), [_extends$1({}, state[_appName7].objectTypes[_objectTypeIdx], { hasChanges: true }, update)], _toConsumableArray(state[_appName7].objectTypes.slice(_objectTypeIdx + 1)))
        })));
      }

    case UPDATE_OBJECT_TYPE_EXT_ID_FOR_OBJECT_TYPE:
      {
        var _action$payload6 = action.payload,
            _appName8 = _action$payload6.appName,
            _objectTypeIdx2 = _action$payload6.objectTypeIdx,
            _objectTypeExtId = _action$payload6.objectTypeExtId;
        // TODO: reset all objectFieldsId to null, shoud do it here ?

        if (!_appName8 || _objectTypeIdx2 == null) return state;
        var objectTypeToUpdate = _extends$1({}, state[_appName8].objectTypes[_objectTypeIdx2], { objectTypeExtId: _objectTypeExtId });
        var updatedFields = (objectTypeToUpdate.fields || []).map(function (item) {
          return new FieldMapping(_extends$1({}, item, { fieldExtId: null }));
        });

        // update testing status
        var prevObjectTypeExtId = state[_appName8].objectTypes[_objectTypeIdx2].objectTypeExtId;

        if (!_objectTypeExtId) {
          objectTypeToUpdate.status = objectTypeMappingStatuses.NOT_MAPPED;
        } else if (_objectTypeExtId !== prevObjectTypeExtId) {
          objectTypeToUpdate.status = objectTypeMappingStatuses.MAPPED;
        }

        return _extends$1({}, state, _defineProperty({}, _appName8, _extends$1({}, state[_appName8], {
          objectTypes: [].concat(_toConsumableArray(state[_appName8].objectTypes.slice(0, _objectTypeIdx2)), [_extends$1({}, objectTypeToUpdate, { fields: updatedFields, hasChanges: true })], _toConsumableArray(state[_appName8].objectTypes.slice(_objectTypeIdx2 + 1)))
        })));
      }

    case UPDATE_LABEL_FOR_FIELD_IN_OBJECT_TYPE:
    case UPDATE_EXTID_FOR_FIELD_IN_OBJECT_TYPE:
    case UPDATE_FOR_FIELD_IN_OBJECT_TYPE:
      {
        var _action$payload7 = action.payload,
            _appName9 = _action$payload7.appName,
            _objectTypeIdx3 = _action$payload7.objectTypeIdx,
            fieldIdx = _action$payload7.fieldIdx,
            _update = _objectWithoutProperties(_action$payload7, ['appName', 'objectTypeIdx', 'fieldIdx']);

        if (!_appName9 || _objectTypeIdx3 == null || fieldIdx == null) return state;

        // update testing status
        var _objectTypeToUpdate = {};
        var _status = state[_appName9].objectTypes[_objectTypeIdx3].status;

        if (_status !== objectTypeMappingStatuses.MAPPED) {
          _objectTypeToUpdate.status = objectTypeMappingStatuses.MAPPED;
        }

        return _extends$1({}, state, _defineProperty({}, _appName9, _extends$1({}, state[_appName9], {
          objectTypes: [].concat(_toConsumableArray(state[_appName9].objectTypes.slice(0, _objectTypeIdx3)), [_extends$1({}, state[_appName9].objectTypes[_objectTypeIdx3], _objectTypeToUpdate, {
            fields: [].concat(_toConsumableArray(state[_appName9].objectTypes[_objectTypeIdx3].fields.slice(0, fieldIdx)), [_extends$1({}, state[_appName9].objectTypes[_objectTypeIdx3].fields[fieldIdx], _update)], _toConsumableArray(state[_appName9].objectTypes[_objectTypeIdx3].fields.slice(fieldIdx + 1))),
            hasChanges: true
          })], _toConsumableArray(state[_appName9].objectTypes.slice(_objectTypeIdx3 + 1)))
        })));
      }

    case SAVE_MAPPING_FOR_APP_SUCCESS:
      {
        // TODO: Duplicated!
        var _action$payload$actio = action.payload.actionPayload,
            _appName10 = _action$payload$actio.appName,
            _objectTypeIdx4 = _action$payload$actio.objectTypeIdx;
        // TODO: reset all objectFieldsId to null, shoud do it here ?

        if (!_appName10 || _objectTypeIdx4 == null) return state;
        return _extends$1({}, state, _defineProperty({}, _appName10, _extends$1({}, state[_appName10], {
          objectTypes: [].concat(_toConsumableArray(state[_appName10].objectTypes.slice(0, _objectTypeIdx4)), [_extends$1({}, state[_appName10].objectTypes[_objectTypeIdx4], { hasChanges: false })], _toConsumableArray(state[_appName10].objectTypes.slice(_objectTypeIdx4 + 1)))
        })));
      }

    case DELETE_OBJECT_TYPE_FOR_APP_SUCCESS:
      {
        var _action$payload$actio2 = action.payload.actionPayload,
            _appName11 = _action$payload$actio2.appName,
            applicationObjectTypeName = _action$payload$actio2.applicationObjectTypeName;

        if (!_appName11 || applicationObjectTypeName == null) return state;
        return _extends$1({}, state, _defineProperty({}, _appName11, _extends$1({}, state[_appName11], {
          objectTypes: state[_appName11].objectTypes.filter(function (item) {
            return item.applicationObjectTypeName !== applicationObjectTypeName;
          })
        })));
      }

    default:
      return state;
  }
};

var FETCH_RELATIONS_FOR_APP_REQUEST = 'FETCH_RELATIONS_FOR_APP_REQUEST';
var FETCH_RELATIONS_FOR_APP_SUCCESS = 'FETCH_RELATIONS_FOR_APP_SUCCESS';
var FETCH_RELATIONS_FOR_APP_FAILURE = 'FETCH_RELATIONS_FOR_APP_FAILURE';

var SAVE_RELATIONS_FOR_APP_REQUEST = 'SAVE_RELATIONS_FOR_APP_REQUEST';
var SAVE_RELATIONS_FOR_APP_SUCCESS = 'SAVE_RELATIONS_FOR_APP_SUCCESS';
var SAVE_RELATIONS_FOR_APP_FAILURE = 'SAVE_RELATIONS_FOR_APP_FAILURE';

var isEnum = _objectPie.f;
var _objectToArray = function (isEntries) {
  return function (it) {
    var O = _toIobject(it);
    var keys = _objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!_descriptors || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

// https://github.com/tc39/proposal-object-values-entries

var $values = _objectToArray(false);

_export(_export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

var values = _core.Object.values;

var values$1 = createCommonjsModule(function (module) {
module.exports = { "default": values, __esModule: true };
});

var _Object$values = unwrapExports(values$1);

var initialState$2 = _Object$values(appNames).reduce(function (state, appName) {
  return _extends$1({}, state, _defineProperty({}, appName, { relations: [], isNew: false }));
}, {});

var reducer$2 = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$2;
  var action = arguments[1];

  switch (action.type) {
    case SAVE_RELATIONS_FOR_APP_SUCCESS:
    case FETCH_RELATIONS_FOR_APP_SUCCESS:
      {
        var _action$payload = action.payload,
            appName = _action$payload.actionPayload.appName,
            _action$payload$data = _action$payload.data,
            objectRelationship = _action$payload$data.objectRelationship,
            mapping = _action$payload$data.mapping;

        return _extends$1({}, state, _defineProperty({}, appName, _extends$1({}, state[appName], {
          relations: objectRelationship ? objectRelationship.relationships : mapping.relationships,
          isNew: false
        })));
      }

    case FETCH_RELATIONS_FOR_APP_FAILURE:
      {
        var _action$payload2 = action.payload,
            code = _action$payload2.code,
            _appName = _action$payload2.actionPayload.appName;

        if (code === 404) {
          return _extends$1({}, state, _defineProperty({}, _appName, _extends$1({}, state[_appName], {
            isNew: true
          })));
        }
        return state;
      }

    default:
      return state;
  }
};

var FECTH_RAW_OBJECT_TYPES_REQUEST = 'FECTH_RAW_OBJECT_TYPES_REQUEST';
var FECTH_RAW_OBJECT_TYPES_SUCCESS = 'FECTH_RAW_OBJECT_TYPES_SUCCESS';
var FECTH_RAW_OBJECT_TYPES_FAILURE = 'FECTH_RAW_OBJECT_TYPES_FAILURE';

var reducer$3 = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case FECTH_RAW_OBJECT_TYPES_SUCCESS:
      {
        return action.payload.data;
      }
    default:
      return state;
  }
};

var FECTH_RAW_OBJECT_FIELDS_REQUEST = 'FECTH_RAW_OBJECT_FIELDS_REQUEST';
var FECTH_RAW_OBJECT_FIELDS_SUCCESS = 'FECTH_RAW_OBJECT_FIELDS_SUCCESS';
var FECTH_RAW_OBJECT_FIELDS_FAILURE = 'FECTH_RAW_OBJECT_FIELDS_FAILURE';

var reducer$4 = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case FECTH_RAW_OBJECT_FIELDS_SUCCESS:
      {
        return _extends$1({}, state, _defineProperty({}, action.payload.actionMeta.fieldId, (action.payload.data || []).map(function (item) {
          return {
            label: item,
            value: item
          };
        })));
      }
    default:
      return state;
  }
};

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

var TO_STRING_TAG = _wks('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = _global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
  _iterators[NAME] = _iterators.Array;
}

var ITERATOR$4 = _wks('iterator');

var core_isIterable = _core.isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR$4] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || _iterators.hasOwnProperty(_classof(O));
};

var isIterable = core_isIterable;

var isIterable$1 = createCommonjsModule(function (module) {
module.exports = { "default": isIterable, __esModule: true };
});

unwrapExports(isIterable$1);

var core_getIterator = _core.getIterator = function (it) {
  var iterFn = core_getIteratorMethod(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return _anObject(iterFn.call(it));
};

var getIterator = core_getIterator;

var getIterator$1 = createCommonjsModule(function (module) {
module.exports = { "default": getIterator, __esModule: true };
});

var _getIterator = unwrapExports(getIterator$1);

var slicedToArray = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _isIterable3 = _interopRequireDefault(isIterable$1);



var _getIterator3 = _interopRequireDefault(getIterator$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
});

var _slicedToArray = unwrapExports(slicedToArray);

var initialState$3 = {
  loading: {
    FETCH_TE_OBJECT_TYPES_SETTING: true
  },
  errors: {},
  init: {}
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$3.loading;
  var action = arguments[1];
  var type = action.type;

  var matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);

  // not a *_REQUEST / *_SUCCESS /  *_FAILURE actions, so we ignore them
  if (!matches) return state;

  var _matches = _slicedToArray(matches, 3),
      requestName = _matches[1],
      requestState = _matches[2];

  return _extends$1({}, state, _defineProperty({}, requestName, requestState === 'REQUEST'));
};

var errors = function errors() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$3.errors;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  var matches = /(.*)_(REQUEST|FAILURE)/.exec(type);
  // not a *_REQUEST / *_FAILURE actions, so we ignore them
  if (!matches || !payload) return state;

  var _matches2 = _slicedToArray(matches, 3),
      requestName = _matches2[1],
      requestState = _matches2[2];

  return _extends$1({}, state, _defineProperty({}, requestName, requestState === 'FAILURE' ? action.payload ? _.get(action.payload, 'code', _.get(action, 'meta.responseBody.code', 'error')) : 'error' : ''));
};

var init = function init() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$3.init;
  var action = arguments[1];
  var type = action.type;

  var matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);

  // not a *_REQUEST / *_SUCCESS /  *_FAILURE actions, so we ignore them
  if (!matches) return state;

  var _matches3 = _slicedToArray(matches, 3),
      requestName = _matches3[1],
      requestState = _matches3[2];

  return _extends$1({}, state, _defineProperty({}, requestName, ['SUCCESS', 'FAILURE'].includes(requestState) || state[requestName]));
};

var apiStatus = combineReducers({
  loading: loading,
  errors: errors,
  init: init
});

var _fields, _RESERVATION_SETTINGS, _RESERVATION_SETTINGS2;

var TEMPLATE_TYPE = {
  GENERAL: 'GENERAL',
  SELECT_MODE: 'SELECT_MODE'
};

var EXAM_RESERVATION_MODE_FIELD = 'exam_publish_reservation_mode';

// In fields, appFieldId is key
var RESERVATION_SETTINGS_MAPPING = (_RESERVATION_SETTINGS = {}, _defineProperty(_RESERVATION_SETTINGS, appNames.TE_EXAM, [{
  label: 'General settings',
  templateType: TEMPLATE_TYPE.GENERAL,
  fields: {
    object_type_ext_id: {
      order: 0,
      label: 'TE Exam system type',
      type: 'dropdown',
      optionsSource: 'objectExtTypes',
      loading: 'rawObjectTypesLoading',
      onChange: 'fetchObjectTypeFields',
      required: true
    },
    object_ext_id: {
      order: 1,
      label: 'TE Exam system object',
      type: 'dropdown',
      dependOn: 'object_type_ext_id',
      optionsSource: 'objectTypefields',
      loading: 'objectTypeObjectsLoading',
      required: true
    }
  }
}, {
  label: 'Room booking reservations',
  templateType: TEMPLATE_TYPE.SELECT_MODE,
  showDependOn: 'object_ext_id',
  modeFieldId: 'reservation_mode_ext_id',
  types: {
    object_type_ext_id: {
      label: 'TE Exam system',
      reduxSource: 'reservationSettings',
      required: true,
      requiredMessage: 'TE Exam system type not detected on room booking reservation mode'
    },
    room: {
      label: 'Room',
      reduxSource: 'mapping',
      required: true,
      requiredMessage: 'Room type not detected on room booking reservation mode'
    }
  },
  fields: {
    reservation_mode_ext_id: {
      order: 2,
      label: 'Select reservation mode',
      type: 'dropdown',
      optionsSource: 'situations',
      loading: 'situationsLoading',
      onChange: ['fetchSituationFields', 'fetchSituationTypes'],
      required: true,
      requiredMessage: 'No Room booking reservation mode selected',
      uniqWithFields: [EXAM_RESERVATION_MODE_FIELD],
      uniqWithFieldsMessage: 'Room reservation mode and exam reservation mode can not be the same'
    },
    reference_field_ext_id: {
      order: 3,
      label: 'Room booking ID',
      type: 'dropdown',
      dependOn: 'reservation_mode_ext_id',
      optionsSource: 'situationFields',
      loading: 'situationFieldsLoading',
      required: true,
      requiredMessage: 'Room booking ID not mapped on room booking reservation mode'
    },
    boolean_field_ext_id: {
      order: 4,
      label: 'Is TE Exam room booking',
      type: 'dropdown',
      dependOn: 'reservation_mode_ext_id',
      optionsSource: 'situationFields',
      loading: 'situationFieldsLoading',
      required: true,
      requiredMessage: 'Is TE Exam room booking not mapped on room booking reservation mode'
    },
    room_booking_public_schedule_url: {
      order: 5,
      label: 'Public schedule url',
      type: 'dropdown',
      dependOn: 'reservation_mode_ext_id',
      optionsSource: 'situationFields',
      loading: 'objectTypeObjectsLoading',
      requiredMessage: 'Public Schedule URL not mapped on room booking reservation mode'
    }
  }
}, {
  label: 'Exam reservations',
  templateType: TEMPLATE_TYPE.SELECT_MODE,
  showDependOn: 'object_ext_id',
  modeFieldId: EXAM_RESERVATION_MODE_FIELD,
  types: {
    object_type_ext_id: {
      label: 'TE Exam system',
      reduxSource: 'reservationSettings',
      required: true,
      requiredMessage: 'TE Exam system type not detected on exam reservation mode'
    },
    room: { label: 'Room', reduxSource: 'mapping' },
    professor: { label: 'Professor', reduxSource: 'mapping' },
    coordinator: { label: 'Coordinator', reduxSource: 'mapping' },
    course: { label: 'Course', reduxSource: 'mapping' },
    courseEvent: { label: 'Course event', reduxSource: 'mapping' },
    module: { label: 'Module', reduxSource: 'mapping' },
    coursePart: { label: 'Course part', reduxSource: 'mapping' },
    program: { label: 'Program', reduxSource: 'mapping' },
    studentGroup: { label: 'Student group', reduxSource: 'mapping' },
    costCenter: { label: 'Cost center', reduxSource: 'mapping' },
    department: { label: 'Department', reduxSource: 'mapping' },
    externalCustomer: { label: 'External customer', reduxSource: 'mapping' }
  },
  fields: (_fields = {}, _defineProperty(_fields, EXAM_RESERVATION_MODE_FIELD, {
    order: 6,
    label: 'Select reservation mode',
    type: 'dropdown',
    optionsSource: 'situations',
    loading: 'situationsLoading',
    onChange: ['fetchSituationFields', 'fetchSituationTypes'],
    required: true,
    requiredMessage: 'No Exam reservation mode selected'
  }), _defineProperty(_fields, 'public_schedule_url', {
    order: 7,
    label: 'Public schedule url',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading',
    required: true,
    requiredMessage: 'Public Schedule URL not mapped on exam reservation mode'
  }), _defineProperty(_fields, 'exam_name', {
    order: 8,
    label: 'Exam name',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading',
    required: true,
    requiredMessage: 'Exam name not mapped on exam reservation mode'
  }), _defineProperty(_fields, 'exam_id', {
    order: 9,
    label: 'Exam id',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading',
    required: true,
    requiredMessage: 'Exam id not mapped on exam reservation mode'
  }), _defineProperty(_fields, 'student_information', {
    order: 10,
    label: 'Student information',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading'
  }), _defineProperty(_fields, 'comment_to_scheduler', {
    order: 11,
    label: 'External comment',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading'
  }), _defineProperty(_fields, 'planned_students', {
    order: 12,
    label: 'Planned students',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading'
  }), _defineProperty(_fields, 'allocated_students', {
    order: 13,
    label: 'Allocated students',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading'
  }), _defineProperty(_fields, 'exam_type', {
    order: 14,
    label: 'Exam type',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading'
  }), _defineProperty(_fields, 'exam_status', {
    order: 15,
    label: 'Exam status',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading'
  }), _defineProperty(_fields, 'external_reference', {
    order: 16,
    label: 'External reference',
    type: 'dropdown',
    dependOn: EXAM_RESERVATION_MODE_FIELD,
    optionsSource: 'situationFields',
    loading: 'objectTypeObjectsLoading'
  }), _fields)
}]), _defineProperty(_RESERVATION_SETTINGS, appNames.HOOTDESK, [{
  label: 'General settings',
  templateType: TEMPLATE_TYPE.GENERAL,
  fields: {
    object_type_ext_id: {
      order: 0,
      label: 'TE Hootdesk system type',
      type: 'dropdown',
      optionsSource: 'objectExtTypes',
      loading: 'rawObjectTypesLoading',
      onChange: 'fetchObjectTypeFields',
      required: true
    },
    object_ext_id: {
      order: 1,
      label: 'TE Hootdesk system object',
      type: 'dropdown',
      dependOn: 'object_type_ext_id',
      optionsSource: 'objectTypefields',
      loading: 'objectTypeObjectsLoading',
      required: true
    }
  }
}, {
  templateType: TEMPLATE_TYPE.SELECT_MODE,
  modeFieldId: 'reservation_mode_ext_id',
  fields: {
    // object_type_ext_id: {
    //   order: 0,
    //   label: 'Object type ext id',
    //   type: 'dropdown',
    //   optionsSource: 'objectExtTypes',
    //   loading: 'rawObjectTypesLoading',
    //   onChange: 'fetchObjectTypeFields',
    // },
    // object_ext_id: {
    //   order: 1,
    //   label: 'Object ext id',
    //   type: 'dropdown',
    //   dependOn: 'object_type_ext_id',
    //   optionsSource: 'objectTypefields',
    //   loading: 'objectTypeObjectsLoading',
    // },
    reservation_mode_ext_id: {
      order: 0,
      label: 'Reservation mode ext id',
      type: 'dropdown',
      optionsSource: 'situations',
      loading: 'situationsLoading',
      onChange: ['fetchSituationFields'],
      required: true
    },
    reference_field_ext_id: {
      order: 1,
      label: 'Reference field ext id',
      type: 'dropdown',
      dependOn: 'reservation_mode_ext_id',
      optionsSource: 'situationFields',
      loading: 'situationFieldsLoading',
      required: true
    },
    boolean_field_ext_id: {
      order: 2,
      label: 'Boolean field ext id ',
      type: 'dropdown',
      dependOn: 'reservation_mode_ext_id',
      optionsSource: 'situationFields',
      loading: 'situationFieldsLoading',
      required: true
    }
  }
}]), _RESERVATION_SETTINGS);

var RESERVATION_SETTINGS_ALL_FIELDS = (_RESERVATION_SETTINGS2 = {}, _defineProperty(_RESERVATION_SETTINGS2, appNames.TE_EXAM, RESERVATION_SETTINGS_MAPPING[appNames.TE_EXAM].reduce(function (tot, _ref) {
  var fields = _ref.fields;
  return _extends$1({}, tot, fields);
}, {})), _defineProperty(_RESERVATION_SETTINGS2, appNames.HOOTDESK, RESERVATION_SETTINGS_MAPPING[appNames.HOOTDESK].reduce(function (tot, _ref2) {
  var fields = _ref2.fields;
  return _extends$1({}, tot, fields);
}, {})), _RESERVATION_SETTINGS2);

var EXAM_OBJECT_FIELD_MAP = {
  room: 'room',
  professor: 'professor',
  coordinator: 'coordinator',
  course: 'course',
  courseEvent: 'course_event',
  module: 'module',
  coursePart: 'course_part',
  program: 'program',
  studentGroup: 'student_group',
  costCenter: 'cost_center',
  department: 'department',
  externalCustomer: 'external_customer'
};

var FETCH_RESERVATION_SETTINGS_REQUEST = 'FETCH_RESERVATION_SETTINGS_REQUEST';
var FETCH_RESERVATION_SETTINGS_FAILURE = 'FETCH_RESERVATION_SETTINGS_FAILURE';
var FETCH_RESERVATION_SETTINGS_SUCCESS = 'FETCH_RESERVATION_SETTINGS_SUCCESS';

var FETCH_TEST_RESERVATION_SETTINGS_REQUEST = 'FETCH_TEST_RESERVATION_SETTINGS_REQUEST';
var FETCH_TEST_RESERVATION_SETTINGS_FAILURE = 'FETCH_TEST_RESERVATION_SETTINGS_FAILURE';
var FETCH_TEST_RESERVATION_SETTINGS_SUCCESS = 'FETCH_TEST_RESERVATION_SETTINGS_SUCCESS';

var UPDATE_RESERVATION_SETTINGS_REQUEST = 'UPDATE_RESERVATION_SETTINGS_REQUEST';
var UPDATE_RESERVATION_SETTINGS_FAILURE = 'UPDATE_RESERVATION_SETTINGS_FAILURE';
var UPDATE_RESERVATION_SETTINGS_SUCCESS = 'UPDATE_RESERVATION_SETTINGS_SUCCESS';

var UPDATE_RESERVATION_SETTINGS = 'UPDATE_RESERVATION_SETTINGS';

// import { ReservationSettings } from '../../Models/ReservationSettings.model';

var initialState$4 = {
  payload: [],
  validation: {}
};

var reducer$5 = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$4;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case FETCH_RESERVATION_SETTINGS_SUCCESS:
      var allParamsMapping = get(payload, 'reservationMapping.paramMappings').filter(function (_ref2) {
        var appFieldId = _ref2.appFieldId;
        return !!RESERVATION_SETTINGS_ALL_FIELDS[payload.reservationMapping.appName][appFieldId];
      });
      var reservationSetting = sortBy(allParamsMapping.map(function (_ref3) {
        var appFieldId = _ref3.appFieldId,
            fieldExt = _ref3.fieldExt;
        return { appFieldId: appFieldId, fieldExt: fieldExt };
      }), function (_ref4) {
        var appFieldId = _ref4.appFieldId;
        return RESERVATION_SETTINGS_ALL_FIELDS[payload.reservationMapping.appName][appFieldId].order;
      });
      return _extends$1({}, state, {
        payload: reservationSetting
      });

    case FETCH_RESERVATION_SETTINGS_FAILURE:
      var initialReservationSetting = _Object$keys(RESERVATION_SETTINGS_ALL_FIELDS[payload.actionPayload.appName]).map(function (key) {
        return {
          appFieldId: key,
          fieldExt: null
        };
      });

      return _extends$1({}, state, {
        payload: initialReservationSetting,
        isNew: true
      });

    case FETCH_TEST_RESERVATION_SETTINGS_SUCCESS:
      // Get first error
      var _get = get(payload, 'data.statuslist.status'),
          _get2 = _slicedToArray(_get, 1),
          validation = _get2[0];

      return _extends$1({}, state, {
        validation: validation
      });

    case FETCH_TEST_RESERVATION_SETTINGS_FAILURE:
      return _extends$1({}, state, {
        validation: payload
      });

    case UPDATE_RESERVATION_SETTINGS:
      var appFieldId = payload.appFieldId,
          fieldExt = payload.fieldExt;

      var newSettings = [].concat(_toConsumableArray(state.payload));
      var index = newSettings.findIndex(function (item) {
        return item.appFieldId === appFieldId;
      });
      if (index > -1) {
        newSettings[index] = {
          appFieldId: appFieldId,
          fieldExt: fieldExt
        };
      } else {
        newSettings.push({
          appFieldId: appFieldId,
          fieldExt: fieldExt
        });
      }
      return _extends$1({}, state, {
        payload: newSettings
      });

    case UPDATE_RESERVATION_SETTINGS_SUCCESS:
      return _extends$1({}, state, {
        isNew: false
      });

    default:
      return state;
  }
};

var FETCH_SITUATIONS_REQUEST = 'FETCH_SITUATIONS_REQUEST';
var FETCH_SITUATIONS_SUCCESS = 'FETCH_SITUATIONS_SUCCESS';
var FETCH_SITUATIONS_FAILURE = 'FETCH_SITUATIONS_FAILURE';

var FETCH_SITUATION_FIELD_REQUEST = 'FETCH_SITUATION_FIELD_REQUEST';
var FETCH_SITUATION_FIELD_SUCCESS = 'FETCH_SITUATION_FIELD_SUCCESS';
var FETCH_SITUATION_FIELD_FAILURE = 'FETCH_SITUATION_FIELD_FAILURE';

var FETCH_SITUATION_TYPE_REQUEST = 'FETCH_SITUATION_TYPE_REQUEST';
var FETCH_SITUATION_TYPE_SUCCESS = 'FETCH_SITUATION_TYPE_SUCCESS';
var FETCH_SITUATION_TYPE_FAILURE = 'FETCH_SITUATION_TYPE_FAILURE';

var FETCH_OBJECT_TYPES_REQUEST = 'FETCH_OBJECT_TYPES_REQUEST';
var FETCH_OBJECT_TYPES_SUCCESS = 'FETCH_OBJECT_TYPES_SUCCESS';
var FETCH_OBJECT_TYPES_FAILURE = 'FETCH_OBJECT_TYPES_FAILURE';

var FETCH_OBJECT_TYPE_FIELD_REQUEST = 'FETCH_OBJECT_TYPE_FIELD_REQUEST';
var FETCH_OBJECT_TYPE_FIELD_SUCCESS = 'FETCH_OBJECT_TYPE_FIELD_SUCCESS';
var FETCH_OBJECT_TYPE_FIELD_FAILURE = 'FETCH_OBJECT_TYPE_FIELD_FAILURE';

var initialState$5 = {
  situations: [],
  situationFields: {},
  situationTypes: {},
  objectExtTypes: [],
  objectTypefields: []
};

var correctExtIdType = function correctExtIdType(_ref) {
  var extid = _ref.extid,
      name = _ref.name;
  return {
    value: extid,
    label: name
  };
};

var reducer$6 = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$5;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case FETCH_SITUATIONS_SUCCESS:
      var situations = payload.map(correctExtIdType);
      return _extends$1({}, state, {
        situations: situations
      });

    case FETCH_SITUATION_FIELD_SUCCESS:
      {
        var correctFields = function correctFields(value) {
          return {
            value: value,
            label: value
          };
        };
        var situationFields = payload.map(correctFields);
        return _extends$1({}, state, {
          situationFields: _extends$1({}, state.situationFields, _defineProperty({}, action.value, situationFields))
        });
      }

    case FETCH_SITUATION_TYPE_SUCCESS:
      {
        return _extends$1({}, state, {
          situationTypes: _extends$1({}, state.situationTypes, _defineProperty({}, action.value, payload.type))
        });
      }

    case FETCH_OBJECT_TYPES_SUCCESS:
      var objectExtTypes = payload.map(correctExtIdType);
      return _extends$1({}, state, {
        objectExtTypes: objectExtTypes
      });

    case FETCH_OBJECT_TYPE_FIELD_SUCCESS:
      var correctObjectTypeField = function correctObjectTypeField(props) {
        return {
          value: _.get(props, 'fields.te_extid', props.te_extid),
          label: _.get(props, 'fields.te_extid', _.get(props, 'name', _.get(props, 'te_extid')))
        };
      };
      var objectTypefields = payload.map(correctObjectTypeField);
      return _extends$1({}, state, {
        objectTypefields: objectTypefields
      });

    default:
      return state;
  }
};

var FETCH_OBJECT_FIELDS_REQUEST = 'FETCH_OBJECT_FIELDS_REQUEST';
var FETCH_OBJECT_FIELDS_FAILURE = 'FETCH_OBJECT_FIELDS_FAILURE';
var FETCH_OBJECT_FIELDS_SUCCESS = 'FETCH_OBJECT_FIELDS_SUCCESS';

var FETCH_OBJECT_FIELDS_WITH_RELATED_REQUEST = 'FETCH_OBJECT_FIELDS_WITH_RELATED_REQUEST';
var FETCH_OBJECT_FIELDS_WITH_RELATED_FAILURE = 'FETCH_OBJECT_FIELDS_WITH_RELATED_FAILURE';
var FETCH_OBJECT_FIELDS_WITH_RELATED_SUCCESS = 'FETCH_OBJECT_FIELDS_WITH_RELATED_SUCCESS';

var initialState$6 = {
  objects: [],
  fields: {},
  relatedExtIds: {}
};

var objectGetter = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$6;
  var action = arguments[1];

  switch (action.type) {
    case FETCH_OBJECT_FIELDS_WITH_RELATED_SUCCESS:
    case FETCH_OBJECT_FIELDS_SUCCESS:
      {
        var _action$payload = action.payload,
            response = _action$payload.response,
            fields = _action$payload.actionPayload.fields;

        return _extends$1({}, state, {
          fields: _extends$1({}, state.fields, fields.reduce(function (allFields, field, fieldIndex) {
            if (!response[fieldIndex]) return _extends$1({}, allFields);
            return _extends$1({}, allFields, _defineProperty({}, field, response[fieldIndex].data.map(function (_ref) {
              var fields = _ref.fields;
              return fields;
            })));
          }, {})),
          relatedExtIds: _extends$1({}, state.relatedExtIds, fields.reduce(function (allFields, field, fieldIndex) {
            if (!response[fieldIndex]) return _extends$1({}, allFields);
            return _extends$1({}, allFields, _defineProperty({}, field, response[fieldIndex].data.reduce(function (tot, _ref2) {
              var te_extid = _ref2.fields.te_extid,
                  related = _ref2.related;

              if (!isEmpty(related)) {
                tot[te_extid] = related;
              }
              return tot;
            }, {})));
          }, {}))
        });
      }
    default:
      return _extends$1({}, state);
  }
});

var rootReducer = combineReducers({
  apiStatus: apiStatus,
  connectionSettings: reducer,
  mapping: reducer$1,
  relations: reducer$2,
  reservationSettings: reducer$5,
  reservationMapping: reducer$6,
  rawObjectTypes: reducer$3,
  rawObjectFields: reducer$4,
  objectGetter: objectGetter
});

var configureStore = function configureStore() {
  var initialState = {};
  var enhancers = [];
  var middleware = [thunk];

  if (process.env.NODE_ENV === 'development') {
    var devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension());
    }
  }

  var composedEnhancers = compose.apply(undefined, [applyMiddleware.apply(undefined, middleware)].concat(enhancers));

  var store = createStore(rootReducer, initialState, composedEnhancers);
  return store;
};

var _anInstance = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

var _forOf = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
  var f = _ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES = _wks('species');
var _speciesConstructor = function (O, D) {
  var C = _anObject(O).constructor;
  var S;
  return C === undefined || (S = _anObject(C)[SPECIES]) == undefined ? D : _aFunction(S);
};

// fast apply, http://jsperf.lnkit.com/fast-apply/5
var _invoke = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

var process$1 = _global.process;
var setTask = _global.setImmediate;
var clearTask = _global.clearImmediate;
var MessageChannel = _global.MessageChannel;
var Dispatch = _global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (_cof(process$1) == 'process') {
    defer = function (id) {
      process$1.nextTick(_ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(_ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = _ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
    defer = function (id) {
      _global.postMessage(id + '', '*');
    };
    _global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in _domCreate('script')) {
    defer = function (id) {
      _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
        _html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(_ctx(run, id, 1), 0);
    };
  }
}
var _task = {
  set: setTask,
  clear: clearTask
};

var macrotask = _task.set;
var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
var process$2 = _global.process;
var Promise$1 = _global.Promise;
var isNode = _cof(process$2) == 'process';

var _microtask = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process$2.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise$1.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(_global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

// 25.4.1.5 NewPromiseCapability(C)


function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = _aFunction(resolve);
  this.reject = _aFunction(reject);
}

var f$3 = function (C) {
  return new PromiseCapability(C);
};

var _newPromiseCapability = {
	f: f$3
};

var _perform = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

var navigator$1 = _global.navigator;

var _userAgent = navigator$1 && navigator$1.userAgent || '';

var _promiseResolve = function (C, x) {
  _anObject(C);
  if (_isObject(x) && x.constructor === C) return x;
  var promiseCapability = _newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var _redefineAll = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else _hide(target, key, src[key]);
  } return target;
};

var SPECIES$1 = _wks('species');

var _setSpecies = function (KEY) {
  var C = typeof _core[KEY] == 'function' ? _core[KEY] : _global[KEY];
  if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
    configurable: true,
    get: function () { return this; }
  });
};

var task = _task.set;
var microtask = _microtask();




var PROMISE = 'Promise';
var TypeError$1 = _global.TypeError;
var process$3 = _global.process;
var versions = process$3 && process$3.versions;
var v8 = versions && versions.v8 || '';
var $Promise = _global[PROMISE];
var isNode$1 = _classof(process$3) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && _userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain$$1 = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain$$1.length > i) run(chain$$1[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(_global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = _perform(function () {
        if (isNode$1) {
          process$3.emit('unhandledRejection', value, promise);
        } else if (handler = _global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = _global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(_global, function () {
    var handler;
    if (isNode$1) {
      process$3.emit('rejectionHandled', promise);
    } else if (handler = _global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    _anInstance(this, $Promise, PROMISE, '_h');
    _aFunction(executor);
    Internal.call(this);
    try {
      executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = _redefineAll($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode$1 ? process$3.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = _ctx($resolve, promise, 1);
    this.reject = _ctx($reject, promise, 1);
  };
  _newPromiseCapability.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Promise: $Promise });
_setToStringTag($Promise, PROMISE);
_setSpecies(PROMISE);
Wrapper = _core[PROMISE];

// statics
_export(_export.S + _export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
_export(_export.S + _export.F * (_library || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return _promiseResolve(_library && this === Wrapper ? $Promise : this, x);
  }
});
_export(_export.S + _export.F * !(USE_NATIVE && _iterDetect(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = _perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      _forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = _perform(function () {
      _forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

_export(_export.P + _export.R, 'Promise', { 'finally': function (onFinally) {
  var C = _speciesConstructor(this, _core.Promise || _global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return _promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return _promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

// https://github.com/tc39/proposal-promise-try




_export(_export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = _newPromiseCapability.f(this);
  var result = _perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

var promise = _core.Promise;

var promise$1 = createCommonjsModule(function (module) {
module.exports = { "default": promise, __esModule: true };
});

var _Promise = unwrapExports(promise$1);

var runtime = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = module.exports;

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);
});

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

var runtimeModule = runtime;

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

var regenerator = runtimeModule;

var asyncToGenerator = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _promise2 = _interopRequireDefault(promise$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

var _this = undefined;

var MAX_RETRY_TIMES = 3;

// Singleton to hold API status
var allApis = {};
var baseUrl = void 0;
var accessToken = void 0;

var setBaseUrl = function setBaseUrl(url) {
  baseUrl = url;
};

var setAccessToken = function setAccessToken(token) {
  accessToken = token;
};

/**
 * @function prepareOption
 * @description wrapper function to axios option object
 * @param {String} method request HTTP method
 * @param {String} params params to pass in request
 * @param {Bool} requiresAuth whehter bearer token is required
 * @param {Obj} headers additional headers to be sent
 * @returns {String}
 */
var prepareOption = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(method, params, requiresAuth, headers, additionalOptions) {
    var option;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            option = _extends$1({
              method: method,
              headers: _extends$1({
                'Access-Control-Allow-Origin': '*'
              }, headers),
              body: {}
            }, additionalOptions);


            if (requiresAuth) {
              option.headers = _extends$1({
                'Access-Control-Allow-Origin': '*'
              }, headers);
              if (accessToken) {
                option.headers.Authorization = 'Bearer ' + accessToken;
              }
            }

            if (params) {
              if (method === 'GET') {
                option.params = _extends$1({}, params);
              } else {
                option.data = _extends$1({}, params);
              }
            }
            return _context.abrupt('return', option);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function prepareOption(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * @function doDispatch
 * @description wrapper function around dispatch thunk action
 * @param {String} endpoint route to be called
 * @returns {String}
 */
function doDispatch(flow, params, data) {
  var success = flow.success,
      dispatch = flow.dispatch,
      actionPayload = flow.actionPayload;

  if (typeof success === 'function') {
    dispatch(success(_extends$1({}, data, { actionMeta: _extends$1({}, params), actionPayload: actionPayload || null }), params));
  }
}

/**
 * @function getAPIUrl
 * @description returns URL for TE Preferences API depending on environment
 * @param {String} endpoint route to be called
 * @returns {String}
 */
var getAPIUrl = function getAPIUrl(endpoint) {
  if (endpoint.search('http://') > -1 || endpoint.search('https://') > -1) {
    return endpoint;
  }
  var apiUrl = baseUrl;
  return '' + apiUrl + endpoint;
};

/**
 * @function refreshToken
 * @description Return a refreshed access token
 * @returns {void}
 */
var refreshToken = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function refreshToken() {
    return _ref2.apply(this, arguments);
  };
}();

function createThunkAction(_ref3) {
  var method = _ref3.method,
      flow = _ref3.flow,
      endpoint = _ref3.endpoint,
      _ref3$absoluteUrl = _ref3.absoluteUrl,
      absoluteUrl = _ref3$absoluteUrl === undefined ? false : _ref3$absoluteUrl,
      params = _ref3.params,
      _ref3$actionPayload = _ref3.actionPayload,
      actionPayload = _ref3$actionPayload === undefined ? {} : _ref3$actionPayload,
      _ref3$requiresAuth = _ref3.requiresAuth,
      requiresAuth = _ref3$requiresAuth === undefined ? true : _ref3$requiresAuth,
      headers = _ref3.headers,
      _ref3$successNotifica = _ref3.successNotification,
      successNotification = _ref3$successNotifica === undefined ? null : _ref3$successNotifica,
      additionalOptions = _ref3.additionalOptions;
  var CancelToken = axios.CancelToken;

  if (allApis[endpoint]) {
    allApis[endpoint].inprogress = true;
  } else {
    allApis[endpoint] = {
      inprogress: true
    };
  }

  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(dispatch, getState) {
      var apiUrl, fullUrl, option, request, failure, onSuccess, retryCounter, doFetching;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              apiUrl = getAPIUrl(endpoint);
              fullUrl = !absoluteUrl ? apiUrl : endpoint;
              _context3.next = 4;
              return prepareOption(method, params, requiresAuth, headers, additionalOptions);

            case 4:
              option = _context3.sent;
              request = flow.request, failure = flow.failure;

              if (typeof request === 'function') {
                dispatch(request(params));
              }
              if (typeof allApis[endpoint].cancel === 'function' && allApis[endpoint].inprogress) {
                allApis[endpoint].cancel('DUPLICATED_CANCELLED');
                allApis[endpoint].inprogress = false;
              }
              option.cancelToken = new CancelToken(function (c) {
                allApis[endpoint].cancel = c;
              });

              onSuccess = function onSuccess(response) {
                allApis[endpoint].inprogress = false;
                doDispatch(_extends$1({}, flow, { dispatch: dispatch, getState: getState, actionPayload: actionPayload }), params, response.data);
                if (successNotification) {
                  notification.success({
                    message: 'Operation completed',
                    description: successNotification
                  });
                }
              };

              retryCounter = 0;

              doFetching = function doFetching(fullUrl, option) {
                return axios(fullUrl, option).then(function (response) {
                  retryCounter = 0;
                  onSuccess(response);
                  return response.data;
                }).catch(function (error) {
                  allApis[endpoint].inprogress = false;
                  var response = error.response;

                  // If call was unauthorized, retry with token

                  if (error.message === 'UNAUTHORIZED_CANCELLED') {
                    allApis[endpoint].recall = function () {
                      if (accessToken) {
                        option.headers.Authorization = 'Bearer ' + accessToken;
                      }
                      option.cancelToken = new CancelToken(function (c) {
                        allApis[endpoint].cancel = c;
                      });
                      return axios(fullUrl, option).then(function (newResponse) {
                        doDispatch(_extends$1({}, flow, { dispatch: dispatch, getState: getState, actionPayload: actionPayload }), params, newResponse.data);
                      });
                    };
                  }

                  // Display failure message
                  if (successNotification) {
                    notification.error({
                      message: 'Operation failed',
                      description: get(error, 'response.data.message', error.toString())
                    });
                  }

                  // If no response, return
                  if (!response) return null;

                  // If 5xx
                  if (response.status >= 500 && option.retryWhenFail) {
                    retryCounter += 1;
                    if (retryCounter < MAX_RETRY_TIMES) {
                      return doFetching(fullUrl, option);
                    }
                  }

                  // Process data
                  var data = response.data;

                  if (requiresAuth && data.code === 401) {
                    _Object$keys(allApis).forEach(function (key) {
                      var item = allApis[key];
                      if (typeof item.cancel === 'function' && item.inprogress) {
                        item.cancel('UNAUTHORIZED_CANCELLED');
                      }
                      return item;
                    });
                    return refreshToken();
                    // @todo should recall after token's been refreshed
                  }

                  if (typeof failure === 'function') {
                    dispatch(failure(_extends$1({}, data, { actionPayload: actionPayload }), option.params));
                  }
                  return null;
                });
              };

              return _context3.abrupt('return', doFetching(fullUrl, option));

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function thunk$$1(_x6, _x7) {
      return _ref4.apply(this, arguments);
    }

    return thunk$$1;
  }();
}

/**
 * @function createThunkActions
 * @description wrapper function around dispatch thunk action
 * @param {Array} actions array of action which is used in createThunkAction
 * @param {Object} flow Redux flow
 */
function createThunkActions(_ref5) {
  var actions = _ref5.actions,
      flow = _ref5.flow;
  var success = flow.success,
      failure = flow.failure,
      request = flow.request;

  return function thunk$$1(dispatch, getState) {
    if (typeof request === 'function') {
      dispatch(request());
    }
    return _Promise.all(actions.map(function (item) {
      var method = item.method,
          endpoint = item.endpoint,
          params = item.params,
          isSafe = item.isSafe,
          headers = item.headers,
          successNotification = item.successNotification,
          additionalOptions = item.additionalOptions;

      return createThunkAction({
        method: method,
        flow: {},
        endpoint: endpoint,
        params: params,
        requiresAuth: !isSafe,
        headers: headers,
        successNotification: successNotification,
        additionalOptions: additionalOptions
      })();
    })).then(function (results) {
      if (typeof success === 'function') {
        doDispatch(_extends$1({}, flow, { dispatch: dispatch, getState: getState }), {}, {
          response: results
        });
      }
    }, function (errors) {
      if (typeof failure === 'function') {
        doDispatch(_extends$1({}, flow, { dispatch: dispatch, getState: getState }), {}, {
          errors: errors
        });
      }
    });
  };
}

var asyncAction = {
  GET: function GET(_ref6) {
    var flow = _ref6.flow,
        endpoint = _ref6.endpoint,
        params = _ref6.params,
        actionPayload = _ref6.actionPayload,
        _ref6$requiresAuth = _ref6.requiresAuth,
        requiresAuth = _ref6$requiresAuth === undefined ? true : _ref6$requiresAuth,
        headers = _ref6.headers,
        successNotification = _ref6.successNotification,
        additionalOptions = _ref6.additionalOptions;
    return createThunkAction({
      method: 'GET',
      flow: flow,
      endpoint: endpoint,
      params: params,
      actionPayload: actionPayload,
      requiresAuth: requiresAuth,
      headers: headers,
      successNotification: successNotification,
      additionalOptions: additionalOptions
    });
  },
  PUT: function PUT(_ref7) {
    var flow = _ref7.flow,
        endpoint = _ref7.endpoint,
        params = _ref7.params,
        actionPayload = _ref7.actionPayload,
        _ref7$requiresAuth = _ref7.requiresAuth,
        requiresAuth = _ref7$requiresAuth === undefined ? true : _ref7$requiresAuth,
        headers = _ref7.headers,
        successNotification = _ref7.successNotification,
        additionalOptions = _ref7.additionalOptions;
    return createThunkAction({
      method: 'PUT',
      flow: flow,
      endpoint: endpoint,
      params: params,
      actionPayload: actionPayload,
      requiresAuth: requiresAuth,
      headers: headers,
      successNotification: successNotification,
      additionalOptions: additionalOptions
    });
  },
  PATCH: function PATCH(_ref8) {
    var flow = _ref8.flow,
        endpoint = _ref8.endpoint,
        params = _ref8.params,
        actionPayload = _ref8.actionPayload,
        _ref8$requiresAuth = _ref8.requiresAuth,
        requiresAuth = _ref8$requiresAuth === undefined ? true : _ref8$requiresAuth,
        headers = _ref8.headers,
        successNotification = _ref8.successNotification,
        additionalOptions = _ref8.additionalOptions;
    return createThunkAction({
      method: 'PATCH',
      flow: flow,
      endpoint: endpoint,
      params: params,
      actionPayload: actionPayload,
      requiresAuth: requiresAuth,
      headers: headers,
      successNotification: successNotification,
      additionalOptions: additionalOptions
    });
  },
  POST: function POST(_ref9) {
    var flow = _ref9.flow,
        endpoint = _ref9.endpoint,
        params = _ref9.params,
        actionPayload = _ref9.actionPayload,
        _ref9$requiresAuth = _ref9.requiresAuth,
        requiresAuth = _ref9$requiresAuth === undefined ? true : _ref9$requiresAuth,
        headers = _ref9.headers,
        successNotification = _ref9.successNotification,
        additionalOptions = _ref9.additionalOptions;
    return createThunkAction({
      method: 'POST',
      flow: flow,
      endpoint: endpoint,
      params: params,
      actionPayload: actionPayload,
      requiresAuth: requiresAuth,
      headers: headers,
      successNotification: successNotification,
      additionalOptions: additionalOptions
    });
  },
  DELETE: function DELETE(_ref10) {
    var flow = _ref10.flow,
        endpoint = _ref10.endpoint,
        params = _ref10.params,
        actionPayload = _ref10.actionPayload,
        _ref10$requiresAuth = _ref10.requiresAuth,
        requiresAuth = _ref10$requiresAuth === undefined ? true : _ref10$requiresAuth,
        headers = _ref10.headers,
        successNotification = _ref10.successNotification,
        additionalOptions = _ref10.additionalOptions;
    return createThunkAction({
      method: 'DELETE',
      flow: flow,
      endpoint: endpoint,
      params: params,
      actionPayload: actionPayload,
      requiresAuth: requiresAuth,
      headers: headers,
      successNotification: successNotification,
      additionalOptions: additionalOptions
    });
  }
};

var fetchConnectionSettingsFlow = {
  request: function request() {
    return { type: FETCH_CONNECTION_SETTINGS_REQUEST };
  },
  success: function success(response) {
    return { type: FETCH_CONNECTION_SETTINGS_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: FETCH_CONNECTION_SETTINGS_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchConnectionSettings = function fetchConnectionSettings(_ref) {
  var organizationId = _ref.organizationId;
  return asyncAction.GET({
    flow: fetchConnectionSettingsFlow,
    endpoint: 'connection-setting/' + organizationId,
    params: {
      decrypt: true
    },
    requiresAuth: true
  });
};

var updateConnectionSettingsFlow = {
  request: function request() {
    return { type: UPDATE_CONNECTION_SETTINGS_REQUEST };
  },
  success: function success(response) {
    return { type: UPDATE_CONNECTION_SETTINGS_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: UPDATE_CONNECTION_SETTINGS_FAILURE, payload: _extends$1({}, err) };
  }
};

var updateConnectionSettings = function updateConnectionSettings(_ref2) {
  var organizationId = _ref2.organizationId,
      params = _ref2.params,
      isNew = _ref2.isNew;

  if (isNew) {
    return asyncAction.POST({
      flow: updateConnectionSettingsFlow,
      endpoint: 'connection-setting',
      successNotification: true,
      params: _extends$1({}, params, { organizationId: organizationId })
    });
  }
  return asyncAction.PUT({
    flow: updateConnectionSettingsFlow,
    endpoint: 'connection-setting/' + organizationId,
    successNotification: true,
    params: _extends$1({}, params, { organizationId: organizationId })
  });
};

var connectionSettingsSelector = createSelector(function (state) {
  return state.connectionSettings;
}, function (connectionSettings) {
  return connectionSettings;
});

var createLoadingSelector = function createLoadingSelector(actions) {
  return function (state) {
    return (
      // returns true only when all actions are finished loading
      _(actions).some(function (action) {
        return _.get(state, 'apiStatus.loading.' + action);
      })
    );
  };
};

var createInitSelector = function createInitSelector(actions) {
  return function (state) {
    return (
      // returns true only when all actions are finished loading
      actions.every(function (action) {
        return state.apiStatus.init[action];
      })
    );
  };
};

var _TEX_LANGUAGES;

var LANG_CODE = {
  Danish: 'da',
  Dutch: 'nl',
  English: 'en',
  Finnish: 'fi',
  German: 'de',
  Norwegian: 'nb',
  Swedish: 'sv'
};

// Languages supported in TE Exam
var TEX_LANGUAGES = (_TEX_LANGUAGES = {}, _defineProperty(_TEX_LANGUAGES, LANG_CODE.English, 'English'), _defineProperty(_TEX_LANGUAGES, LANG_CODE.Swedish, 'Svenska'), _defineProperty(_TEX_LANGUAGES, LANG_CODE.Norwegian, 'Norsk'), _TEX_LANGUAGES);

var DEFAULT_LANG = LANG_CODE.English;

/* eslint-disable react/jsx-props-no-spreading */

var TE18inProvider = function TE18inProvider(_ref) {
  var children = _ref.children,
      lang = _ref.lang,
      translateMessage = _ref.translateMessage;
  return React.createElement(
    IntlProvider,
    { locale: lang, messages: translateMessage[lang] },
    children
  );
};

TE18inProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,
  lang: PropTypes.string,
  translateMessage: PropTypes.objectOf(PropTypes.any).isRequired
};

TE18inProvider.defaultProps = {
  lang: DEFAULT_LANG
};

/* eslint-disable import/no-extraneous-dependencies */

var TE18inProvider$1 = TE18inProvider;

/* eslint-disable import/no-extraneous-dependencies */

var messages = defineMessages({});

/* eslint-disable import/no-extraneous-dependencies */

var messages$1 = defineMessages({
  configureIntegrationSettings: {
    id: 'common.label.configureIntegrationSettings',
    defaultMessage: 'Configure the integration settings for communicating with TE Server'
  },
  baseUrl: {
    id: 'common.label.baseUrl',
    defaultMessage: 'Base URL'
  },
  baseUrlDesc: {
    id: 'common.label.baseUrlDesc',
    defaultMessage: 'The URL TE Exam should use to connect to the TimeEdit server'
  },
  baseUrlRequired: {
    id: 'common.label.baseUrlRequired',
    defaultMessage: 'Base URL is required'
  },
  username: {
    id: 'common.label.username',
    defaultMessage: 'Username'
  },
  usernameDesc: {
    id: 'common.label.usernameDesc',
    defaultMessage: 'The username TE Exam should use to authenticate with the TimeEdit server'
  },
  usernameRequired: {
    id: 'common.label.usernameRequired',
    defaultMessage: 'Username is required'
  },
  password: {
    id: 'common.label.password',
    defaultMessage: 'Password'
  },
  passwordDesc: {
    id: 'common.label.passwordDesc',
    defaultMessage: 'The password TE Exam should use to authenticate with the TimeEdit server'
  },
  passwordRequired: {
    id: 'common.label.passwordRequired',
    defaultMessage: 'Password is required'
  },
  certificate: {
    id: 'common.label.certificate',
    defaultMessage: 'Certificate key'
  },
  certificateDesc: {
    id: 'common.label.certificateDesc',
    defaultMessage: 'The certificate key TE Exam should use to authenticate with the TimeEdit server'
  },
  certificateRequired: {
    id: 'common.label.certificateRequired',
    defaultMessage: 'Certificate key is required'
  },
  proceedWithCaution: {
    id: 'common.label.proceedWithCaution',
    defaultMessage: 'Editing properties here can break your connection with the TimeEdit server. Proceed with caution'
  },
  saveChanges: {
    id: 'common.label.saveChanges',
    defaultMessage: 'Save changes'
  }
});

var message = {
  button: messages,
  label: messages$1
};

// CONSTANTS
var IntegrationSettings = function IntegrationSettings(_ref) {
  var organizationId = _ref.organizationId,
      accessToken = _ref.accessToken,
      form = _ref.form,
      intl = _ref.intl;

  var dispatch = useDispatch();
  var getFieldDecorator = form.getFieldDecorator,
      validateFieldsAndScroll = form.validateFieldsAndScroll,
      setFieldsValue = form.setFieldsValue;


  var connectionSettings = useSelector(connectionSettingsSelector);
  var connectionSettingsLoading = useSelector(createLoadingSelector(['FETCH_CONNECTION_SETTINGS']));
  var connectionSettingsSaving = useSelector(createLoadingSelector(['UPDATE_CONNECTION_SETTINGS']));

  var onSubmitHandle = function onSubmitHandle(e) {
    e.preventDefault();
    validateFieldsAndScroll(function (err, values) {
      if (!err) {
        dispatch(updateConnectionSettings({ organizationId: organizationId, params: values, isNew: connectionSettings.isNew }));
      }
    });
  };

  useEffect(function () {
    dispatch(fetchConnectionSettings({ organizationId: organizationId }));
  }, []);

  useEffect(function () {
    if (connectionSettings && !connectionSettingsLoading) {
      var baseUrl = connectionSettings.baseUrl,
          username = connectionSettings.username,
          password = connectionSettings.password,
          certificateKey = connectionSettings.certificateKey;

      setFieldsValue({
        baseUrl: baseUrl, username: username, password: password, certificateKey: certificateKey
      });
    }
  }, [connectionSettingsLoading]);

  return React.createElement(
    React.Fragment,
    null,
    React.createElement(Alert, {
      style: { marginBottom: '2rem' },
      message: 'Danger zone',
      description: intl.formatMessage(message.label.proceedWithCaution),
      type: 'error'
    }),
    React.createElement(
      Form,
      { onSubmit: onSubmitHandle },
      React.createElement(List, {
        header: intl.formatMessage(message.label.configureIntegrationSettings),
        dataSource: [{
          title: intl.formatMessage(message.label.baseUrl),
          description: intl.formatMessage(message.label.baseUrlDesc),
          key: 'baseUrl',
          type: 'text',
          rules: [{
            required: true,
            message: intl.formatMessage(message.label.baseUrlRequired)
          }]
        }, {
          title: intl.formatMessage(message.label.username),
          description: intl.formatMessage(message.label.usernameDesc),
          key: 'username',
          rules: [{
            required: true,
            message: intl.formatMessage(message.label.usernameRequired)
          }]
        }, {
          title: intl.formatMessage(message.label.password),
          description: intl.formatMessage(message.label.passwordDesc),
          key: 'password',
          type: 'password',
          rules: [{
            required: true,
            message: intl.formatMessage(message.label.passwordRequired)
          }]
        }, {
          title: intl.formatMessage(message.label.certificate),
          description: intl.formatMessage(message.label.certificateDesc),
          key: 'certificateKey',
          type: 'text',
          rules: [{
            required: true,
            message: intl.formatMessage(message.label.certificateRequired)
          }]
        }],
        renderItem: function renderItem(item) {
          return React.createElement(
            List.Item,
            null,
            React.createElement(List.Item.Meta, { title: item.title, description: item.description }),
            React.createElement(
              Form.Item,
              null,
              getFieldDecorator(item.key, {
                rules: item.rules
              })(React.createElement(Input, {
                style: { maxWidth: '60rem', width: '60rem' },
                type: item.type,
                disabled: connectionSettingsLoading || connectionSettingsSaving,
                suffix: connectionSettingsLoading ? React.createElement(Icon, { type: 'loading' }) : null
              }))
            )
          );
        }
      }),
      React.createElement(
        Row,
        { style: { marginTop: '2rem' } },
        React.createElement(
          Col,
          { span: 4 },
          React.createElement(
            Button,
            { htmlType: 'submit', type: 'primary', loading: connectionSettingsSaving },
            intl.formatMessage(message.label.saveChanges)
          )
        )
      )
    )
  );
};

IntegrationSettings.propTypes = {
  form: PropTypes.object,
  intl: PropTypes.object,
  accessToken: PropTypes.string,
  organizationId: PropTypes.string
};

IntegrationSettings.defaultProps = {
  form: {},
  integrationSettings: null,
  accessToken: null,
  organizationId: null
};

var _ConnectionSettings = Form.create({ name: 'FormIntegrationSettings' })(injectIntl(IntegrationSettings));

var moveElementInArray = function moveElementInArray(array, from, to) {
  var clonedArray = _Object$assign([], array);
  var f = clonedArray.splice(from, 1)[0];
  clonedArray.splice(to, 0, f);
  return clonedArray;
};

var createMappingForAppFlow = {
  request: function request() {
    return { type: CREATE_MAPPING_FOR_APP_REQUEST };
  },
  success: function success(response) {
    return { type: CREATE_MAPPING_FOR_APP_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: CREATE_MAPPING_FOR_APP_FAILURE, payload: _extends$1({}, err) };
  }
};

var createMappingForApp = function createMappingForApp(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId;

  var defaultAppMapping = createNewApplicationTemplateMapping(appName);

  var errors = defaultAppMapping.errors,
      objectTypes = defaultAppMapping.objectTypes,
      rest = _objectWithoutProperties(defaultAppMapping, ['errors', 'objectTypes']);

  return asyncAction.POST({
    flow: createMappingForAppFlow,
    endpoint: 'service/' + appName + '/mapping/',
    params: _extends$1({}, rest, {
      appName: appName,
      organizationId: organizationId
    }),
    actionPayload: {
      appName: appName
    }
  });
};
var fetchMappingForAppFlow = {
  request: function request() {
    return { type: FETCH_MAPPING_FOR_APP_REQUEST };
  },
  success: function success(response) {
    return { type: FETCH_MAPPING_FOR_APP_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: FETCH_MAPPING_FOR_APP_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchMappingForApp = function fetchMappingForApp(_ref2) {
  var appName = _ref2.appName,
      organizationId = _ref2.organizationId;
  return asyncAction.GET({
    flow: fetchMappingForAppFlow,
    endpoint: 'service/' + appName + '/mapping/' + organizationId,
    actionPayload: {
      appName: appName
    },
    additionalOptions: {
      retryWhenFail: true
    }
  });
};

var resetMappingForApp = function resetMappingForApp(_ref3) {
  var appName = _ref3.appName;
  return {
    type: RESET_MAPPING_FOR_APP,
    payload: {
      appName: appName
    }
  };
};

var testMappingForObjectType = function testMappingForObjectType(_ref4) {
  var appName = _ref4.appName,
      organizationId = _ref4.organizationId,
      objectTypeIdx = _ref4.objectTypeIdx,
      objectType = _ref4.objectType;

  return asyncAction.POST({
    flow: {
      request: function request() {
        return { type: TEST_MAPPING_FOR_OBJECT_TYPE_REQUEST };
      },
      success: function success(response) {
        return {
          type: TEST_MAPPING_FOR_OBJECT_TYPE_SUCCESS,
          payload: _extends$1({}, response, { appName: appName, objectTypeIdx: objectTypeIdx })
        };
      },
      failure: function failure(err) {
        return { type: TEST_MAPPING_FOR_OBJECT_TYPE_FAILURE, payload: _extends$1({}, err) };
      }
    },
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/object/types/' + encodeURIComponent(objectType.applicationObjectTypeName) + '/test',
    params: {
      options: {
        objectTypeMappingOverride: _extends$1({}, objectType, {
          fields: objectType.fields.filter(function (field) {
            return field.isActive !== false;
          }) })
      }
    }
  });
};

var testMappingForAllObjectTypes = function testMappingForAllObjectTypes(_ref5) {
  var appName = _ref5.appName,
      organizationId = _ref5.organizationId;
  return asyncAction.POST({
    flow: {
      request: function request() {
        return { type: TEST_MAPPING_FOR_ALL_OBJECT_TYPES_REQUEST };
      },
      success: function success(response) {
        return {
          type: TEST_MAPPING_FOR_ALL_OBJECT_TYPES_SUCCESS,
          payload: _extends$1({}, response, { appName: appName })
        };
      },
      failure: function failure(err) {
        return { type: TEST_MAPPING_FOR_ALL_OBJECT_TYPES_FAILURE, payload: _extends$1({}, err, { appName: appName }) };
      }
    },
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/object/test'
  });
};

var addNewObjectType = function addNewObjectType(_ref6) {
  var appName = _ref6.appName,
      objectType = _ref6.objectType;
  return {
    type: ADD_NEW_OBJECT_TYPE,
    payload: {
      appName: appName,
      objectType: objectType
    }
  };
};

var updateLabelForObjectType = function updateLabelForObjectType(_ref7) {
  var appName = _ref7.appName,
      objectTypeIdx = _ref7.objectTypeIdx,
      applicationObjectTypeLabel = _ref7.applicationObjectTypeLabel;
  return {
    type: UPDATE_LABEL_FOR_OBJECT_TYPE,
    payload: {
      appName: appName,
      objectTypeIdx: objectTypeIdx,
      applicationObjectTypeLabel: applicationObjectTypeLabel
    }
  };
};

var updateFieldMappingModeForObjectType = function updateFieldMappingModeForObjectType(_ref8) {
  var appName = _ref8.appName,
      objectTypeIdx = _ref8.objectTypeIdx,
      fieldMappingMode = _ref8.fieldMappingMode;
  return {
    type: UPDATE_FIELD_MAPPING_MODE_FOR_OBJECT_TYPE,
    payload: {
      appName: appName,
      objectTypeIdx: objectTypeIdx,
      fieldMappingMode: fieldMappingMode
    }
  };
};

var updateForObjectType = function updateForObjectType(_ref9) {
  var appName = _ref9.appName,
      objectTypeIdx = _ref9.objectTypeIdx,
      data = _objectWithoutProperties(_ref9, ['appName', 'objectTypeIdx']);

  return {
    type: UPDATE_FOR_OBJECT_TYPE,
    payload: _extends$1({
      appName: appName,
      objectTypeIdx: objectTypeIdx
    }, data)
  };
};
var moveFieldInObjectType = function moveFieldInObjectType(_ref10) {
  var appName = _ref10.appName,
      objectTypeIdx = _ref10.objectTypeIdx,
      fields = _ref10.fields,
      fromIdx = _ref10.fromIdx,
      toIdx = _ref10.toIdx;
  return {
    type: UPDATE_FOR_OBJECT_TYPE,
    payload: {
      appName: appName,
      objectTypeIdx: objectTypeIdx,
      fields: moveElementInArray(fields, fromIdx, toIdx)
    }
  };
};

var updateObjectExtIdForObjectType = function updateObjectExtIdForObjectType(_ref11) {
  var appName = _ref11.appName,
      objectTypeIdx = _ref11.objectTypeIdx,
      objectTypeExtId = _ref11.objectTypeExtId;
  return {
    type: UPDATE_OBJECT_TYPE_EXT_ID_FOR_OBJECT_TYPE,
    payload: {
      appName: appName,
      objectTypeIdx: objectTypeIdx,
      objectTypeExtId: objectTypeExtId
    }
  };
};

var updateLabelForFieldInObjectType = function updateLabelForFieldInObjectType(_ref12) {
  var appName = _ref12.appName,
      objectTypeIdx = _ref12.objectTypeIdx,
      fieldIdx = _ref12.fieldIdx,
      fieldLabel = _ref12.fieldLabel;
  return {
    type: UPDATE_LABEL_FOR_FIELD_IN_OBJECT_TYPE,
    payload: {
      appName: appName,
      objectTypeIdx: objectTypeIdx,
      fieldIdx: fieldIdx,
      fieldLabel: fieldLabel
    }
  };
};

var updateExtIdForFieldInObjectType = function updateExtIdForFieldInObjectType(_ref13) {
  var appName = _ref13.appName,
      objectTypeIdx = _ref13.objectTypeIdx,
      fieldIdx = _ref13.fieldIdx,
      fieldExtId = _ref13.fieldExtId;
  return {
    type: UPDATE_EXTID_FOR_FIELD_IN_OBJECT_TYPE,
    payload: {
      appName: appName,
      objectTypeIdx: objectTypeIdx,
      fieldIdx: fieldIdx,
      fieldExtId: fieldExtId
    }
  };
};

var updateForFieldInObjectType = function updateForFieldInObjectType(_ref14) {
  var appName = _ref14.appName,
      objectTypeIdx = _ref14.objectTypeIdx,
      fieldIdx = _ref14.fieldIdx,
      rest = _objectWithoutProperties(_ref14, ['appName', 'objectTypeIdx', 'fieldIdx']);

  return {
    type: UPDATE_FOR_FIELD_IN_OBJECT_TYPE,
    payload: _extends$1({
      appName: appName,
      objectTypeIdx: objectTypeIdx,
      fieldIdx: fieldIdx
    }, rest)
  };
};
var saveMappingFopAppFlow = {
  request: function request() {
    return { type: SAVE_MAPPING_FOR_APP_REQUEST };
  },
  success: function success(response) {
    return { type: SAVE_MAPPING_FOR_APP_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: SAVE_MAPPING_FOR_APP_FAILURE, payload: _extends$1({}, err) };
  }
};

var saveMappingFopApp = function saveMappingFopApp(_ref15) {
  var appName = _ref15.appName,
      organizationId = _ref15.organizationId,
      objectTypeIdx = _ref15.objectTypeIdx,
      objectType = _ref15.objectType;

  var status = objectType.status,
      hasChanges = objectType.hasChanges,
      fields = objectType.fields,
      labelField = objectType.labelField,
      secondaryLabelField = objectType.secondaryLabelField,
      rest = _objectWithoutProperties(objectType, ['status', 'hasChanges', 'fields', 'labelField', 'secondaryLabelField']);

  var params = _extends$1({
    fields: fields.filter(function (item) {
      return item.isActive || item.isActive === undefined;
    }),
    status: status
  }, rest);
  if (labelField) params.labelField = labelField;
  if (secondaryLabelField) params.secondaryLabelField = secondaryLabelField;

  return asyncAction.PATCH({
    flow: saveMappingFopAppFlow,
    endpoint: 'service/' + appName + '/mapping/' + organizationId + '/object-type/' + encodeURIComponent(objectType.applicationObjectTypeName),
    successNotification: true,
    params: params,
    actionPayload: {
      appName: appName,
      objectTypeIdx: objectTypeIdx
    }
  });
};
var deleteObjectTypeFopAppFlow = {
  request: function request() {
    return { type: DELETE_OBJECT_TYPE_FOR_APP_REQUEST };
  },
  success: function success(response) {
    return { type: DELETE_OBJECT_TYPE_FOR_APP_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: DELETE_OBJECT_TYPE_FOR_APP_FAILURE, payload: _extends$1({}, err) };
  }
};

var deleteObjectTypeFopApp = function deleteObjectTypeFopApp(_ref16) {
  var appName = _ref16.appName,
      organizationId = _ref16.organizationId,
      objectTypeIdx = _ref16.objectTypeIdx,
      objectType = _ref16.objectType;

  var status = objectType.status,
      hasChanges = objectType.hasChanges,
      fields = objectType.fields,
      rest = _objectWithoutProperties(objectType, ['status', 'hasChanges', 'fields']);

  return asyncAction.DELETE({
    flow: deleteObjectTypeFopAppFlow,
    endpoint: 'service/' + appName + '/mapping/' + organizationId + '/object-type/' + encodeURIComponent(objectType.applicationObjectTypeName),
    successNotification: true,
    actionPayload: _extends$1({
      appName: appName,
      objectTypeIdx: objectTypeIdx
    }, rest)
  });
};
var saveExamShouldPublishFlow = {
  request: function request() {
    return { type: SAVE_EXAM_SHOULD_PUBLISH_REQUEST };
  },
  success: function success(response) {
    return { type: SAVE_EXAM_SHOULD_PUBLISH_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: SAVE_EXAM_SHOULD_PUBLISH_FAILURE, payload: _extends$1({}, err) };
  }
};

var saveExamShouldPublish = function saveExamShouldPublish(_ref17) {
  var organizationId = _ref17.organizationId,
      shouldPublish = _ref17.shouldPublish;

  if (isEmpty(shouldPublish)) return null;
  if (!process.env.REACT_APP_TE_EXAM_SERVER_URL) {
    console.error('Missed param "REACT_APP_TE_EXAM_SERVER_URL"');
    return null;
  }

  return asyncAction.PATCH({
    flow: saveExamShouldPublishFlow,
    endpoint: process.env.REACT_APP_TE_EXAM_SERVER_URL + '/api/v1/organizations/' + organizationId + '/mandatory-objects',
    params: {
      data: mapKeys(shouldPublish, function (__, field) {
        return (EXAM_OBJECT_FIELD_MAP[field] || field) + '_should_publish';
      })
    }
  });
};

var appProperties = {
  LABEL: 'LABEL',
  EMAIL: 'EMAIL'
};

var mapActionsToProps = {
  updateLabelForObjectType: updateLabelForObjectType,
  testMappingForObjectType: testMappingForObjectType,
  saveMappingFopApp: saveMappingFopApp,
  deleteObjectTypeFopApp: deleteObjectTypeFopApp
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    objectTypeSaving: createLoadingSelector(['SAVE_MAPPING_FOR_APP'])(state),
    allowDynamicObjectTypes: state.mapping[ownProps.appName].allowDynamicObjectTypes
  };
};

var PanelHeader = function PanelHeader(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      objectTypeIdx = _ref.objectTypeIdx,
      objectType = _ref.objectType,
      objectTypeSaving = _ref.objectTypeSaving,
      updateLabelForObjectType$$1 = _ref.updateLabelForObjectType,
      testMappingForObjectType$$1 = _ref.testMappingForObjectType,
      saveMappingFopApp$$1 = _ref.saveMappingFopApp,
      allowDynamicObjectTypes = _ref.allowDynamicObjectTypes,
      deleteObjectTypeFopApp$$1 = _ref.deleteObjectTypeFopApp,
      onSave = _ref.onSave;

  // Memoized variables
  var _useMemo = useMemo(function () {
    return objectType;
  }, [objectType]),
      applicationObjectTypeName = _useMemo.applicationObjectTypeName,
      applicationObjectTypeLabel = _useMemo.applicationObjectTypeLabel,
      applicationObjectTypeGroup = _useMemo.applicationObjectTypeGroup,
      labelField = _useMemo.labelField,
      secondaryLabelField = _useMemo.secondaryLabelField,
      sampleObjects = _useMemo.sampleObjects,
      status = _useMemo.status;

  var labelFieldsValid = useMemo(
  // If is FREE_MAPPING, return isLabeled field
  function () {
    if (objectType.fieldMappingMode === fieldMappingModes.FREE_MAPPING) {
      return !!objectType.fields.find(function (field) {
        return field.appProperty === appProperties.LABEL;
      });
    }
    return (sampleObjects || []).some(function (obj) {
      return (!labelField || obj[labelField]) && (!secondaryLabelField || obj[secondaryLabelField]);
    });
  }, [objectType, sampleObjects, labelField, secondaryLabelField]);

  var testing = useSelector(createLoadingSelector(['TEST_MAPPING_FOR_OBJECT_TYPE', 'TEST_MAPPING_FOR_ALL_OBJECT_TYPES']));

  var deleting = useSelector(createLoadingSelector(['DELETE_OBJECT_TYPE_FOR_APP']));

  // Callbacks
  var onUpdateLabelCallback = useCallback(function (applicationObjectTypeLabel) {
    return updateLabelForObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, applicationObjectTypeLabel: applicationObjectTypeLabel });
  }, [appName, objectTypeIdx, updateLabelForObjectType$$1]);

  var onTestCallback = useCallback(function (e) {
    e.stopPropagation();
    testMappingForObjectType$$1({ appName: appName, organizationId: organizationId, objectTypeIdx: objectTypeIdx, objectType: objectType });
  }, [objectType, appName, organizationId]);

  var onSaveCallback = useCallback(function (e) {
    e.stopPropagation();
    saveMappingFopApp$$1({ appName: appName, organizationId: organizationId, objectTypeIdx: objectTypeIdx, objectType: objectType }).then(function () {
      if (onSave) {
        onSave({ appName: appName, organizationId: organizationId, objectTypeIdx: objectTypeIdx, objectType: objectType });
      }
    });
  }, [objectType]);

  var onDeleteCallback = useCallback(function (e) {
    e.stopPropagation();
    deleteObjectTypeFopApp$$1({ appName: appName, organizationId: organizationId, objectTypeIdx: objectTypeIdx, objectType: objectType });
  }, [objectType]);

  return React.createElement(
    'div',
    { className: 'panel-header--wrapper' },
    React.createElement(
      'div',
      { className: 'panel-header--label' },
      React.createElement(
        Typography.Paragraph,
        {
          editable: {
            onChange: onUpdateLabelCallback
          }
        },
        applicationObjectTypeLabel || applicationObjectTypeName
      )
    ),
    applicationObjectTypeName && React.createElement(
      'div',
      { className: 'panel-header--application-name' },
      React.createElement(
        'span',
        { className: 'label' },
        'Application property name:'
      ),
      React.createElement(
        'span',
        { className: 'value' },
        applicationObjectTypeName
      )
    ),
    applicationObjectTypeGroup && objectTypeGroupProps[applicationObjectTypeGroup] && React.createElement(
      'div',
      { className: 'panel-header--group' },
      React.createElement(
        Tag,
        null,
        objectTypeGroupProps[applicationObjectTypeGroup].label
      )
    ),
    React.createElement(
      'div',
      { className: 'panel-header--right' },
      React.createElement(
        'div',
        { className: 'panel-header--status' },
        React.createElement(
          Tag,
          { color: objectTypeMappingStatusProps[status].color },
          objectTypeMappingStatusProps[status].label
        )
      ),
      React.createElement(
        'div',
        { className: 'panel-header--actions' },
        React.createElement(
          Button,
          {
            size: 'small',
            loading: testing,
            disabled: status === objectTypeMappingStatuses.NOT_MAPPED,
            onClick: onTestCallback
          },
          'Test'
        ),
        React.createElement(
          Button,
          {
            size: 'small',
            type: 'primary',
            onClick: onSaveCallback,
            loading: objectType.hasChanges && objectTypeSaving,
            disabled: !objectType.hasChanges || objectTypeSaving || !labelFieldsValid
          },
          'Save'
        ),
        allowDynamicObjectTypes ? React.createElement(
          Button,
          {
            size: 'small',
            type: 'danger',
            onClick: onDeleteCallback,
            loading: deleting,
            disabled: objectTypeSaving
          },
          'Delete'
        ) : null
      )
    )
  );
};

PanelHeader.propTypes = {
  appName: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired,
  objectTypeIdx: PropTypes.number.isRequired,
  objectType: PropTypes.object.isRequired,
  objectTypeSaving: PropTypes.bool.isRequired,
  updateLabelForObjectType: PropTypes.func.isRequired,
  testMappingForObjectType: PropTypes.func.isRequired,
  saveMappingFopApp: PropTypes.func.isRequired,
  deleteObjectTypeFopApp: PropTypes.func.isRequired,
  allowDynamicObjectTypes: PropTypes.bool,
  onSave: PropTypes.func.isRequired
};
PanelHeader.defaultProps = {
  allowDynamicObjectTypes: false
};

var PanelHeader$1 = connect(mapStateToProps, mapActionsToProps)(PanelHeader);

var fetchRawObjectFieldsFlow = {
  request: function request() {
    return { type: FECTH_RAW_OBJECT_FIELDS_REQUEST };
  },
  success: function success(response) {
    return { type: FECTH_RAW_OBJECT_FIELDS_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: FECTH_RAW_OBJECT_FIELDS_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchRawObjectFields = function fetchRawObjectFields(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      fieldId = _ref.fieldId;
  return asyncAction.GET({
    flow: fetchRawObjectFieldsFlow,
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/object/types/' + encodeURIComponent(fieldId) + '/fields',
    requiresAuth: true,
    params: {
      fieldId: fieldId
    },
    additionalOptions: {
      retryWhenFail: true
    }
  });
};

var mapStateToProps$1 = function mapStateToProps(state, ownProps) {
  var appName = ownProps.appName;

  return {
    allowedMappingModes: state.mapping[appName].allowedMappingModes,
    allowDynamicObjectTypes: state.mapping[appName].allowDynamicObjectTypes,
    rawObjectTypes: state.rawObjectTypes,
    rawObjectFields: state.rawObjectFields,
    rawObjectTypesLoading: createLoadingSelector(['FECTH_RAW_OBJECT_TYPES'])(state)
  };
};

var mapActionsToProps$1 = {
  updateFieldMappingModeForObjectType: updateFieldMappingModeForObjectType,
  updateObjectExtIdForObjectType: updateObjectExtIdForObjectType,
  fetchRawObjectFields: fetchRawObjectFields
};

var MappingSelector = function MappingSelector(_ref) {
  var appName = _ref.appName,
      objectType = _ref.objectType,
      objectTypeIdx = _ref.objectTypeIdx,
      organizationId = _ref.organizationId,
      allowedMappingModes = _ref.allowedMappingModes,
      rawObjectTypes = _ref.rawObjectTypes,
      rawObjectFields = _ref.rawObjectFields,
      rawObjectTypesLoading = _ref.rawObjectTypesLoading,
      updateFieldMappingModeForObjectType$$1 = _ref.updateFieldMappingModeForObjectType,
      updateObjectExtIdForObjectType$$1 = _ref.updateObjectExtIdForObjectType,
      fetchRawObjectFields$$1 = _ref.fetchRawObjectFields,
      allowDynamicObjectTypes = _ref.allowDynamicObjectTypes;

  // Memoized vars
  var _useMemo = useMemo(function () {
    return objectType;
  }, [objectType]),
      objectTypeExtId = _useMemo.objectTypeExtId,
      fieldMappingMode = _useMemo.fieldMappingMode;

  // Callbacks


  var onUpdateFieldMappingModeForObjectType = useCallback(function (fieldMappingMode) {
    return updateFieldMappingModeForObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, fieldMappingMode: fieldMappingMode });
  }, [appName, objectTypeIdx, updateFieldMappingModeForObjectType$$1]);

  var onUpdateObjectExtIdForObjectType = useCallback(function (objectTypeExtId) {
    // Only call api to get new rawObjectFields
    return updateObjectExtIdForObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, objectTypeExtId: objectTypeExtId });
  }, [appName, objectTypeIdx, !!rawObjectFields[objectTypeExtId], updateObjectExtIdForObjectType$$1]);

  useEffect(function () {
    if (!rawObjectFields[objectTypeExtId]) {
      fetchRawObjectFields$$1({ appName: appName, organizationId: organizationId, fieldId: objectTypeExtId });
    }
  }, [objectTypeExtId]);

  return React.createElement(
    Row,
    { gutter: 16 },
    React.createElement(
      Col,
      { md: 12 },
      React.createElement(
        Form.Item,
        { label: 'Mapping type', className: 'data-model' },
        React.createElement(
          Select,
          {
            value: fieldMappingMode || undefined,
            style: { minWidth: '100%' },
            onChange: onUpdateFieldMappingModeForObjectType
          },
          _Object$keys(fieldMappingModes).filter(function (el) {
            return allowedMappingModes.indexOf(el) > -1;
          }).map(function (el) {
            return React.createElement(
              Select.Option,
              { key: el, value: el },
              fieldMappingModeProps[el].label
            );
          })
        )
      )
    ),
    React.createElement(
      Col,
      { md: 12 },
      React.createElement(
        Form.Item,
        { label: 'Mapped to object type', className: 'data-model' },
        React.createElement(
          Select,
          {
            placeholder: 'No object type selected',
            value: objectTypeExtId || undefined,
            style: { minWidth: '100%' },
            onChange: onUpdateObjectExtIdForObjectType,
            loading: rawObjectTypesLoading,
            disabled: allowDynamicObjectTypes || rawObjectTypesLoading,
            showSearch: true,
            allowClear: true,
            filterOption: function filterOption(query, item) {
              return !query || ('' + item.props.value + item.props.children).toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
          },
          rawObjectTypes && rawObjectTypes.map(function (item) {
            return React.createElement(
              Select.Option,
              { value: item.extid, key: item.extid },
              item.name
            );
          })
        )
      )
    )
  );
};

MappingSelector.propTypes = {
  appName: PropTypes.string.isRequired,
  objectType: PropTypes.object.isRequired,
  objectTypeIdx: PropTypes.number.isRequired,
  allowedMappingModes: PropTypes.array,
  updateFieldMappingModeForObjectType: PropTypes.func.isRequired,
  updateObjectExtIdForObjectType: PropTypes.func.isRequired,
  rawObjectTypes: PropTypes.array.isRequired,
  rawObjectTypesLoading: PropTypes.bool.isRequired,
  organizationId: PropTypes.string.isRequired,
  fetchRawObjectFields: PropTypes.func.isRequired,
  rawObjectFields: PropTypes.object.isRequired,
  allowDynamicObjectTypes: PropTypes.bool
};

MappingSelector.defaultProps = {
  allowedMappingModes: [],
  allowDynamicObjectTypes: false
};

var MappingSelector$1 = connect(mapStateToProps$1, mapActionsToProps$1)(MappingSelector);

var RawFieldMapping = function RawFieldMapping() {
  return React.createElement(Alert, {
    type: 'info',
    message: 'No further action needed',
    description: 'The application will automatically receive the first primary field from TE Server'
  });
};

var mapStateToProps$2 = function mapStateToProps(state, ownProps) {
  var objectTypeExtId = ownProps.objectType.objectTypeExtId;

  return {
    objectTypeFields: state.rawObjectFields[objectTypeExtId] || [],
    rawObjectFieldsLoading: createLoadingSelector(['FECTH_RAW_OBJECT_FIELDS'])(state)
  };
};

var mapActionsToProps$2 = {
  updateForObjectType: updateForObjectType,
  updateLabelForFieldInObjectType: updateLabelForFieldInObjectType,
  updateExtIdForFieldInObjectType: updateExtIdForFieldInObjectType
};

var MappedFieldMapping = function MappedFieldMapping(_ref) {
  var appName = _ref.appName,
      objectType = _ref.objectType,
      objectTypeIdx = _ref.objectTypeIdx,
      objectTypeFields = _ref.objectTypeFields,
      rawObjectFieldsLoading = _ref.rawObjectFieldsLoading,
      updateForObjectType$$1 = _ref.updateForObjectType,
      updateLabelForFieldInObjectType$$1 = _ref.updateLabelForFieldInObjectType,
      updateExtIdForFieldInObjectType$$1 = _ref.updateExtIdForFieldInObjectType;

  var onUpdateLabelForField = useCallback(function (fieldLabel, fieldIdx) {
    return updateLabelForFieldInObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, fieldIdx: fieldIdx, fieldLabel: fieldLabel });
  }, [appName, objectTypeIdx, updateObjectExtIdForObjectType]);

  var onUpdateExtIdForField = useCallback(function (fieldExtId, fieldIdx) {
    return updateExtIdForFieldInObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, fieldIdx: fieldIdx, fieldExtId: fieldExtId });
  }, [appName, objectTypeIdx, updateObjectExtIdForObjectType]);

  var onUpdateLabelForObjectType = useCallback(function (labelField) {
    return updateForObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, labelField: labelField });
  }, [appName, objectTypeIdx]);

  var onUpdateSecondaryLabelForObjectType = useCallback(function (secondaryLabelField) {
    return updateForObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, secondaryLabelField: secondaryLabelField });
  }, [appName, objectTypeIdx]);

  return React.createElement(Table, {
    size: 'middle',
    columns: [{
      title: 'Field key',
      dataIndex: 'appFieldName',
      key: 'appFieldName'
    }, {
      title: 'Label',
      dataIndex: 'fieldLabel',
      key: 'fieldLabel',
      render: function render(fieldLabel, record, fieldIdx) {
        return React.createElement(
          Typography.Paragraph,
          {
            style: { marginBottom: '0' },
            editable: { onChange: function onChange(newLabel) {
                return onUpdateLabelForField(newLabel, fieldIdx);
              } }
          },
          fieldLabel
        );
      }
    }, {
      title: 'Mapping',
      dataIndex: 'fieldExtId',
      key: 'fieldExtId',
      render: function render(fieldExtId, record, fieldIdx) {
        return React.createElement(
          Select,
          {
            size: 'small',
            value: fieldExtId,
            onChange: function onChange(fieldExtId) {
              return onUpdateExtIdForField(fieldExtId, fieldIdx);
            },
            style: { minWidth: '100%' },
            showSearch: true,
            allowClear: true,
            loading: rawObjectFieldsLoading,
            disabled: rawObjectFieldsLoading
          },
          objectTypeFields.map(function (el) {
            return React.createElement(
              Select.Option,
              { value: el.value, key: el.value },
              el.label
            );
          })
        );
      }
    }, {
      title: 'Label',
      dataIndex: 'appFieldName',
      key: 'label',
      render: function render(appFieldName) {
        return React.createElement(Radio, {
          checked: appFieldName === objectType.labelField,
          onChange: function onChange() {
            return onUpdateLabelForObjectType(appFieldName);
          }
        });
      }
    }, {
      title: 'Secondary label',
      dataIndex: 'appFieldName',
      key: 'secondaryLabel',
      render: function render(appFieldName) {
        return React.createElement(Radio, {
          checked: appFieldName === objectType.secondaryLabelField,
          onChange: function onChange() {
            return onUpdateSecondaryLabelForObjectType(appFieldName);
          }
        });
      }
    }],
    dataSource: objectType.fields || [],
    rowKey: 'appFieldName',
    pagination: false
  });
};

MappedFieldMapping.propTypes = {
  appName: PropTypes.string.isRequired,
  objectType: PropTypes.object.isRequired,
  objectTypeIdx: PropTypes.number.isRequired,
  objectTypeFields: PropTypes.array,
  rawObjectFieldsLoading: PropTypes.bool.isRequired,
  updateForObjectType: PropTypes.func.isRequired,
  updateLabelForFieldInObjectType: PropTypes.func.isRequired,
  updateExtIdForFieldInObjectType: PropTypes.func.isRequired
};

MappedFieldMapping.defaultProps = {
  objectTypeFields: []
};

var MappedFieldMapping$1 = connect(mapStateToProps$2, mapActionsToProps$2)(MappedFieldMapping);

/**
 * Create the React Context
 */ const DndContext = createContext({
    dragDropManager: undefined
});

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function invariant(condition, format, ...args) {
    if (isProduction()) {
        if (format === undefined) {
            throw new Error('invariant requires an error message argument');
        }
    }
    if (!condition) {
        let error;
        if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function isProduction() {
    return typeof process !== 'undefined' && process.env['NODE_ENV'] === 'production';
}

// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function get$1(obj, path, defaultValue) {
    return path.split('.').reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null
    , obj);
}
/**
 * drop-in replacement for _.without
 */ function without(items, item) {
    return items.filter((i)=>i !== item
    );
}
/**
 * drop-in replacement for _.isString
 * @param input
 */ function isObject(input) {
    return typeof input === 'object';
}
/**
 * replacement for _.xor
 * @param itemsA
 * @param itemsB
 */ function xor(itemsA, itemsB) {
    const map$$1 = new Map();
    const insertItem = (item)=>{
        map$$1.set(item, map$$1.has(item) ? map$$1.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map$$1.forEach((count, key)=>{
        if (count === 1) {
            result.push(key);
        }
    });
    return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */ function intersection(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1
    );
}

const INIT_COORDS = 'dnd-core/INIT_COORDS';
const BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
const PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
const HOVER = 'dnd-core/HOVER';
const DROP = 'dnd-core/DROP';
const END_DRAG = 'dnd-core/END_DRAG';

function setClientOffset(clientOffset, sourceClientOffset) {
    return {
        type: INIT_COORDS,
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}

const ResetCoordinatesAction = {
    type: INIT_COORDS,
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function createBeginDrag(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource =true , clientOffset , getSourceClientOffset ,  } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch(setClientOffset(clientOffset));
        verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch(ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) {
                throw new Error('getSourceClientOffset must be defined');
            }
            verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch(setClientOffset(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) {
            return undefined;
        }
        verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: BEGIN_DRAG,
            payload: {
                itemType,
                item,
                sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function verifyInvariants(sourceIds, monitor, registry) {
    invariant(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    sourceIds.forEach(function(sourceId) {
        invariant(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
    });
}
function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    invariant(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}
function verifyItemIsObject(item) {
    invariant(isObject(item), 'Item must be an object.');
}
function getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--){
        if (monitor.canDragSource(sourceIds[i])) {
            sourceId = sourceIds[i];
            break;
        }
    }
    return sourceId;
}

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function createDrop(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        verifyInvariants$1(monitor);
        const targetIds = getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: DROP,
                payload: {
                    dropResult: _objectSpread({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function verifyInvariants$1(monitor) {
    invariant(monitor.isDragging(), 'Cannot call drop while not dragging.');
    invariant(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}
function determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    verifyDropResultType(dropResult);
    if (typeof dropResult === 'undefined') {
        dropResult = index === 0 ? {} : monitor.getDropResult();
    }
    return dropResult;
}
function verifyDropResultType(dropResult) {
    invariant(typeof dropResult === 'undefined' || isObject(dropResult), 'Drop result must either be an object or undefined.');
}
function getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}

function createEndDrag(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: END_DRAG
        };
    };
}
function verifyIsDragging(monitor) {
    invariant(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}

function matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) {
        return targetType === null;
    }
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType
    ) : targetType === draggedItemType;
}

function createHover(manager) {
    return function hover(targetIdsArg, { clientOffset  } = {}) {
        verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        checkInvariants(targetIds, monitor, registry);
        hoverAllTargets(targetIds, monitor, registry);
        return {
            type: HOVER,
            payload: {
                targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function verifyTargetIdsIsArray(targetIdsArg) {
    invariant(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}
function checkInvariants(targetIds, monitor, registry) {
    invariant(monitor.isDragging(), 'Cannot call hover while not dragging.');
    invariant(!monitor.didDrop(), 'Cannot call hover after drop.');
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        invariant(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        const target = registry.getTarget(targetId);
        invariant(target, 'Expected targetIds to be registered.');
    }
}
function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!matchesType(targetType, draggedItemType)) {
            targetIds.splice(i, 1);
        }
    }
}
function hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}

function createPublishDragSource(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) {
            return {
                type: PUBLISH_DRAG_SOURCE
            };
        }
        return;
    };
}

function createDragDropActions(manager) {
    return {
        beginDrag: createBeginDrag(manager),
        publishDragSource: createPublishDragSource(manager),
        hover: createHover(manager),
        drop: createDrop(manager),
        endDrag: createEndDrag(manager)
    };
}

class DragDropManagerImpl {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch  } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== 'undefined') {
                    dispatch(action);
                }
            };
        }
        const actions = createDragDropActions(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}

/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */ function subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */ function getSourceClientOffset(state) {
    const { clientOffset , initialClientOffset , initialSourceClientOffset  } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
        return null;
    }
    return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */ function getDifferenceFromInitialOffset(state) {
    const { clientOffset , initialClientOffset  } = state;
    if (!clientOffset || !initialClientOffset) {
        return null;
    }
    return subtract(clientOffset, initialClientOffset);
}

const NONE = [];
const ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */ function areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === NONE) {
        return false;
    }
    if (dirtyIds === ALL || typeof handlerIds === 'undefined') {
        return true;
    }
    const commonIds = intersection(handlerIds, dirtyIds);
    return commonIds.length > 0;
}

class DragDropMonitorImpl {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds  } = options;
        invariant(typeof listener === 'function', 'listener must be a function.');
        invariant(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !areDirty(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) {
                    listener();
                }
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        invariant(typeof listener === 'function', 'listener must be a function.');
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) {
                return;
            }
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) {
            return false;
        }
        const source = this.registry.getSource(sourceId);
        invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) {
            return false;
        }
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) {
            return false;
        }
        const target = this.registry.getTarget(targetId);
        invariant(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) {
            return false;
        }
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) {
            return false;
        }
        const source = this.registry.getSource(sourceId, true);
        invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) {
            return false;
        }
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) {
            return false;
        }
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) {
            return false;
        }
        const { shallow  } = options;
        if (!this.isDragging()) {
            return false;
        }
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !matchesType(targetType, draggedItemType)) {
            return false;
        }
        const targetIds = this.getTargetIds();
        if (!targetIds.length) {
            return false;
        }
        const index = targetIds.indexOf(targetId);
        if (shallow) {
            return index === targetIds.length - 1;
        } else {
            return index > -1;
        }
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return getSourceClientOffset(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const scope = typeof global !== 'undefined' ? global : self;
const BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new BrowserMutationObserver(callback);
    const node = document.createTextNode('');
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const makeRequestCall = typeof BrowserMutationObserver === 'function' ? // reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
makeRequestCallFromMutationObserver : // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
makeRequestCallFromTimer;

class AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q , requestFlush  } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q  } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++){
                        q[scan] = q[scan + this.index];
                    }
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = makeRequestCall(this.flush);
        this.requestErrorThrow = makeRequestCallFromTimer(()=>{
            // Throw first error
            if (this.pendingErrors.length) {
                throw this.pendingErrors.shift();
            }
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

// `call`, just like a function.
class RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}

class TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new RawTask(this.onError, (t)=>tasks[tasks.length] = t
        );
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}

const asapQueue = new AsapQueue();
const taskFactory = new TaskFactory(asapQueue.registerPendingError);
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */ function asap(task) {
    asapQueue.enqueueTask(taskFactory.create(task));
}

const ADD_SOURCE = 'dnd-core/ADD_SOURCE';
const ADD_TARGET = 'dnd-core/ADD_TARGET';
const REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
const REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function addSource(sourceId) {
    return {
        type: ADD_SOURCE,
        payload: {
            sourceId
        }
    };
}
function addTarget(targetId) {
    return {
        type: ADD_TARGET,
        payload: {
            targetId
        }
    };
}
function removeSource(sourceId) {
    return {
        type: REMOVE_SOURCE,
        payload: {
            sourceId
        }
    };
}
function removeTarget(targetId) {
    return {
        type: REMOVE_TARGET,
        payload: {
            targetId
        }
    };
}

function validateSourceContract(source) {
    invariant(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    invariant(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    invariant(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
    invariant(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    invariant(typeof target.hover === 'function', 'Expected hover to be a function.');
    invariant(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>validateType(t, false)
        );
        return;
    }
    invariant(typeof type === 'string' || typeof type === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

var HandlerRole;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));

let nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}

function getNextHandlerId(role) {
    const id = getNextUniqueId().toString();
    switch(role){
        case HandlerRole.SOURCE:
            return `S${id}`;
        case HandlerRole.TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return HandlerRole.SOURCE;
        case 'T':
            return HandlerRole.TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function mapContainsValue(map$$1, searchValue) {
    const entries = map$$1.entries();
    let isDone = false;
    do {
        const { done , value: [, value] ,  } = entries.next();
        if (value === searchValue) {
            return true;
        }
        isDone = !!done;
    }while (!isDone)
    return false;
}
class HandlerRegistryImpl {
    addSource(type, source) {
        validateType(type);
        validateSourceContract(source);
        const sourceId = this.addHandler(HandlerRole.SOURCE, type, source);
        this.store.dispatch(addSource(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        validateType(type, true);
        validateTargetContract(target);
        const targetId = this.addHandler(HandlerRole.TARGET, type, target);
        this.store.dispatch(addTarget(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = parseRoleFromHandlerId(handlerId);
        return role === HandlerRole.SOURCE;
    }
    isTargetId(handlerId) {
        const role = parseRoleFromHandlerId(handlerId);
        return role === HandlerRole.TARGET;
    }
    removeSource(sourceId) {
        invariant(this.getSource(sourceId), 'Expected an existing source.');
        this.store.dispatch(removeSource(sourceId));
        asap(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        invariant(this.getTarget(targetId), 'Expected an existing target.');
        this.store.dispatch(removeTarget(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        invariant(source, 'Expected an existing source.');
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        invariant(this.pinnedSource, 'No source is pinned at the time.');
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = getNextHandlerId(role);
        this.types.set(id, type);
        if (role === HandlerRole.SOURCE) {
            this.dragSources.set(id, handler);
        } else if (role === HandlerRole.TARGET) {
            this.dropTargets.set(id, handler);
        }
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}

const strictEquality = (a, b)=>a === b
;
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */ function areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) {
        return true;
    } else if (!offsetA || !offsetB) {
        return false;
    } else {
        return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
    }
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */ function areArraysEqual(a, b, isEqual$$1 = strictEquality) {
    if (a.length !== b.length) {
        return false;
    }
    for(let i = 0; i < a.length; ++i){
        if (!isEqual$$1(a[i], b[i])) {
            return false;
        }
    }
    return true;
}

function reduce(// eslint-disable-next-line @typescript-eslint/no-unused-vars
_state = NONE, action) {
    switch(action.type){
        case HOVER:
            break;
        case ADD_SOURCE:
        case ADD_TARGET:
        case REMOVE_TARGET:
        case REMOVE_SOURCE:
            return NONE;
        case BEGIN_DRAG:
        case PUBLISH_DRAG_SOURCE:
        case END_DRAG:
        case DROP:
        default:
            return ALL;
    }
    const { targetIds =[] , prevTargetIds =[]  } = action.payload;
    const result = xor(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !areArraysEqual(targetIds, prevTargetIds);
    if (!didChange) {
        return NONE;
    }
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) {
            result.push(prevInnermostTargetId);
        }
        if (innermostTargetId) {
            result.push(innermostTargetId);
        }
    }
    return result;
}

function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
const initialState$7 = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function reduce$1(state = initialState$7, action) {
    const { payload  } = action;
    switch(action.type){
        case INIT_COORDS:
        case BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case HOVER:
            if (areCoordsEqual(state.clientOffset, payload.clientOffset)) {
                return state;
            }
            return _objectSpread$1({}, state, {
                clientOffset: payload.clientOffset
            });
        case END_DRAG:
        case DROP:
            return initialState$7;
        default:
            return state;
    }
}

function _defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
const initialState$8 = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function reduce$2(state = initialState$8, action) {
    const { payload  } = action;
    switch(action.type){
        case BEGIN_DRAG:
            return _objectSpread$2({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case PUBLISH_DRAG_SOURCE:
            return _objectSpread$2({}, state, {
                isSourcePublic: true
            });
        case HOVER:
            return _objectSpread$2({}, state, {
                targetIds: payload.targetIds
            });
        case REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) {
                return state;
            }
            return _objectSpread$2({}, state, {
                targetIds: without(state.targetIds, payload.targetId)
            });
        case DROP:
            return _objectSpread$2({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case END_DRAG:
            return _objectSpread$2({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}

function reduce$3(state = 0, action) {
    switch(action.type){
        case ADD_SOURCE:
        case ADD_TARGET:
            return state + 1;
        case REMOVE_SOURCE:
        case REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}

function reduce$4(state = 0) {
    return state + 1;
}

function _defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function reduce$5(state = {}, action) {
    return {
        dirtyHandlerIds: reduce(state.dirtyHandlerIds, {
            type: action.type,
            payload: _objectSpread$3({}, action.payload, {
                prevTargetIds: get$1(state, 'dragOperation.targetIds', [])
            })
        }),
        dragOffset: reduce$1(state.dragOffset, action),
        refCount: reduce$3(state.refCount, action),
        dragOperation: reduce$2(state.dragOperation, action),
        stateId: reduce$4(state.stateId)
    };
}

function createDragDropManager(backendFactory, globalContext = undefined, backendOptions = {}, debugMode = false) {
    const store = makeStoreInstance(debugMode);
    const monitor = new DragDropMonitorImpl(store, new HandlerRegistryImpl(store));
    const manager = new DragDropManagerImpl(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    return createStore(reduce$5, debugMode && reduxDevTools && reduxDevTools({
        name: 'dnd-core',
        instanceId: 'dnd-core'
    }));
}

function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let refCount = 0;
const INSTANCE_SYM = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
var DndProvider = /*#__PURE__*/ memo(function DndProvider(_param) {
    var { children  } = _param, props = _objectWithoutProperties$1(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ useEffect(()=>{
        if (isGlobalInstance) {
            const context = getGlobalContext();
            ++refCount;
            return ()=>{
                if (--refCount === 0) {
                    context[INSTANCE_SYM] = null;
                }
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ jsx(DndContext.Provider, {
        value: manager,
        children: children
    });
});
function getDndContextValue(props) {
    if ('manager' in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function createSingletonDndContext(backend, context = getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[INSTANCE_SYM]) {
        ctx[INSTANCE_SYM] = {
            dragDropManager: createDragDropManager(backend, context, options, debugMode)
        };
    }
    return ctx[INSTANCE_SYM];
}
function getGlobalContext() {
    return typeof global !== 'undefined' ? global : window;
}

/**
 * A utility for rendering a drag preview image
 */ const DragPreviewImage = memo(function DragPreviewImage({ connect: connect$$1 , src  }) {
    useEffect(()=>{
        if (typeof Image === 'undefined') return;
        let connected = false;
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            connect$$1(img);
            connected = true;
        };
        return ()=>{
            if (connected) {
                connect$$1(null);
            }
        };
    });
    return null;
});

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

// suppress the useLayoutEffect warning on server side.
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */ function useCollector(monitor, collect, onUpdate) {
    const [collected, setCollected] = useState(()=>collect(monitor)
    );
    const updateCollected = useCallback(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!fastDeepEqual(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) {
                onUpdate();
            }
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    useIsomorphicLayoutEffect(updateCollected);
    return [
        collected,
        updateCollected
    ];
}

function useMonitorOutput(monitor, collect, onCollect) {
    const [collected, updateCollected] = useCollector(monitor, collect, onCollect);
    useIsomorphicLayoutEffect(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) {
            return;
        }
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}

function useCollectedProps(collector, monitor, connector) {
    return useMonitorOutput(monitor, collector || (()=>({})
    ), ()=>connector.reconnect()
    );
}

function useOptionalFactory(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== 'function') {
        memoDeps.push(arg);
    }
    return useMemo(()=>{
        return typeof arg === 'function' ? arg() : arg;
    }, memoDeps);
}

function useConnectDragSource(connector) {
    return useMemo(()=>connector.hooks.dragSource()
    , [
        connector
    ]);
}
function useConnectDragPreview(connector) {
    return useMemo(()=>connector.hooks.dragPreview()
    , [
        connector
    ]);
}

let isCallingCanDrag = false;
let isCallingIsDragging = false;
class DragSourceMonitorImpl {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        invariant(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');
        try {
            isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) {
            return false;
        }
        invariant(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');
        try {
            isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}

let isCallingCanDrop = false;
class DropTargetMonitorImpl {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) {
            return false;
        }
        invariant(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');
        try {
            isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) {
            return false;
        }
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}

function registerTarget(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function registerSource(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}

function shallowEqual(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) {
        return !!compareResult;
    }
    if (objA === objB) {
        return true;
    }
    if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
        return false;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) {
            return false;
        }
    }
    return true;
}

function isRef(obj) {
    return(// eslint-disable-next-line no-prototype-builtins
    obj !== null && typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current'));
}

function throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') {
        return;
    }
    const displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + `You can either wrap ${displayName} into a <div>, or turn it into a ` + 'drag source or a drop target itself.');
}
function wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!isValidElement(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options)
         : hook;
        return cloneWithRef(element, ref);
    };
}
function wrapConnectorHooks(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith('Ref')) {
            wrappedHooks[key] = hooks[key];
        } else {
            const wrappedHook = wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook
            ;
        }
    });
    return wrappedHooks;
}
function setRef(ref, node) {
    if (typeof ref === 'function') {
        ref(node);
    } else {
        ref.current = node;
    }
}
function cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    invariant(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs');
    if (!previousRef) {
        // When there is no ref on the element, use the new ref directly
        return cloneElement(element, {
            ref: newRef
        });
    } else {
        return cloneElement(element, {
            ref: (node)=>{
                setRef(previousRef, node);
                setRef(newRef, node);
            }
        });
    }
}

class SourceConnector {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) {
            return;
        }
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) {
            this.disconnectDragSource();
        }
        if (!this.handlerId) {
            return didChange;
        }
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) {
            this.disconnectDragPreview();
        }
        if (!this.handlerId) {
            return;
        }
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = wrapConnectorHooks({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if (isRef(node)) {
                    this.dragSourceRef = node;
                } else {
                    this.dragSourceNode = node;
                }
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if (isRef(node)) {
                    this.dragPreviewRef = node;
                } else {
                    this.dragPreviewNode = node;
                }
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}

class TargetConnector {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) {
            this.disconnectDropTarget();
        }
        const dropTarget = this.dropTarget;
        if (!this.handlerId) {
            return;
        }
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) {
            return;
        }
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = wrapConnectorHooks({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if (isRef(node)) {
                    this.dropTargetRef = node;
                } else {
                    this.dropTargetNode = node;
                }
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}

/**
 * A hook to retrieve the DragDropManager from Context
 */ function useDragDropManager() {
    const { dragDropManager  } = useContext(DndContext);
    invariant(dragDropManager != null, 'Expected drag drop context');
    return dragDropManager;
}

function useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
    const manager = useDragDropManager();
    const connector = useMemo(()=>new SourceConnector(manager.getBackend())
    , [
        manager
    ]);
    useIsomorphicLayoutEffect(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource()
        ;
    }, [
        connector,
        dragSourceOptions
    ]);
    useIsomorphicLayoutEffect(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview()
        ;
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}

function useDragSourceMonitor() {
    const manager = useDragDropManager();
    return useMemo(()=>new DragSourceMonitorImpl(manager)
    , [
        manager
    ]);
}

class DragSourceImpl {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === 'object') {
            result = spec.item;
        } else if (typeof spec.item === 'function') {
            result = spec.item(monitor);
        } else {
            result = {};
        }
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === 'boolean') {
            return spec.canDrag;
        } else if (typeof spec.canDrag === 'function') {
            return spec.canDrag(monitor);
        } else {
            return true;
        }
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging  } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end  } = spec;
        if (end) {
            end(monitor.getItem(), monitor);
        }
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}

function useDragSource(spec, monitor, connector) {
    const handler = useMemo(()=>new DragSourceImpl(spec, monitor, connector)
    , [
        monitor,
        connector
    ]);
    useEffect(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}

function useDragType(spec) {
    return useMemo(()=>{
        const result = spec.type;
        invariant(result != null, 'spec.type must be defined');
        return result;
    }, [
        spec
    ]);
}

function useRegisteredDragSource(spec, monitor, connector) {
    const manager = useDragDropManager();
    const handler = useDragSource(spec, monitor, connector);
    const itemType = useDragType(spec);
    useIsomorphicLayoutEffect(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = registerSource(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}

/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ function useDrag(specArg, deps) {
    const spec = useOptionalFactory(specArg, deps);
    invariant(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = useDragSourceMonitor();
    const connector = useDragSourceConnector(spec.options, spec.previewOptions);
    useRegisteredDragSource(spec, monitor, connector);
    return [
        useCollectedProps(spec.collect, monitor, connector),
        useConnectDragSource(connector),
        useConnectDragPreview(connector), 
    ];
}

function useConnectDropTarget(connector) {
    return useMemo(()=>connector.hooks.dropTarget()
    , [
        connector
    ]);
}

function useDropTargetConnector(options) {
    const manager = useDragDropManager();
    const connector = useMemo(()=>new TargetConnector(manager.getBackend())
    , [
        manager
    ]);
    useIsomorphicLayoutEffect(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget()
        ;
    }, [
        options
    ]);
    return connector;
}

function useDropTargetMonitor() {
    const manager = useDragDropManager();
    return useMemo(()=>new DropTargetMonitorImpl(manager)
    , [
        manager
    ]);
}

/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */ function useAccept(spec) {
    const { accept  } = spec;
    return useMemo(()=>{
        invariant(spec.accept != null, 'accept must be defined');
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}

class DropTargetImpl {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) {
            spec.hover(monitor.getItem(), monitor);
        }
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) {
            return spec.drop(monitor.getItem(), monitor);
        }
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}

function useDropTarget(spec, monitor) {
    const dropTarget = useMemo(()=>new DropTargetImpl(spec, monitor)
    , [
        monitor
    ]);
    useEffect(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}

function useRegisteredDropTarget(spec, monitor, connector) {
    const manager = useDragDropManager();
    const dropTarget = useDropTarget(spec, monitor);
    const accept = useAccept(spec);
    useIsomorphicLayoutEffect(function registerDropTarget() {
        const [handlerId, unregister] = registerTarget(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()
        ).join('|'), 
    ]);
}

/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ function useDrop(specArg, deps) {
    const spec = useOptionalFactory(specArg, deps);
    const monitor = useDropTargetMonitor();
    const connector = useDropTargetConnector(spec.options);
    useRegisteredDropTarget(spec, monitor, connector);
    return [
        useCollectedProps(spec.collect, monitor, connector),
        useConnectDropTarget(connector), 
    ];
}

// cheap lodash replacements
function memoize(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) {
            result = fn();
        }
        return result;
    };
    return memoized;
}
/**
 * drop-in replacement for _.without
 */ function without$1(items, item) {
    return items.filter((i)=>i !== item
    );
}
function union(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item)
    ;
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key)
    );
    return result;
}

class EnterLeaveCounter {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode))
        ;
        this.entered = union(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = without$1(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}

class NativeDragSource {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) {
                    newProperties[property] = {
                        value: propertyFn(dataTransfer, this.config.matchesTypes),
                        configurable: true,
                        enumerable: true
                    };
                }
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}

const FILE = '__NATIVE_FILE__';
const URL = '__NATIVE_URL__';
const TEXT = '__NATIVE_TEXT__';
const HTML = '__NATIVE_HTML__';

var NativeTypes = /*#__PURE__*/Object.freeze({
	FILE: FILE,
	URL: URL,
	TEXT: TEXT,
	HTML: HTML
});

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry)
    , '');
    return result != null ? result : defaultValue;
}

const nativeTypesConfig = {
    [FILE]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files)
            ,
            items: (dataTransfer)=>dataTransfer.items
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Files'
        ]
    },
    [HTML]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>getDataFromDataTransfer(dataTransfer, matchesTypes, '')
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Html',
            'text/html'
        ]
    },
    [URL]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n')
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Url',
            'text/uri-list'
        ]
    },
    [TEXT]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>getDataFromDataTransfer(dataTransfer, matchesTypes, '')
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Text',
            'text/plain'
        ]
    }
};

function createNativeDragSource(type, dataTransfer) {
    const config = nativeTypesConfig[type];
    if (!config) {
        throw new Error(`native type ${type} has no configuration`);
    }
    const result = new NativeDragSource(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function matchNativeItemType(dataTransfer) {
    if (!dataTransfer) {
        return null;
    }
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys(nativeTypesConfig).filter((nativeItemType)=>{
        const typeConfig = nativeTypesConfig[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) {
            return false;
        }
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1
        );
    })[0] || null;
}

const isFirefox = memoize(()=>/firefox/i.test(navigator.userAgent)
);
const isSafari = memoize(()=>Boolean(window.safari)
);

class MonotonicInterpolant {
    interpolate(x) {
        const { xs , ys , c1s , c2s , c3s  } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) {
            return ys[i];
        }
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) {
                low = mid + 1;
            } else if (xHere > x) {
                high = mid - 1;
            } else {
                return ys[mid];
            }
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length  } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++){
            indexes.push(i);
        }
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1
        );
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) {
                c1s.push(0);
            } else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}

const ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
    const el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
    if (!el) {
        return null;
    }
    const { top , left  } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function getEventClientOffset(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function isImageNode(node) {
    var ref;
    return node.nodeName === 'IMG' && (isFirefox() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if (isSafari() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth,
        dragPreviewHeight
    };
}
function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth , offsetHeight: sourceHeight  } = sourceNode;
    const { anchorX , anchorY  } = anchorPoint;
    const { dragPreviewWidth , dragPreviewHeight  } = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            (offsetFromDragPreview.y / sourceHeight) * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight, 
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if (isSafari() && isImage) {
            // We'll have to wait for @3x to see if this is entirely correct
            y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        }
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            (offsetFromDragPreview.x / sourceWidth) * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth, 
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX , offsetY  } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}

class OptionsReader {
    get window() {
        if (this.globalContext) {
            return this.globalContext;
        } else if (typeof window !== 'undefined') {
            return window;
        }
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) {
            return this.globalContext.document;
        } else if (this.window) {
            return this.window.document;
        } else {
            return undefined;
        }
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
}

function _defineProperty$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
class HTML5BackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) {
            return;
        }
        if (root.__isReactDndBackendSetUp) {
            throw new Error('Cannot have two HTML5 backends at the same time.');
        }
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) {
            return;
        }
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 ? void 0 : ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId)
        ;
        const handleSelectStart = (e)=>this.handleSelectStart(e)
        ;
        node.setAttribute('draggable', 'true');
        node.addEventListener('dragstart', handleDragStart);
        node.addEventListener('selectstart', handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener('dragstart', handleDragStart);
            node.removeEventListener('selectstart', handleSelectStart);
            node.setAttribute('draggable', 'false');
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId)
        ;
        const handleDragOver = (e)=>this.handleDragOver(e, targetId)
        ;
        const handleDrop = (e)=>this.handleDrop(e, targetId)
        ;
        node.addEventListener('dragenter', handleDragEnter);
        node.addEventListener('dragover', handleDragOver);
        node.addEventListener('drop', handleDrop);
        return ()=>{
            node.removeEventListener('dragenter', handleDragEnter);
            node.removeEventListener('dragover', handleDragOver);
            node.removeEventListener('drop', handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) {
            return;
        }
        target.addEventListener('dragstart', this.handleTopDragStart);
        target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.addEventListener('dragend', this.handleTopDragEndCapture, true);
        target.addEventListener('dragenter', this.handleTopDragEnter);
        target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.addEventListener('dragover', this.handleTopDragOver);
        target.addEventListener('dragover', this.handleTopDragOverCapture, true);
        target.addEventListener('drop', this.handleTopDrop);
        target.addEventListener('drop', this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) {
            return;
        }
        target.removeEventListener('dragstart', this.handleTopDragStart);
        target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
        target.removeEventListener('dragenter', this.handleTopDragEnter);
        target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.removeEventListener('dragover', this.handleTopDragOver);
        target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
        target.removeEventListener('drop', this.handleTopDrop);
        target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return _objectSpread$4({
            dropEffect: this.altKeyPressed ? 'copy' : 'move'
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) {
            // It makes more sense to default to 'copy' for native resources
            return 'copy';
        }
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return _objectSpread$4({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys(NativeTypes).some((key)=>NativeTypes[key] === itemType
        );
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = createNativeDragSource(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 ? void 0 : ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) {
            return;
        }
        if (!this.dragStartSourceIds) {
            this.dragStartSourceIds = [];
        }
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) {
            this.dragOverTargetIds = [];
        }
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && getNodeClientOffset(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) {
                return;
            }
            this.actions.endDrag();
            if (this.currentNativeHandle) {
                this.registry.removeSource(this.currentNativeHandle);
            }
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) {
                return;
            }
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) {
                this.actions.endDrag();
            }
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== 'undefined') {
                this.hoverRafId = requestAnimationFrame(()=>{
                    if (this.monitor.isDragging()) {
                        this.actions.hover(dragOverTargetIds || [], {
                            clientOffset: this.lastClientOffset
                        });
                    }
                    this.hoverRafId = null;
                });
            }
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== 'undefined') {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) {
                return;
            }
            const { dragStartSourceIds  } = this;
            this.dragStartSourceIds = null;
            const clientOffset = getEventClientOffset(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset
            });
            const { dataTransfer  } = e;
            const nativeType = matchNativeItemType(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX , anchorY , offsetX , offsetY  } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX,
                            anchorY
                        };
                        const offsetPoint = {
                            offsetX,
                            offsetY
                        };
                        const dragPreviewOffset = getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.setData('application/json', {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState  } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) {
                    // Usually we want to publish it in the next tick so that browser
                    // is able to screenshot the current (not yet dragging) state.
                    //
                    // It also neatly avoids a situation where render() returns null
                    // in the same tick for the source element, and browser freaks out.
                    setTimeout(()=>this.actions.publishDragSource()
                    , 0);
                } else {
                    // In some cases the user may want to override this behavior, e.g.
                    // to work around IE not supporting custom drag previews.
                    //
                    // When using a custom drag layer, the only way to prevent
                    // the default drag preview from drawing in IE is to screenshot
                    // the dragging state in which the node itself has zero opacity
                    // and height. In this case, though, returning null from render()
                    // will abruptly end the dragging, which is not obvious.
                    //
                    // This is the reason such behavior is strictly opt-in.
                    this.actions.publishDragSource();
                }
            } else if (nativeType) {
                // A native item (such as URL) dragged from inside the document
                this.beginDragNativeItem(nativeType);
            } else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
                // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
                // Just let it drag. It's a native type (URL or text) and will be picked up in
                // dragenter handler.
                return;
            } else {
                // If by this time no drag source reacted, tell browser not to drag.
                e.preventDefault();
            }
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) {
                // Firefox can dispatch this event in an infinite loop
                // if dragend handler does something like showing an alert.
                // Only proceed if we have not handled it already.
                this.actions.endDrag();
            }
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) {
                return;
            }
            const { dataTransfer  } = e;
            const nativeType = matchNativeItemType(dataTransfer);
            if (nativeType) {
                // A native item (such as file or URL) dragged from outside the document
                this.beginDragNativeItem(nativeType, dataTransfer);
            }
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds  } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                return;
            }
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) {
                this.actions.hover(dragEnterTargetIds, {
                    clientOffset: getEventClientOffset(e)
                });
            }
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId)
            );
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                }
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds  } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = 'none';
                }
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = getEventClientOffset(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId)
            );
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                }
            } else if (this.isDraggingNativeItem()) {
                // Don't show a nice cursor but still prevent default
                // "drop and blow away the whole document" action.
                e.preventDefault();
            } else {
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = 'none';
                }
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) {
                e.preventDefault();
            }
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) {
                return;
            }
            if (this.isDraggingNativeItem()) {
                setTimeout(()=>this.endDragNativeItem()
                , 0);
            }
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
            } else if (matchNativeItemType(e.dataTransfer)) {
                // Dragging some elements, like <a> and <img> may still behave like a native drag event,
                // even if the current drag event matches a user-defined type.
                // Stop the default behavior when we're not expecting a native item to be dropped.
                e.preventDefault();
            }
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds  } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: getEventClientOffset(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) {
                this.endDragNativeItem();
            } else if (this.monitor.isDragging()) {
                this.actions.endDrag();
            }
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== 'function') {
                return;
            }
            // Inputs and textareas should be selectable
            if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
                return;
            }
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new OptionsReader(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
    }
}

const HTML5Backend = function createBackend(manager, context, options) {
    return new HTML5BackendImpl(manager, context, options);
};

var DraggableBodyRow = function DraggableBodyRow(objectTypeExtId) {
  return function (_ref) {
    var index = _ref.index,
        moveRow = _ref.moveRow,
        className = _ref.className,
        style = _ref.style,
        restProps = _objectWithoutProperties(_ref, ['index', 'moveRow', 'className', 'style']);

    var ref = useRef();

    var _useDrop = useDrop({
      accept: objectTypeExtId,
      collect: function collect(monitor) {
        var _ref2 = monitor.getItem() || {},
            dragIndex = _ref2.index;

        if (dragIndex === index) {
          return {};
        }
        return {
          isOver: monitor.isOver(),
          dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward'
        };
      },
      drop: function drop(item) {
        moveRow(item.index, index);
      }
    }),
        _useDrop2 = _slicedToArray(_useDrop, 2),
        _useDrop2$ = _useDrop2[0],
        isOver = _useDrop2$.isOver,
        dropClassName = _useDrop2$.dropClassName,
        drop = _useDrop2[1];

    var _useDrag = useDrag({
      type: objectTypeExtId,
      item: { index: index },
      collect: function collect(monitor) {
        return {
          isDragging: monitor.isDragging()
        };
      }
    }),
        _useDrag2 = _slicedToArray(_useDrag, 2),
        drag = _useDrag2[1];

    drop(drag(ref));

    return React.createElement('tr', _extends$1({
      ref: ref,
      className: '' + className + (isOver ? dropClassName : ''),
      style: _extends$1({ cursor: 'move' }, style)
    }, restProps));
  };
};

var mapStateToProps$3 = function mapStateToProps(state, ownProps) {
  return {
    rawObjectFields: state.rawObjectFields[ownProps.objectType.objectTypeExtId] || [],
    rawObjectFieldsLoading: createLoadingSelector(['FECTH_RAW_OBJECT_FIELDS'])(state)
  };
};

var mapActionsToProps$3 = {
  updateForObjectType: updateForObjectType,
  updateForFieldInObjectType: updateForFieldInObjectType,
  moveFieldInObjectType: moveFieldInObjectType
};

var FreeMappingFieldMapping = function FreeMappingFieldMapping(_ref) {
  var appName = _ref.appName,
      objectType = _ref.objectType,
      objectTypeIdx = _ref.objectTypeIdx,
      rawObjectFields = _ref.rawObjectFields,
      updateForObjectType$$1 = _ref.updateForObjectType,
      updateForFieldInObjectType$$1 = _ref.updateForFieldInObjectType,
      rawObjectFieldsLoading = _ref.rawObjectFieldsLoading,
      moveFieldInObjectType$$1 = _ref.moveFieldInObjectType;

  // callbacks
  useEffect(function () {
    if (rawObjectFields && rawObjectFields.length) {
      var indexedField = keyBy(objectType.fields.filter(function (field) {
        return field.isActive;
      }), 'fieldExtId');
      var orderedKeys = uniq(_Object$keys(indexedField).concat(rawObjectFields.map(function (item) {
        return item.value;
      })));
      var fields = orderedKeys.map(function (key) {
        var existedField = indexedField[key];
        if (existedField) {
          return new FieldMapping(_extends$1({}, existedField, {
            isActive: true
          }));
        }
        return new FieldMapping({
          appFieldName: key,
          fieldExtId: key,
          fieldLabel: key,
          isActive: false
        });
      });

      updateForObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, fields: fields, hasChanges: objectType.hasChanges });
    }
  }, [rawObjectFieldsLoading, objectType.objectTypeExtId]);

  var onFieldToggle = useCallback(function (item, itemIndex) {
    return function (checked) {
      var activatedFieldsCount = objectType.fields.filter(function (field) {
        return field.isActive;
      }).length;
      if (checked) {
        // If first activated field -> set it as Is Label field
        updateForFieldInObjectType$$1({
          appName: appName,
          objectTypeIdx: objectTypeIdx,
          fieldIdx: itemIndex,
          isActive: true,
          appProperty: activatedFieldsCount === 0 ? appProperties.LABEL : null
        });
      } else {
        updateForFieldInObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, fieldIdx: itemIndex, isActive: false, appProperty: null });

        if (item.appProperty === appProperties.LABEL && activatedFieldsCount > 1) {
          var nextLabeledFieldIndex = objectType.fields.findIndex(function (field) {
            return field.fieldExtId !== item.fieldExtId && field.isActive;
          });
          updateForFieldInObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, fieldIdx: nextLabeledFieldIndex, appProperty: appProperties.LABEL });
        }
      }
    };
  }, [objectType.fields]);

  var onSearchableToggle = useCallback(function (item, itemIndex) {
    return function (checked) {
      updateForFieldInObjectType$$1({
        appName: appName,
        objectTypeIdx: objectTypeIdx,
        fieldIdx: itemIndex,
        isSearchable: checked
      });
    };
  }, [objectType.fields]);

  var onIsLabelSelect = function onIsLabelSelect(itemIndex) {
    return function () {
      var foundLabelFieldIndex = objectType.fields.findIndex(function (field) {
        return field.appProperty === appProperties.LABEL;
      });
      if (foundLabelFieldIndex > -1) {
        updateForFieldInObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, fieldIdx: foundLabelFieldIndex, appProperty: null });
      }
      updateForFieldInObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, fieldIdx: itemIndex, appProperty: appProperties.LABEL });
    };
  };

  var onFieldLabelChange = function onFieldLabelChange(item, itemIndex) {
    return function (newLabel) {
      updateForFieldInObjectType$$1({ appName: appName, objectTypeIdx: objectTypeIdx, fieldIdx: itemIndex, fieldLabel: newLabel });
    };
  };

  var columns = [{
    title: 'Field',
    dataIndex: 'fieldExtId'
  }, {
    title: 'Include',
    render: function render(text, item, itemIndex) {
      return React.createElement(Switch, { checked: item.isActive, onChange: onFieldToggle(item, itemIndex) });
    }
  }, {
    title: 'Searchable',
    render: function render(text, item, itemIndex) {
      var style = !item.isActive ? { cursor: 'not-allowed' } : {};
      return React.createElement(Switch, { style: style, checked: item.isSearchable && item.isActive, onChange: onSearchableToggle(item, itemIndex) });
    }
  }, {
    title: 'Label',
    render: function render(text, item, itemIndex) {
      return React.createElement(
        Typography.Paragraph,
        {
          style: { marginBottom: '0' },
          editable: { onChange: onFieldLabelChange(item, itemIndex) }
        },
        item.fieldLabel
      );
    }
  }, {
    title: 'Is Label',
    render: function render(text, item, itemIndex) {
      return React.createElement(Radio, { disabled: !item.isActive, checked: item.appProperty === appProperties.LABEL, onChange: onIsLabelSelect(itemIndex) });
    }
  }];

  var onRowMove = useCallback(function (fromIdx, toIdx) {
    moveFieldInObjectType$$1({
      appName: appName,
      objectTypeIdx: objectTypeIdx,
      fields: objectType.fields,
      fromIdx: fromIdx,
      toIdx: toIdx
    });
  });

  return React.createElement(
    DndProvider,
    { backend: HTML5Backend },
    React.createElement(Table, {
      columns: columns,
      dataSource: objectType.fields,
      rowKey: 'fieldExtId',
      pagination: false,
      loading: rawObjectFieldsLoading,
      onRow: function onRow(record, index) {
        return {
          key: record.fieldExtId,
          index: index,
          moveRow: onRowMove
        };
      },
      components: {
        body: {
          row: DraggableBodyRow(objectType.objectTypeExtId)
        }
      }
    })
  );
};

FreeMappingFieldMapping.propTypes = {
  appName: PropTypes.string.isRequired,
  objectType: PropTypes.object.isRequired,
  objectTypeIdx: PropTypes.number.isRequired,
  rawObjectFields: PropTypes.array.isRequired,
  updateForObjectType: PropTypes.func.isRequired,
  updateForFieldInObjectType: PropTypes.func.isRequired,
  rawObjectFieldsLoading: PropTypes.bool.isRequired,
  moveFieldInObjectType: PropTypes.func.isRequired
};

var FreeMappingFieldMapping$1 = connect(mapStateToProps$3, mapActionsToProps$3)(FreeMappingFieldMapping);

// CONSTANTS
var mapStateToProps$4 = function mapStateToProps(state, ownProps) {
  var appName = ownProps.appName;

  return {
    allowedMappingModes: state.mapping[appName].allowedMappingModes
  };
};

var FieldMapping$1 = function FieldMapping(_ref) {
  var appName = _ref.appName,
      objectType = _ref.objectType,
      objectTypeIdx = _ref.objectTypeIdx;

  var activeView = useMemo(function () {
    var fieldMappingMode = objectType.fieldMappingMode;

    switch (fieldMappingMode) {
      case fieldMappingModes.RAW:
        return React.createElement(RawFieldMapping, null);

      case fieldMappingModes.MAPPED:
        return React.createElement(MappedFieldMapping$1, { appName: appName, objectType: objectType, objectTypeIdx: objectTypeIdx });

      case fieldMappingModes.FREE_MAPPING:
        return React.createElement(FreeMappingFieldMapping$1, { appName: appName, objectType: objectType, objectTypeIdx: objectTypeIdx });

      default:
        return null;
    }
  }, [objectType]);

  return React.createElement(
    'div',
    { className: 'field-mapping--wrapper' },
    activeView
  );
};

FieldMapping$1.propTypes = {
  appName: PropTypes.string.isRequired,
  objectType: PropTypes.object.isRequired,
  objectTypeIdx: PropTypes.number.isRequired
};

var FieldMapping$2 = connect(mapStateToProps$4, null)(FieldMapping$1);

// CONSTANTS
var PreviewTable = function PreviewTable(_ref) {
  var objectType = _ref.objectType;
  var sampleObjects = objectType.sampleObjects,
      fields = objectType.fields,
      fieldMappingMode = objectType.fieldMappingMode;


  var columnFields = useMemo(function () {
    return fieldMappingMode === fieldMappingModes.RAW ? {} : fields.reduce(function (result, _ref2) {
      var appFieldName = _ref2.appFieldName,
          fieldLabel = _ref2.fieldLabel;
      return _extends$1({}, result, _defineProperty({}, appFieldName, fieldLabel));
    }, { te_extid: 'TE ExtID' });
  }, [fieldMappingMode, fields]);

  var columns = useMemo(function () {
    if (!sampleObjects || !sampleObjects[0]) return [];
    return _Object$keys(sampleObjects[0]).map(function (key) {
      return {
        title: columnFields[key] || key,
        dataIndex: key,
        key: key
      };
    });
  }, [sampleObjects, columnFields]);

  return React.createElement(
    'div',
    { className: 'field-mapping--wrapper', style: { marginTop: '2rem' } },
    React.createElement(
      Card,
      { title: 'Preview' },
      React.createElement(Table, {
        pagination: false,
        dataSource: sampleObjects,
        columns: columns
      })
    )
  );
};

PreviewTable.propTypes = {
  objectType: PropTypes.object.isRequired
};

// CONSTANTS
var mapStateToProps$5 = function mapStateToProps(state, ownProps) {
  return {
    showPreview: (ownProps.objectType.sampleObjects || []).length > 0
  };
};

var ObjectTypeMapping$1 = function ObjectTypeMapping(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      objectType = _ref.objectType,
      objectTypeIdx = _ref.objectTypeIdx,
      showPreview = _ref.showPreview,
      onSave = _ref.onSave;

  return React.createElement(
    'div',
    { className: 'object-type-mapping--wrapper' },
    React.createElement(
      Collapse,
      { bordered: false, defaultActiveKey: [] },
      React.createElement(
        Collapse.Panel,
        {
          header: React.createElement(PanelHeader$1, {
            appName: appName,
            organizationId: organizationId,
            objectType: objectType,
            objectTypeIdx: objectTypeIdx,
            onSave: onSave
          }),
          key: '1'
        },
        React.createElement(MappingSelector$1, {
          appName: appName,
          objectType: objectType,
          objectTypeIdx: objectTypeIdx,
          organizationId: organizationId
        }),
        objectType && objectType.objectTypeExtId && React.createElement(FieldMapping$2, {
          appName: appName,
          objectType: objectType,
          objectTypeIdx: objectTypeIdx
        }),
        showPreview && React.createElement(PreviewTable, { objectType: objectType })
      )
    )
  );
};

ObjectTypeMapping$1.propTypes = {
  appName: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired,
  objectType: PropTypes.object.isRequired,
  objectTypeIdx: PropTypes.number.isRequired,
  showPreview: PropTypes.bool,
  onSave: PropTypes.func.isRequired
};

ObjectTypeMapping$1.defaultProps = {
  showPreview: false
};

var ObjectTypeMapping$2 = connect(mapStateToProps$5, null)(ObjectTypeMapping$1);

var mapStateToProps$6 = function mapStateToProps(state, ownProps) {
  var appName = ownProps.appName;

  var mappedObjectTypes = state.mapping[appName].objectTypes.map(function (obj) {
    return obj.objectTypeExtId;
  });

  return {
    allowedMappingModes: state.mapping[appName].allowedMappingModes,
    rawObjectTypesLoading: createLoadingSelector(['FECTH_RAW_OBJECT_TYPES'])(state),
    rawObjectTypes: state.rawObjectTypes.filter(function (item) {
      return mappedObjectTypes.indexOf(item.extid) === -1;
    })
  };
};

var mapActionsToProps$4 = {
  addNewObjectType: addNewObjectType,
  saveMappingFopApp: saveMappingFopApp
};

var AddNewObjectType = function AddNewObjectType(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      allowedMappingModes = _ref.allowedMappingModes,
      addNewObjectType$$1 = _ref.addNewObjectType,
      saveMappingFopApp$$1 = _ref.saveMappingFopApp,
      objectTypes = _ref.objectTypes,
      rawObjectTypes = _ref.rawObjectTypes,
      rawObjectTypesLoading = _ref.rawObjectTypesLoading;

  // State var to hold the new object type
  var _useState = useState(createNewObjectTypeForApplication(allowedMappingModes[0])),
      _useState2 = _slicedToArray(_useState, 2),
      objectType = _useState2[0],
      setObjectType = _useState2[1];
  // Callback for creating the new object type


  var onAddNewObjectType = useCallback(function () {
    var foundObjectType = objectTypes.find(function (obj) {
      return obj.applicationObjectTypeName === objectType.applicationObjectTypeName;
    });
    if (foundObjectType) {
      notification.error({
        message: 'ObjectType is already existed'
      });
      return;
    }
    addNewObjectType$$1({ appName: appName, objectType: objectType });
    setObjectType(createNewObjectTypeForApplication(allowedMappingModes[0]));
    // CALL API TO CREATE NEW OBJECT_TYPE
    saveMappingFopApp$$1({ appName: appName, organizationId: organizationId, objectTypeIdx: 0, objectType: objectType });
  }, [appName, objectType]);

  return React.createElement(
    Collapse,
    { defaultActiveKey: [] },
    React.createElement(
      Collapse.Panel,
      { header: 'Add new object type', key: '1' },
      React.createElement(
        Row,
        { gutter: 16 },
        React.createElement(
          Col,
          { span: 6 },
          React.createElement(
            Form.Item,
            { label: 'Label' },
            React.createElement(Input, {
              size: 'small',
              value: objectType.applicationObjectTypeLabel,
              onChange: function onChange(e) {
                return setObjectType(_extends$1({}, objectType, {
                  applicationObjectTypeLabel: e.target.value
                }));
              }
            })
          )
        ),
        React.createElement(
          Col,
          { span: 6 },
          React.createElement(
            Form.Item,
            { label: 'Property name' },
            React.createElement(Input, {
              size: 'small',
              disabled: true,
              value: objectType.objectTypeExtId
            })
          )
        ),
        React.createElement(
          Col,
          { span: 6 },
          React.createElement(
            Form.Item,
            { label: 'Mapping type', className: 'data-model' },
            React.createElement(
              Select,
              {
                size: 'small',
                value: objectType.fieldMappingMode || undefined,
                style: { minWidth: '100%' },
                onChange: function onChange(fieldMappingMode) {
                  return setObjectType(_extends$1({}, objectType, { fieldMappingMode: fieldMappingMode }));
                }
              },
              _Object$keys(fieldMappingModes).filter(function (el) {
                return allowedMappingModes.indexOf(el) > -1;
              }).map(function (el) {
                return React.createElement(
                  Select.Option,
                  { key: el, value: el },
                  fieldMappingModeProps[el].label
                );
              })
            )
          )
        ),
        React.createElement(
          Col,
          { span: 6 },
          React.createElement(
            Form.Item,
            { label: 'Mapped to object type', className: 'data-model' },
            React.createElement(
              Select,
              {
                size: 'small',
                placeholder: 'No object type selected',
                value: objectType.objectTypeExtId || undefined,
                style: { minWidth: '100%' },
                onChange: function onChange(objectTypeExtId) {
                  return setObjectType(_extends$1({}, objectType, { objectTypeExtId: objectTypeExtId, applicationObjectTypeName: objectTypeExtId }));
                },
                loading: rawObjectTypesLoading,
                disabled: rawObjectTypesLoading,
                showSearch: true,
                filterOption: function filterOption(query, item) {
                  return !query || ('' + item.props.value + item.props.children).toLowerCase().indexOf(query.toLowerCase()) > -1;
                }
              },
              rawObjectTypes && rawObjectTypes.map(function (item) {
                return React.createElement(
                  Select.Option,
                  { value: item.extid, key: item.extid },
                  item.name
                );
              })
            )
          )
        )
      ),
      React.createElement(
        Row,
        { gutter: 16 },
        React.createElement(
          Col,
          { span: 6 },
          React.createElement(
            Button,
            {
              size: 'small',
              type: 'primary',
              onClick: onAddNewObjectType,
              disabled: !objectType.applicationObjectTypeLabel || !objectType.objectTypeExtId
            },
            'Add object type'
          )
        )
      )
    )
  );
};

AddNewObjectType.propTypes = {
  appName: PropTypes.string.isRequired,
  allowedMappingModes: PropTypes.array.isRequired,
  addNewObjectType: PropTypes.func.isRequired,
  saveMappingFopApp: PropTypes.func.isRequired,
  organizationId: PropTypes.string.isRequired,
  objectTypes: PropTypes.array,
  rawObjectTypesLoading: PropTypes.bool,
  rawObjectTypes: PropTypes.array
};
AddNewObjectType.defaultProps = {
  objectTypes: [],
  rawObjectTypes: [],
  rawObjectTypesLoading: false
};

var AddNewObjectType$1 = connect(mapStateToProps$6, mapActionsToProps$4)(AddNewObjectType);

var fetchRawObjectTypeslow = {
  request: function request() {
    return { type: FECTH_RAW_OBJECT_TYPES_REQUEST };
  },
  success: function success(response) {
    return { type: FECTH_RAW_OBJECT_TYPES_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: FECTH_RAW_OBJECT_TYPES_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchRawObjectTypes = function fetchRawObjectTypes(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId;

  return asyncAction.GET({
    flow: fetchRawObjectTypeslow,
    // endpoint: 'integrations/object-types/raw',
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/object/types',
    requiresAuth: true,
    additionalOptions: {
      retryWhenFail: true
    }
  });
};

var mapStateToProps$7 = function mapStateToProps(state, ownProps) {
  var appName = ownProps.appName;
  var _state$mapping$appNam = state.mapping[appName],
      isNew = _state$mapping$appNam.isNew,
      objectTypes = _state$mapping$appNam.objectTypes,
      allowDynamicObjectTypes = _state$mapping$appNam.allowDynamicObjectTypes,
      allowedMappingModes = _state$mapping$appNam.allowedMappingModes,
      errors = _state$mapping$appNam.errors;


  return {
    objectTypes: objectTypes,
    isNewAppMapping: isNew,
    allowDynamicObjectTypes: allowDynamicObjectTypes,
    allowedMappingModes: allowedMappingModes,
    errors: errors
  };
};

var mapActionsToProps$5 = {
  fetchRawObjectTypes: fetchRawObjectTypes,
  testMappingForAllObjectTypes: testMappingForAllObjectTypes,
  fetchMappingForApp: fetchMappingForApp,
  resetMappingForApp: resetMappingForApp,
  createMappingForApp: createMappingForApp
};

var Mapping = function Mapping(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      objectTypes = _ref.objectTypes,
      isNewAppMapping = _ref.isNewAppMapping,
      allowDynamicObjectTypes = _ref.allowDynamicObjectTypes,
      onSave = _ref.onSave,
      fetchRawObjectTypes$$1 = _ref.fetchRawObjectTypes,
      resetMappingForApp$$1 = _ref.resetMappingForApp,
      fetchMappingForApp$$1 = _ref.fetchMappingForApp,
      createMappingForApp$$1 = _ref.createMappingForApp,
      testMappingForAllObjectTypes$$1 = _ref.testMappingForAllObjectTypes,
      errors = _ref.errors,
      messages = _ref.messages,
      loading = _ref.loading;

  var testing = useSelector(createLoadingSelector(['TEST_MAPPING_FOR_ALL_OBJECT_TYPES']));

  var loadingMappingForApp = useSelector(createLoadingSelector(['FETCH_MAPPING_FOR_APP', 'CREATE_MAPPING_FOR_APP']));

  useEffect(function () {
    fetchRawObjectTypes$$1({ appName: appName, organizationId: organizationId });
    testMappingForAllObjectTypes$$1({ appName: appName, organizationId: organizationId });
  }, []);

  useEffect(function () {
    resetMappingForApp$$1({ appName: appName });
    fetchMappingForApp$$1({ appName: appName, organizationId: organizationId });
  }, [appName, organizationId]);

  useEffect(function () {
    if (!loadingMappingForApp && isNewAppMapping) {
      createMappingForApp$$1({ appName: appName, organizationId: organizationId });
    }
  }, [loadingMappingForApp]);

  var errorMessages = useMemo(function () {
    var errorMessages = objectTypes.reduce(function (result, _ref2) {
      var applicationObjectTypeLabel = _ref2.applicationObjectTypeLabel,
          errors = _ref2.errors;
      return [].concat(_toConsumableArray(result), _toConsumableArray(errors.map(function (error) {
        return {
          title: applicationObjectTypeLabel + ' error:',
          message: error
        };
      })));
    }, []);

    if (errors.length > 0) {
      errors.forEach(function (error) {
        return errorMessages.push({ message: error });
      });
    }

    if (messages.length > 0) {
      messages.forEach(function (_ref3) {
        var type = _ref3.type,
            title = _ref3.title,
            message = _ref3.message;
        return errorMessages.push({ type: type, title: title, message: message });
      });
    }

    return errorMessages;
  }, [objectTypes, errors, messages]);

  if (loadingMappingForApp || loading) {
    return React.createElement(
      Spin,
      null,
      React.createElement(Alert, {
        style: { height: '20rem' },
        type: 'info'
      })
    );
  }

  return React.createElement(
    'div',
    { className: 'mapping--wrapper' },
    testing ? React.createElement(Alert, { type: 'warning', message: React.createElement(
        'span',
        null,
        React.createElement(Icon, { type: 'loading' }),
        ' Testing...'
      ) }) : errorMessages.length > 0 ? errorMessages.map(function (_ref4) {
      var _ref4$type = _ref4.type,
          type = _ref4$type === undefined ? 'error' : _ref4$type,
          _ref4$title = _ref4.title,
          title = _ref4$title === undefined ? 'Errors:' : _ref4$title,
          message = _ref4.message;
      return React.createElement(Alert, { type: type, message: title, description: message });
    }) : React.createElement(Alert, { type: 'success', message: 'Data mapping configuration looks good' }),
    allowDynamicObjectTypes && React.createElement(AddNewObjectType$1, { appName: appName, organizationId: organizationId, objectTypes: objectTypes }),
    objectTypes.map(function (objectType, objectTypeIdx) {
      return React.createElement(ObjectTypeMapping$2, {
        key: objectType.applicationObjectTypeName,
        objectType: objectType,
        appName: appName,
        organizationId: organizationId,
        objectTypeIdx: objectTypeIdx,
        onSave: onSave
      });
    })
  );
};

Mapping.propTypes = {
  organizationId: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
  isNewAppMapping: PropTypes.bool.isRequired,
  objectTypes: PropTypes.array,
  errors: PropTypes.array.isRequired,
  messages: PropTypes.array,
  loading: PropTypes.bool,
  allowDynamicObjectTypes: PropTypes.bool,
  onSave: PropTypes.array,
  fetchRawObjectTypes: PropTypes.func.isRequired,
  testMappingForAllObjectTypes: PropTypes.func.isRequired,
  fetchMappingForApp: PropTypes.func.isRequired,
  resetMappingForApp: PropTypes.func.isRequired,
  createMappingForApp: PropTypes.func.isRequired
};

Mapping.defaultProps = {
  objectTypes: [],
  messages: [],
  loading: false,
  isNewAppMapping: false,
  allowDynamicObjectTypes: false,
  allowedMappingModes: fieldMappingModes.RAW
};

var _Mapping = connect(mapStateToProps$7, mapActionsToProps$5)(Mapping);

var fetchRelationsForAppFlow = {
  request: function request() {
    return { type: FETCH_RELATIONS_FOR_APP_REQUEST };
  },
  success: function success(response) {
    return { type: FETCH_RELATIONS_FOR_APP_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: FETCH_RELATIONS_FOR_APP_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchRelationsForApp = function fetchRelationsForApp(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId;
  return asyncAction.GET({
    flow: fetchRelationsForAppFlow,
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/relationships',
    actionPayload: { appName: appName },
    requiresAuth: true
  });
};

var saveRelationsForAppFlow = {
  request: function request() {
    return { type: SAVE_RELATIONS_FOR_APP_REQUEST };
  },
  success: function success(response) {
    return { type: SAVE_RELATIONS_FOR_APP_SUCCESS, payload: _extends$1({}, response) };
  },
  failure: function failure(err) {
    return { type: SAVE_RELATIONS_FOR_APP_FAILURE, payload: _extends$1({}, err) };
  }
};

var saveRelationsForApp = function saveRelationsForApp(_ref2) {
  var appName = _ref2.appName,
      organizationId = _ref2.organizationId,
      isNew = _ref2.isNew,
      _ref2$relations = _ref2.relations,
      relations = _ref2$relations === undefined ? [] : _ref2$relations;

  var actionParams = {
    flow: saveRelationsForAppFlow,
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/relationships',
    params: { relationships: relations },
    actionPayload: { appName: appName },
    requiresAuth: true
  };

  if (isNew) return asyncAction.POST(actionParams);
  return asyncAction.PUT(actionParams);
};

var mappingObjectTypesSelector = function mappingObjectTypesSelector(state, appName) {
  return state.mapping[appName].objectTypes;
};

var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};

// CONSTANTS
var Title = Typography.Title;


var loadingSelector = createLoadingSelector(['FETCH_RELATIONS_FOR_APP']);

var savingSelector = createLoadingSelector(['SAVE_RELATIONS_FOR_APP']);

var Relations = function Relations(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId;

  var dispatch = useDispatch();
  var loading = useSelector(loadingSelector);
  var saving = useSelector(savingSelector);
  var mappingObjectTypes = useSelector(function (state) {
    return mappingObjectTypesSelector(state, appName);
  });
  var isNew = useSelector(function (state) {
    return state.relations[appName].isNew;
  });
  var relationships = useSelector(function (state) {
    return state.relations[appName].relations;
  });

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      relations = _useState2[0],
      setRelations = _useState2[1];

  var relationMap = useMemo(function () {
    var _relationMap = {};
    relations.forEach(function (_ref2) {
      var from = _ref2.from,
          to = _ref2.to;

      if (from && to) {
        if (!_relationMap[from]) _relationMap[from] = [];
        if (!_relationMap[to]) _relationMap[to] = [];

        _relationMap[from].push(to);
        _relationMap[to].push(from);
      }
    });
    return _relationMap;
  }, [relations]);

  var hasChanged = useMemo(function () {
    return !isEqual(relationships, relations.filter(function (_ref3) {
      var from = _ref3.from,
          to = _ref3.to;
      return from && to;
    }));
  }, [relationships, relations]);

  var typeOptions = useMemo(function () {
    return mappingObjectTypes.map(function (type) {
      return { label: type.applicationObjectTypeLabel, value: type.applicationObjectTypeName };
    });
  }, [mappingObjectTypes]);

  var saveRelations = useCallback(function () {
    return dispatch(saveRelationsForApp({
      appName: appName,
      organizationId: organizationId,
      isNew: isNew,
      relations: relations.filter(function (_ref4) {
        var from = _ref4.from,
            to = _ref4.to;
        return from && to;
      }) }));
  }, [relations, isNew]);

  var addRelation = useCallback(function () {
    return setRelations(function (prevRelations) {
      return [].concat(_toConsumableArray(prevRelations), [{ from: undefined, to: undefined }]);
    });
  }, []);

  var removeRelation = useCallback(function (index) {
    return setRelations(function (prevRelations) {
      prevRelations.splice(index, 1);
      return [].concat(_toConsumableArray(prevRelations));
    });
  }, []);

  var setRelation = useCallback(function (value, prop, index) {
    return setRelations(function (prevRelations) {
      prevRelations[index][prop] = value;
      return [].concat(_toConsumableArray(prevRelations));
    });
  }, []);

  useEffect(function () {
    dispatch(fetchRelationsForApp({ appName: appName, organizationId: organizationId }));
  }, []);

  var prevLoading = usePrevious(loading);
  useEffect(function () {
    if (!loading && prevLoading) {
      if (isNew) addRelation();else setRelations(cloneDeep(relationships));
    }
  }, [loading]);

  return React.createElement(
    'div',
    null,
    React.createElement(
      PageHeader,
      {
        title: React.createElement(
          Title,
          { level: 2 },
          'Relations'
        ),
        extra: [React.createElement(
          Button,
          {
            htmlType: 'submit',
            type: 'primary',
            onClick: saveRelations,
            loading: saving,
            disabled: !hasChanged
          },
          'Save changes'
        )]
      },
      React.createElement(
        Spin,
        { spinning: loading },
        React.createElement(Alert, {
          type: 'info',
          message: 'Please make sure to only map relations that is configured in TE server',
          showIcon: true
        }),
        React.createElement(
          Row,
          { gutter: [10], style: { marginTop: 10 } },
          React.createElement(
            Col,
            { span: 4 },
            React.createElement(
              Title,
              { level: 4 },
              'Select type:'
            )
          ),
          React.createElement(Col, { span: 1 }),
          React.createElement(
            Col,
            { span: 4 },
            React.createElement(
              Title,
              { level: 4 },
              'Relation to:'
            )
          )
        ),
        relations.map(function (_ref5, index) {
          var from = _ref5.from,
              to = _ref5.to;
          return React.createElement(
            Row,
            { gutter: [10], key: index, style: { marginTop: 10 } },
            React.createElement(
              Col,
              { span: 4 },
              React.createElement(
                Select,
                {
                  value: from,
                  placeholder: 'Please select',
                  onChange: function onChange(value) {
                    return setRelation(value, 'from', index);
                  },
                  style: { width: '100%' }
                },
                typeOptions.map(function (_ref6) {
                  var value = _ref6.value,
                      label = _ref6.label;
                  return React.createElement(
                    Select.Option,
                    {
                      key: value,
                      value: value,
                      disabled: to && (value === to || relationMap[to] && relationMap[to].includes(value))
                    },
                    label
                  );
                })
              )
            ),
            React.createElement(
              Col,
              { span: 1 },
              React.createElement(Icon, {
                type: 'swap',
                style: { lineHeight: '32px', position: 'relative', top: '50%', left: '35%' }
              })
            ),
            React.createElement(
              Col,
              { span: 4 },
              React.createElement(
                Select,
                {
                  value: to,
                  placeholder: 'Please select',
                  onChange: function onChange(value) {
                    return setRelation(value, 'to', index);
                  },
                  style: { width: '100%' }
                },
                typeOptions.map(function (_ref7) {
                  var value = _ref7.value,
                      label = _ref7.label;
                  return React.createElement(
                    Select.Option,
                    {
                      key: value,
                      value: value,
                      disabled: from && (value === from || relationMap[from] && relationMap[from].includes(value))
                    },
                    label
                  );
                })
              )
            ),
            React.createElement(
              Col,
              { span: 1 },
              React.createElement(
                Button,
                { onClick: function onClick() {
                    return removeRelation(index);
                  }, style: { border: 0, position: 'relative', top: '50%' } },
                React.createElement(Icon, {
                  type: 'minus-square',
                  style: { color: 'red', fontSize: 16, lineHeight: '32px' }
                })
              )
            )
          );
        }),
        React.createElement(
          Row,
          { style: { marginTop: 10 } },
          React.createElement(
            Col,
            null,
            React.createElement(
              Button,
              { onClick: addRelation, style: { border: 0 } },
              React.createElement(Icon, { type: 'plus-square' }),
              'Add relation'
            )
          )
        )
      )
    )
  );
};

Relations.propTypes = {
  appName: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired
};

var reservationMappingSelector = function reservationMappingSelector(state) {
  return state.reservationMapping;
};

var reservationSituationTypesSelector = function reservationSituationTypesSelector(state) {
  return state.reservationMapping.situationTypes;
};

var reservationSituationTypeByValueSelector = createSelector(reservationSituationTypesSelector, function (__, value) {
  return value;
}, function (situationTypes, value) {
  return situationTypes[value] || [];
});

var fetchReservationSettingsFlow = {
  request: function request() {
    return { type: FETCH_RESERVATION_SETTINGS_REQUEST };
  },
  success: function success(_ref) {
    var payload = _ref.data;
    return { type: FETCH_RESERVATION_SETTINGS_SUCCESS, payload: payload };
  },
  failure: function failure(err) {
    return { type: FETCH_RESERVATION_SETTINGS_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchReservationSettings = function fetchReservationSettings(_ref2) {
  var appName = _ref2.appName,
      organizationId = _ref2.organizationId;
  return asyncAction.GET({
    flow: fetchReservationSettingsFlow,
    endpoint: 'service/' + appName + '/reservation-mapping/' + organizationId,
    requiresAuth: true,
    actionPayload: {
      appName: appName
    },
    additionalOptions: {
      retryWhenFail: true
    }
  });
};

var fetchTestReservationSettingsFlow = {
  request: function request() {
    return { type: FETCH_TEST_RESERVATION_SETTINGS_REQUEST };
  },
  success: function success(_ref3) {
    var payload = _ref3.data;
    return { type: FETCH_TEST_RESERVATION_SETTINGS_SUCCESS, payload: payload };
  },
  failure: function failure(err) {
    return { type: FETCH_TEST_RESERVATION_SETTINGS_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchTestReservationSettings = function fetchTestReservationSettings(_ref4) {
  var appName = _ref4.appName,
      organizationId = _ref4.organizationId;
  return asyncAction.POST({
    flow: fetchTestReservationSettingsFlow,
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/reservation/validate',
    requiresAuth: true
  });
};

var saveReservationSettingsFlow = {
  request: function request() {
    return { type: UPDATE_RESERVATION_SETTINGS_REQUEST };
  },
  success: function success(_ref5) {
    var payload = _ref5.data;
    return { type: UPDATE_RESERVATION_SETTINGS_SUCCESS, payload: payload };
  },
  failure: function failure(err) {
    return { type: UPDATE_RESERVATION_SETTINGS_FAILURE, payload: _extends$1({}, err) };
  }
};

var saveReservationSettings = function saveReservationSettings(params) {
  var organizationId = params.organizationId,
      appName = params.appName;

  return asyncAction.PUT({
    flow: saveReservationSettingsFlow,
    endpoint: 'service/' + appName + '/reservation-mapping/' + organizationId,
    successNotification: true,
    params: params
  });
};

var createReservationSettingsFlow = {
  request: function request() {
    return { type: UPDATE_RESERVATION_SETTINGS_REQUEST };
  },
  success: function success(_ref6) {
    var payload = _ref6.data;
    return { type: UPDATE_RESERVATION_SETTINGS_SUCCESS, payload: payload };
  },
  failure: function failure(err) {
    return { type: UPDATE_RESERVATION_SETTINGS_FAILURE, payload: _extends$1({}, err) };
  }
};

var createReservationSettings = function createReservationSettings(params) {
  var organizationId = params.organizationId,
      appName = params.appName;

  return asyncAction.POST({
    flow: createReservationSettingsFlow,
    endpoint: 'service/' + appName + '/reservation-mapping',
    successNotification: true,
    params: _extends$1({}, params, {
      organizationId: organizationId
    })
  });
};

var updateReservationSetting = function updateReservationSetting(payload) {
  return function (dispatch) {
    return dispatch({
      type: UPDATE_RESERVATION_SETTINGS,
      payload: payload
    });
  };
};

var Title$1 = Typography.Title;


var GeneralTemplate = function GeneralTemplate(_ref) {
  var fields = _ref.fields,
      label = _ref.label,
      _onChange = _ref.onChange,
      form = _ref.form;

  var dispatch = useDispatch();
  var getFieldDecorator = form.getFieldDecorator;


  var reservationMapping = useSelector(reservationMappingSelector);

  return React.createElement(
    'div',
    null,
    label && React.createElement(
      Title$1,
      { level: 3 },
      label
    ),
    map(fields, function (field, appFieldId) {
      var _ref2 = field || {},
          optionsSource = _ref2.optionsSource,
          required = _ref2.required,
          label = _ref2.label;

      var options = reservationMapping[optionsSource] || [];
      return React.createElement(
        Form.Item,
        { label: label, key: appFieldId },
        getFieldDecorator(appFieldId, {
          rules: [{ required: required, message: '' }]
        })(React.createElement(
          Select,
          {
            name: appFieldId,
            onChange: function onChange(value) {
              dispatch(updateReservationSetting({ appFieldId: appFieldId, fieldExt: value }));
              _onChange({ appFieldId: appFieldId, fieldExt: value });
            },
            allowClear: true,
            showSearch: true
          },
          options.map(function (_ref3, index) {
            var label = _ref3.label,
                value = _ref3.value;
            return React.createElement(
              Select.Option,
              { key: index, value: value },
              label
            );
          })
        ))
      );
    })
  );
};

GeneralTemplate.propTypes = {
  fields: PropTypes.objectOf(PropTypes.object).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func
  }).isRequired
};

var reservationSettingsSelector = function reservationSettingsSelector(state) {
  return state.reservationSettings.payload;
};

var reservationTypeValuesSelector = createSelector(reservationSettingsSelector, mappingObjectTypesSelector, function (__, appName) {
  return appName;
}, function (reservationSettings, objectTypes, appName) {
  var values = {};
  if (RESERVATION_SETTINGS_MAPPING[appName]) {
    RESERVATION_SETTINGS_MAPPING[appName].forEach(function (_ref) {
      var types = _ref.types;

      forEach(types, function (_ref2, typeKey) {
        var label = _ref2.label,
            reduxSource = _ref2.reduxSource;

        if (reduxSource === 'reservationSettings') {
          var type = reservationSettings.find(function (rS) {
            return rS.appFieldId === typeKey;
          });
          values[typeKey] = type ? type.fieldExt : null;
        } else if (reduxSource === 'mapping') {
          var _type = objectTypes.find(function (oT) {
            return oT.applicationObjectTypeName === typeKey;
          });
          values[typeKey] = _type ? _type.objectTypeExtId : null;
        }
      });
    });
  }
  return values;
});

var validationReservationSettingsSelector = function validationReservationSettingsSelector(state) {
  return state.reservationSettings.validation;
};

var reservationSettingIsNewSelector = function reservationSettingIsNewSelector(state) {
  return state.reservationSettings.isNew;
};

var typeIdentifiedSelector = createSelector(reservationSettingsSelector, reservationTypeValuesSelector, reservationSituationTypesSelector, function (__, appName) {
  return appName;
}, function (reservationSettings, reservationTypeValues, reservationTypes, appName) {
  var identified = {};
  if (RESERVATION_SETTINGS_MAPPING[appName]) {
    RESERVATION_SETTINGS_MAPPING[appName].forEach(function (_ref3) {
      var modeFieldId = _ref3.modeFieldId,
          types = _ref3.types,
          fields = _ref3.fields;

      if (modeFieldId && types) {
        var modeFieldValue = (reservationSettings.find(function (_ref4) {
          var appFieldId = _ref4.appFieldId;
          return appFieldId === modeFieldId;
        }) || {}).fieldExt;
        var reservationType = reservationTypes[modeFieldValue] || [];
        identified[modeFieldId] = _Object$keys(types).reduce(function (tot, typeKey) {
          return _extends$1({}, tot, _defineProperty({}, typeKey, !!(reservationTypeValues[typeKey] && reservationType.includes(reservationTypeValues[typeKey]))));
        }, {});
      }
    });
  }

  return identified;
});

var Title$2 = Typography.Title,
    Text = Typography.Text;


var SelectModeTemplate = function SelectModeTemplate(_ref) {
  var types = _ref.types,
      fields = _ref.fields,
      modeFieldId = _ref.modeFieldId,
      appName = _ref.appName,
      label = _ref.label,
      _onChange = _ref.onChange,
      form = _ref.form;

  var dispatch = useDispatch();
  var getFieldDecorator = form.getFieldDecorator;


  var reservationMapping = useSelector(reservationMappingSelector);
  var reservationSettings = useSelector(reservationSettingsSelector);
  var typeIdentified = useSelector(function (state) {
    return typeIdentifiedSelector(state, appName);
  });

  var _useMemo = useMemo(function () {
    return {
      modeField: fields[modeFieldId],
      propertyFields: omit(fields, [modeFieldId]),
      modeFieldValue: (reservationSettings.find(function (_ref2) {
        var appFieldId = _ref2.appFieldId;
        return appFieldId === modeFieldId;
      }) || {}).fieldExt
    };
  }, [fields, modeFieldId, reservationSettings]),
      modeField = _useMemo.modeField,
      propertyFields = _useMemo.propertyFields,
      modeFieldValue = _useMemo.modeFieldValue;

  var renderItem = useCallback(function (_ref3, appFieldId) {
    var optionsSource = _ref3.optionsSource,
        required = _ref3.required,
        label = _ref3.label;

    var options = optionsSource === 'situationFields' ? reservationMapping[optionsSource][modeFieldValue] : reservationMapping[optionsSource];

    return React.createElement(
      Form.Item,
      { label: label, key: appFieldId || null },
      getFieldDecorator(appFieldId, {
        rules: [{
          required: appFieldId === modeFieldId || modeField.required || modeFieldValue ? required : false,
          message: ''
        }]
      })(React.createElement(
        Select,
        {
          name: appFieldId,
          onChange: function onChange(value) {
            dispatch(updateReservationSetting({ appFieldId: appFieldId, fieldExt: value }));
            _onChange({ appFieldId: appFieldId, fieldExt: value });
          },
          allowClear: true,
          showSearch: true,
          disabled: !modeFieldValue && appFieldId !== modeFieldId
        },
        (options || []).map(function (_ref4, index) {
          var label = _ref4.label,
              value = _ref4.value;
          return React.createElement(
            Select.Option,
            { key: index, value: value },
            label
          );
        })
      ))
    );
  }, [modeFieldId, modeFieldValue, reservationMapping]);

  return React.createElement(
    'div',
    null,
    React.createElement(
      Row,
      null,
      label && React.createElement(
        Title$2,
        { level: 3 },
        label
      ),
      renderItem(modeField, modeFieldId)
    ),
    React.createElement(
      Row,
      { style: { marginBottom: 20 } },
      React.createElement(
        Title$2,
        { level: 4 },
        'Types'
      ),
      map(types, function (type, typeKey) {
        return React.createElement(
          'div',
          { key: typeKey },
          React.createElement(
            Col,
            { sm: 24, md: 12, lg: 8, className: type.required && 'suffix-required' },
            type.label
          ),
          React.createElement(
            Col,
            { sm: 24, md: 12, lg: 16 },
            typeIdentified[modeFieldId][typeKey] ? React.createElement(
              Text,
              { style: { color: 'green' } },
              'Identified on reservation mode'
            ) : React.createElement(
              Text,
              { type: 'danger' },
              'Not identified on reservation mode'
            )
          )
        );
      })
    ),
    React.createElement(
      Row,
      null,
      React.createElement(
        Title$2,
        { level: 4 },
        'Fields'
      ),
      map(propertyFields, function (field, appFieldId) {
        return renderItem(field, appFieldId);
      })
    )
  );
};

SelectModeTemplate.propTypes = {
  appName: PropTypes.string.isRequired,
  modeFieldId: PropTypes.string.isRequired,
  fields: PropTypes.objectOf(PropTypes.object).isRequired,
  types: PropTypes.objectOf(PropTypes.object).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func
  }).isRequired
};

var fetchSituationsSettingsFlow = {
  request: function request() {
    return { type: FETCH_SITUATIONS_REQUEST };
  },
  success: function success(_ref) {
    var payload = _ref.data;
    return { type: FETCH_SITUATIONS_SUCCESS, payload: payload };
  },
  failure: function failure(err) {
    return { type: FETCH_SITUATIONS_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchSituationsSettings = function fetchSituationsSettings(_ref2) {
  var appName = _ref2.appName,
      organizationId = _ref2.organizationId,
      reservationSituationKind = _ref2.reservationSituationKind;

  return asyncAction.GET({
    flow: fetchSituationsSettingsFlow,
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/reservation/situations',
    requiresAuth: true,
    params: {
      reservationSituationKind: reservationSituationKind
    },
    additionalOptions: {
      retryWhenFail: true
    }
  });
};

var fetchSituationFields = function fetchSituationFields(_ref3) {
  var appName = _ref3.appName,
      organizationId = _ref3.organizationId,
      value = _ref3.value;
  return asyncAction.GET({
    flow: {
      request: function request() {
        return { type: FETCH_SITUATION_FIELD_REQUEST };
      },
      success: function success(_ref4) {
        var payload = _ref4.data;
        return { type: FETCH_SITUATION_FIELD_SUCCESS, payload: payload, value: value };
      },
      failure: function failure(err) {
        return { type: FETCH_SITUATION_FIELD_FAILURE, payload: _extends$1({}, err) };
      }
    },
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/reservation/fields/' + value,
    requiresAuth: true,
    additionalOptions: {
      retryWhenFail: true
    }
  });
};

var fetchSituationTypes = function fetchSituationTypes(_ref5) {
  var appName = _ref5.appName,
      organizationId = _ref5.organizationId,
      value = _ref5.value;
  return asyncAction.GET({
    flow: {
      request: function request() {
        return { type: FETCH_SITUATION_TYPE_REQUEST };
      },
      success: function success(_ref6) {
        var payload = _ref6.data;
        return { type: FETCH_SITUATION_TYPE_SUCCESS, payload: payload, value: value };
      },
      failure: function failure(err) {
        return { type: FETCH_SITUATION_TYPE_FAILURE, payload: _extends$1({}, err) };
      }
    },
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/reservation/types/' + value,
    requiresAuth: true,
    additionalOptions: {
      retryWhenFail: true
    }
  });
};

var fetchObjectTypesFlow = {
  request: function request() {
    return { type: FETCH_OBJECT_TYPES_REQUEST };
  },
  success: function success(_ref7) {
    var payload = _ref7.data;
    return { type: FETCH_OBJECT_TYPES_SUCCESS, payload: payload };
  },
  failure: function failure(err) {
    return { type: FETCH_OBJECT_TYPES_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchObjectTypes = function fetchObjectTypes(_ref8) {
  var appName = _ref8.appName,
      organizationId = _ref8.organizationId;
  return asyncAction.GET({
    flow: fetchObjectTypesFlow,
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/object/types',
    requiresAuth: true,
    additionalOptions: {
      retryWhenFail: true
    }
  });
};

var fetchObjectTypeFieldsFlow = {
  request: function request() {
    return { type: FETCH_OBJECT_TYPE_FIELD_REQUEST };
  },
  success: function success(_ref9) {
    var payload = _ref9.data;
    return { type: FETCH_OBJECT_TYPE_FIELD_SUCCESS, payload: payload };
  },
  failure: function failure(err) {
    return { type: FETCH_OBJECT_TYPE_FIELD_FAILURE, payload: _extends$1({}, err) };
  }
};

var fetchObjectTypeFields = function fetchObjectTypeFields(_ref10) {
  var appName = _ref10.appName,
      organizationId = _ref10.organizationId,
      value = _ref10.value;
  return asyncAction.GET({
    flow: fetchObjectTypeFieldsFlow,
    endpoint: 'service/' + appName + '/integration/' + organizationId + '/object/types/' + encodeURIComponent(value) + '?applyOutputObjectMapping=true&applyInputObjectTypeMapping=false',
    requiresAuth: true,
    additionalOptions: {
      retryWhenFail: true
    }
  });
};

var Title$3 = Typography.Title;


var byAppFieldId = function byAppFieldId(appFieldId) {
  return function (item) {
    return item.appFieldId === appFieldId;
  };
};

var ReservationSettings = function ReservationSettings(_ref) {
  var organizationId = _ref.organizationId,
      appName = _ref.appName,
      onSaveExamShouldPublish = _ref.onSaveExamShouldPublish,
      form = _ref.form;

  var dispatch = useDispatch();
  var validationReservationSettings = useSelector(validationReservationSettingsSelector);
  var reservationSettings = useSelector(reservationSettingsSelector);
  var situationTypes = useSelector(reservationSituationTypesSelector);
  var typeIdentified = useSelector(function (state) {
    return typeIdentifiedSelector(state, appName);
  });
  var isNew = useSelector(reservationSettingIsNewSelector);
  var reservationSettingsLoading = useSelector(createLoadingSelector(['FETCH_RESERVATION_SETTINGS']));
  var reservationSettingsSaving = useSelector(createLoadingSelector(['UPDATE_RESERVATION_SETTINGS']));
  var reservationTestSettingsLoading = useSelector(createLoadingSelector(['FETCH_TEST_RESERVATION_SETTINGS']));
  var situationTypeLoading = useSelector(createLoadingSelector(['FETCH_SITUATION_FIELD']));
  var objectTypeLoading = useSelector(createLoadingSelector(['FETCH_OBJECT_TYPE_FIELD']));
  var validateFieldsAndScroll = form.validateFieldsAndScroll,
      setFieldsValue = form.setFieldsValue;

  useEffect(function () {
    dispatch(fetchReservationSettings({ appName: appName, organizationId: organizationId }));
    dispatch(fetchSituationsSettings({ appName: appName, organizationId: organizationId }));
    dispatch(fetchObjectTypes({ appName: appName, organizationId: organizationId }));
    dispatch(fetchTestReservationSettings({ appName: appName, organizationId: organizationId }));
  }, []);

  var allFields = useMemo(function () {
    return RESERVATION_SETTINGS_ALL_FIELDS[appName] || {};
  }, [appName]);

  var prevReservationSettings = usePrevious(reservationSettings) || [];

  var switchMapped = useMemo(function () {
    return {
      fetchSituationFields: function fetchSituationFields$$1(value) {
        return dispatch(fetchSituationFields({ appName: appName, organizationId: organizationId, value: value }));
      },
      fetchSituationTypes: function fetchSituationTypes$$1(value) {
        return dispatch(fetchSituationTypes({ appName: appName, organizationId: organizationId, value: value }));
      },
      fetchObjectTypeFields: function fetchObjectTypeFields$$1(value) {
        return dispatch(fetchObjectTypeFields({ appName: appName, organizationId: organizationId, value: value }));
      }
    };
  }, [appName, organizationId]);

  useEffect(function () {
    reservationSettings.forEach(function (_ref2) {
      var appFieldId = _ref2.appFieldId,
          fieldExt = _ref2.fieldExt;

      setFieldsValue(_defineProperty({}, appFieldId, fieldExt));

      var _ref3 = allFields[appFieldId] || {},
          onChange = _ref3.onChange;

      var _ref4 = prevReservationSettings.find(byAppFieldId(appFieldId)) || {},
          preValue = _ref4.fieldExt;

      var isChanged = fieldExt !== preValue;

      // onChange could be 1 string or array of strings (action names)
      if (onChange && isChanged && fieldExt) {
        if (!Array.isArray(onChange)) {
          onChange = [onChange];
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(onChange), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var action = _step.value;

            if (switchMapped[action]) {
              switchMapped[action](fieldExt);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    });
  }, [reservationSettings, switchMapped, allFields]);

  useEffect(function () {
    if (RESERVATION_SETTINGS_MAPPING[appName]) {
      RESERVATION_SETTINGS_MAPPING[appName].forEach(function (_ref5) {
        var fields = _ref5.fields,
            types = _ref5.types,
            modeFieldId = _ref5.modeFieldId;

        if (modeFieldId) {
          var modeFieldValue = (reservationSettings.find(function (_ref6) {
            var appFieldId = _ref6.appFieldId;
            return appFieldId === modeFieldId;
          }) || {}).fieldExt;
          if (modeFieldValue && !situationTypes[modeFieldValue]) {
            switchMapped.fetchSituationTypes(modeFieldValue);
          }
        }
      });
    }
  }, [appName, reservationSettings, switchMapped]);

  var onSave = useCallback(function (e) {
    e.preventDefault();
    validateFieldsAndScroll(function (err, values) {
      if (!err) {
        if (isNew) {
          dispatch(createReservationSettings({
            appName: appName,
            organizationId: organizationId,
            paramMappings: reservationSettings
          }));
        } else {
          dispatch(saveReservationSettings({
            appName: appName,
            organizationId: organizationId,
            paramMappings: reservationSettings
          }));
        }

        // Check and set shouldPublish off for fields not identified
        if (appName === appNames.TE_EXAM) {
          var shouldPublish = chain(typeIdentified[EXAM_RESERVATION_MODE_FIELD]).pickBy(function (idendified, typeName) {
            return EXAM_OBJECT_FIELD_MAP[typeName] && !idendified;
          }).value();
          if (!isEmpty(shouldPublish)) {
            if (onSaveExamShouldPublish) {
              dispatch(onSaveExamShouldPublish({ organizationId: organizationId, shouldPublish: shouldPublish }));
            } else {
              dispatch(saveExamShouldPublish({ organizationId: organizationId, shouldPublish: shouldPublish }));
            }
          }
        }
      }
    });
  }, [isNew, appName, organizationId, reservationSettings, typeIdentified]);

  var onChange = useCallback(function (_ref7) {
    var appFieldId = _ref7.appFieldId;

    _Object$keys(allFields).forEach(function (fieldId) {
      var dependOn = allFields[fieldId].dependOn;

      if (dependOn === appFieldId) {
        dispatch(updateReservationSetting({ appFieldId: fieldId, fieldExt: null }));
      }
    });
  }, [allFields]);

  if (!RESERVATION_SETTINGS_MAPPING[appName]) {
    return React.createElement(Alert, { type: 'error', message: 'This application does not support Reservation settings' });
  }

  var handleOnTest = function handleOnTest() {
    return dispatch(fetchTestReservationSettings({ appName: appName, organizationId: organizationId }));
  };

  var errorMessages = useMemo(function () {
    var errors = [];
    if (RESERVATION_SETTINGS_MAPPING[appName]) {
      (RESERVATION_SETTINGS_MAPPING[appName] || []).forEach(function (_ref8) {
        var fields = _ref8.fields,
            types = _ref8.types,
            templateType = _ref8.templateType,
            modeFieldId = _ref8.modeFieldId;

        // check validation of mode field
        if (templateType === TEMPLATE_TYPE.SELECT_MODE) {
          var _fields$modeFieldId = fields[modeFieldId],
              required = _fields$modeFieldId.required,
              requiredMessage = _fields$modeFieldId.requiredMessage,
              label = _fields$modeFieldId.label,
              uniqWithFields = _fields$modeFieldId.uniqWithFields,
              uniqWithFieldsMessage = _fields$modeFieldId.uniqWithFieldsMessage;

          var field = find(reservationSettings, { appFieldId: modeFieldId }) || {};
          if (!field.fieldExt) {
            if (required) {
              errors.push(requiredMessage || 'No ' + label + ' selected');
            } else {
              return;
            }
          } else {
            if (uniqWithFields) {
              var nonunique = uniqWithFields.some(function (fieldId) {
                var fieldToCheck = find(reservationSettings, { appFieldId: fieldId }) || {};
                return !!(fieldToCheck.fieldExt && fieldToCheck.fieldExt === field.fieldExt);
              });
              if (nonunique) {
                errors.push(uniqWithFieldsMessage || 'Not unique');
              }
            }
          }
        }

        // check validation of all types
        _Object$keys(types || {}).forEach(function (typeKey) {
          var _types$typeKey = types[typeKey],
              required = _types$typeKey.required,
              requiredMessage = _types$typeKey.requiredMessage,
              label = _types$typeKey.label;


          if (required && (!typeIdentified[modeFieldId] || !typeIdentified[modeFieldId][typeKey])) {
            errors.push(requiredMessage || label + ' not detected');
          }
        });

        // check validation of non-mode fields
        _Object$keys(fields).forEach(function (appFieldId) {
          var _fields$appFieldId = fields[appFieldId],
              required = _fields$appFieldId.required,
              requiredMessage = _fields$appFieldId.requiredMessage,
              label = _fields$appFieldId.label;

          if (required && appFieldId !== modeFieldId) {
            var _field = find(reservationSettings, { appFieldId: appFieldId });
            if (!_field || !_field.fieldExt) {
              errors.push(requiredMessage || 'No ' + label + ' selected');
            }
          }
        });
      });
    }
    return errors;
  }, [appName, reservationSettings, situationTypes]);

  var testResultMessages = useMemo(function () {
    var errors = [];
    if (validationReservationSettings.result !== 0) {
      errors.push(validationReservationSettings.message);
    }
    return errors;
  }, [validationReservationSettings]);

  var alert = useMemo(function () {
    // loading
    if (isEmpty(validationReservationSettings) || reservationTestSettingsLoading) {
      return React.createElement(Alert, {
        type: 'warning',
        message: React.createElement(
          'span',
          null,
          React.createElement(Icon, { type: 'loading' }),
          ' Testing...'
        ),
        style: { marginBottom: 20 }
      });
    }

    // success
    if (errorMessages.length === 0 && testResultMessages.length === 0) {
      return React.createElement(Alert, { type: 'success', message: 'Data mapping configuration looks good', style: { marginBottom: 20 } });
    }

    // got errors
    return React.createElement(
      'div',
      { style: { marginBottom: 20 } },
      testResultMessages.length > 0 && React.createElement(Alert, {
        type: 'warning',
        message: 'Test result:',
        description: React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'ul',
            null,
            testResultMessages.map(function (message, index) {
              return React.createElement(
                'li',
                { key: index },
                message
              );
            })
          )
        )
      }),
      errorMessages.length > 0 && React.createElement(Alert, {
        type: 'error',
        message: 'Errors:',
        description: React.createElement(
          'ul',
          null,
          errorMessages.map(function (message, index) {
            return React.createElement(
              'li',
              { key: index },
              message
            );
          })
        )
      })
    );
  }, [validationReservationSettings, reservationTestSettingsLoading, errorMessages, testResultMessages]);

  return React.createElement(
    'div',
    { className: 'reservation-settings' },
    React.createElement(
      PageHeader,
      {
        title: React.createElement(
          Title$3,
          { level: 2 },
          'Reservation settings'
        ),
        extra: [React.createElement(
          Button,
          { onClick: handleOnTest, type: 'button', loading: reservationTestSettingsLoading },
          'Test'
        ), React.createElement(
          Button,
          {
            htmlType: 'submit',
            type: 'primary',
            onClick: onSave,
            loading: reservationSettingsSaving,
            disabled: errorMessages.length > 0
          },
          'Save changes'
        )]
      },
      alert,
      React.createElement(
        Spin,
        { tip: 'Loading...', spinning: reservationSettingsLoading || situationTypeLoading || objectTypeLoading },
        React.createElement(
          Form,
          {
            layout: 'horizontal',
            labelAlign: 'left',
            labelCol: { sm: { span: 24 }, md: { span: 12 }, xl: { span: 8 } },
            wrapperCol: { sm: { span: 24 }, md: { span: 12 }, xl: { span: 8 } }
          },
          (RESERVATION_SETTINGS_MAPPING[appName] || []).map(function (_ref9) {
            var templateType = _ref9.templateType,
                showDependOn = _ref9.showDependOn,
                configs = _objectWithoutProperties(_ref9, ['templateType', 'showDependOn']);

            // check dependent value
            if (showDependOn) {
              var dependOnElement = reservationSettings.find(function (_ref10) {
                var appFieldId = _ref10.appFieldId;
                return appFieldId === showDependOn;
              });
              if (!dependOnElement || !dependOnElement.fieldExt) return null;
            }

            switch (templateType) {
              case TEMPLATE_TYPE.SELECT_MODE:
                return React.createElement(SelectModeTemplate, _extends$1({}, configs, { appName: appName, onChange: onChange, form: form }));
              case TEMPLATE_TYPE.GENERAL:
              default:
                return React.createElement(GeneralTemplate, _extends$1({}, configs, { onChange: onChange, form: form }));
            }
          })
        )
      )
    )
  );
};

ReservationSettings.propTypes = {
  appName: PropTypes.string.isRequired,
  form: PropTypes.object,
  organizationId: PropTypes.string,
  onSaveExamShouldPublish: PropTypes.func
};

ReservationSettings.defaultProps = {
  onSaveExamShouldPublish: null
};

var _ReservationSettings = Form.create({ name: 'FormReservationSettings' })(ReservationSettings);

var IntegrationContext = React.createContext();

var IntegrationProvider = function IntegrationProvider(_ref) {
  var children = _ref.children,
      baseUrl$$1 = _ref.baseUrl,
      accessToken$$1 = _ref.accessToken,
      rest = _objectWithoutProperties(_ref, ['children', 'baseUrl', 'accessToken']);

  setAccessToken(accessToken$$1);
  setBaseUrl(baseUrl$$1);
  return React.createElement(
    IntegrationContext.Provider,
    { value: _extends$1({}, rest) },
    children
  );
};

IntegrationProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired,
  accessToken: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired
};

var IntegrationContainer = _extends$1({}, IntegrationContext, { Provider: IntegrationProvider });

var ObjectTypeGetter = function ObjectTypeGetter(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      _ref$objectPath = _ref.objectPath,
      objectPath = _ref$objectPath === undefined ? 'mapping.teExam.objectTypes' : _ref$objectPath,
      onInitialized = _ref.onInitialized;

  var response = useSelector(function (state) {
    return _.get(state, objectPath);
  });
  var loading = useSelector(createLoadingSelector(['FETCH_MAPPING_FOR_APP', 'SAVE_MAPPING_FOR_APP', 'FETCH_RESERVATION_SETTINGS']));

  var prevLoading = usePrevious(loading);

  var dispatch = useDispatch();

  useEffect(function () {
    dispatch(fetchMappingForApp({ appName: appName, organizationId: organizationId }));
    dispatch(fetchReservationSettings({ appName: appName, organizationId: organizationId }));
  }, []);

  useEffect(function () {
    if (prevLoading && !loading && objectPath) {
      typeof onInitialized === 'function' && onInitialized(response);
    }
  }, [loading, objectPath, response]);
  return null;
};

var fetchObjectFields = function fetchObjectFields(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      fields = _ref.fields;

  return createThunkActions({
    flow: {
      request: function request() {
        return { type: FETCH_OBJECT_FIELDS_REQUEST };
      },
      success: function success(payload) {
        return { type: FETCH_OBJECT_FIELDS_SUCCESS, payload: payload };
      },
      failure: function failure(err) {
        return { type: FETCH_OBJECT_FIELDS_FAILURE, payload: _extends$1({}, err) };
      },
      actionPayload: {
        fields: fields
      }
    },
    actions: fields.map(function (field) {
      return {
        method: 'GET',
        endpoint: 'service/' + appName + '/integration/' + organizationId + '/object/types/' + encodeURIComponent(field),
        params: {
          applyOutputObjectMapping: true
        },
        successNotification: false,
        additionalOptions: {
          retryWhenFail: true
        }
      };
    })
  });
};

var fetchObjectFieldsWithRelated = function fetchObjectFieldsWithRelated(_ref2) {
  var appName = _ref2.appName,
      organizationId = _ref2.organizationId,
      fields = _ref2.fields,
      relationMap = _ref2.relationMap;
  return createThunkActions({
    flow: {
      request: function request() {
        return { type: FETCH_OBJECT_FIELDS_WITH_RELATED_REQUEST };
      },
      success: function success(payload) {
        return { type: FETCH_OBJECT_FIELDS_WITH_RELATED_SUCCESS, payload: payload };
      },
      failure: function failure(err) {
        return { type: FETCH_OBJECT_FIELDS_WITH_RELATED_FAILURE, payload: _extends$1({}, err) };
      },
      actionPayload: {
        fields: fields
      }
    },
    actions: fields.map(function (field) {
      return {
        method: 'GET',
        endpoint: 'service/' + appName + '/integration/' + organizationId + '/object/types/' + encodeURIComponent(field) + '/extend',
        params: _extends$1({
          applyOutputObjectMapping: true
        }, relationMap[field] ? relationMap[field].reduce(function (tot, relation, index) {
          return _extends$1({}, tot, _defineProperty({}, 'relatedObjectTypes[' + index + ']', relation));
        }, {}) : {}),
        successNotification: false,
        additionalOptions: {
          retryWhenFail: true
        }
      };
    })
  });
};

var loadingSelector$1 = createLoadingSelector(['FETCH_OBJECT_FIELDS', 'FETCH_OBJECT_FIELDS_WITH_RELATED']);
var savingSelector$1 = createLoadingSelector(['SAVE_MAPPING_FOR_APP']);
var initRelationsSelector = createInitSelector(['FETCH_RELATIONS_FOR_APP']);

var ObjectFieldsGetter = function ObjectFieldsGetter(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      onInitialized = _ref.onInitialized,
      fields = _ref.fields,
      refetchTrigger = _ref.refetchTrigger,
      withRelated = _ref.withRelated;

  var loading = useSelector(loadingSelector$1);
  var saving = useSelector(savingSelector$1);
  var relationsLoaded = useSelector(initRelationsSelector);
  var objectFields = useSelector(function (state) {
    return state.objectGetter.fields;
  });
  var relatedExtIds = useSelector(function (state) {
    return state.objectGetter.relatedExtIds;
  });
  var relations = useSelector(function (state) {
    return state.relations[appName].relations;
  });

  var relationMap = useMemo(function () {
    if (isEmpty(relations)) return {};
    var _relationMap = {};
    relations.forEach(function (_ref2) {
      var from = _ref2.from,
          to = _ref2.to;

      if (from && to) {
        if (!_relationMap[from]) _relationMap[from] = [];
        if (!_relationMap[to]) _relationMap[to] = [];

        _relationMap[from].push(to);
        _relationMap[to].push(from);
      }
    });
    return _relationMap;
  }, [relations]);

  var prevLoading = usePrevious(loading);

  var dispatch = useDispatch();

  useEffect(function () {
    if (withRelated) {
      dispatch(fetchRelationsForApp({ appName: appName, organizationId: organizationId }));
    }
  }, []);

  useEffect(function () {
    if (withRelated) {
      if (relationsLoaded) {
        dispatch(fetchObjectFieldsWithRelated({ appName: appName, organizationId: organizationId, fields: fields, relationMap: relationMap }));
      }
    } else {
      dispatch(fetchObjectFields({ appName: appName, organizationId: organizationId, fields: fields }));
    }
  }, [relationsLoaded]);

  var prevRefetchTrigger = usePrevious(refetchTrigger);
  var prevSaving = usePrevious(saving);
  useEffect(function () {
    if (!loading && (!refetchTrigger && prevRefetchTrigger || !saving && prevSaving)) {
      dispatch(!withRelated ? fetchObjectFields({ appName: appName, organizationId: organizationId, fields: fields }) : fetchObjectFieldsWithRelated({ appName: appName, organizationId: organizationId, fields: fields, relationMap: relationMap }));
    }
  }, [refetchTrigger, saving]);

  useEffect(function () {
    if (!loading && prevLoading && typeof onInitialized === 'function') {
      if (!withRelated) {
        onInitialized({ objectFields: objectFields });
      } else {
        onInitialized({ objectFields: objectFields, relatedExtIds: relatedExtIds, relationMap: relationMap });
      }
    }
  }, [loading, objectFields, relatedExtIds, relationMap]);
  return null;
};

var loadingSelector$2 = createLoadingSelector(['FETCH_RELATIONS_FOR_APP', 'SAVE_RELATIONS_FOR_APP']);

var RelationsGetter = function RelationsGetter(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      onInitialized = _ref.onInitialized;

  var dispatch = useDispatch();

  var relations = useSelector(function (state) {
    return state.relations[appName].relations;
  });
  var loading = useSelector(loadingSelector$2);

  useEffect(function () {
    dispatch(fetchRelationsForApp({ appName: appName, organizationId: organizationId }));
  }, []);

  var prevLoading = usePrevious(loading);
  useEffect(function () {
    if (prevLoading && !loading && relations) {
      typeof onInitialized === 'function' && onInitialized({ relations: relations });
    }
  }, [loading, relations]);
  return null;
};

var ReservationSituationsGetter = function ReservationSituationsGetter(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      onInitialized = _ref.onInitialized,
      reservationSituationKind = _ref.reservationSituationKind;

  var situationsSelector = createSelector(function (state) {
    return state.reservationMapping;
  }, function (mapping) {
    return mapping.situations;
  });
  var situations = useSelector(situationsSelector);
  var loading = useSelector(createLoadingSelector(['FETCH_SITUATIONS']));

  var prevLoading = usePrevious(loading);

  var dispatch = useDispatch();

  useEffect(function () {
    dispatch(fetchSituationsSettings({ appName: appName, organizationId: organizationId, reservationSituationKind: reservationSituationKind }));
  }, [reservationSituationKind]);

  useEffect(function () {
    if (prevLoading && !loading && situations) {
      typeof onInitialized === 'function' && onInitialized({ situations: situations });
    }
  }, [loading, situations]);
  return null;
};

var loadingSelector$3 = createLoadingSelector(['FETCH_RESERVATION_SETTINGS', 'UPDATE_RESERVATION_SETTINGS', 'FETCH_SITUATION_TYPE']);

var ReservationTypeIdentifiedGetter = function ReservationTypeIdentifiedGetter(_ref) {
  var appName = _ref.appName,
      organizationId = _ref.organizationId,
      onInitialized = _ref.onInitialized;

  var typeIdentified = useSelector(function (state) {
    return typeIdentifiedSelector(state, appName);
  });
  var reservationSettings = useSelector(reservationSettingsSelector);
  var reservationTypes = useSelector(reservationSituationTypesSelector);
  var loading = useSelector(loadingSelector$3);

  var prevLoading = usePrevious(loading);

  var dispatch = useDispatch();

  useEffect(function () {
    dispatch(fetchReservationSettings({ appName: appName, organizationId: organizationId }));
  }, [appName, organizationId]);

  useEffect(function () {
    if (reservationSettings.length > 0 && RESERVATION_SETTINGS_MAPPING[appName]) {
      RESERVATION_SETTINGS_MAPPING[appName].forEach(function (_ref2) {
        var modeFieldId = _ref2.modeFieldId,
            types = _ref2.types,
            fields = _ref2.fields;

        if (modeFieldId) {
          var modeFieldValue = (reservationSettings.find(function (_ref3) {
            var appFieldId = _ref3.appFieldId;
            return appFieldId === modeFieldId;
          }) || {}).fieldExt;
          if (modeFieldValue && !reservationTypes[modeFieldValue]) {
            dispatch(fetchSituationTypes({ appName: appName, organizationId: organizationId, value: modeFieldValue }));
          }
        }
      });
    }
  }, [reservationSettings, reservationTypes]);

  useEffect(function () {
    if (prevLoading && !loading) {
      typeof onInitialized === 'function' && onInitialized({
        typeIdentified: typeIdentified,
        reservationSettings: reservationSettings.reduce(function (prev, _ref4) {
          var appFieldId = _ref4.appFieldId,
              fieldExt = _ref4.fieldExt;
          return _extends$1({}, prev, _defineProperty({}, appFieldId, fieldExt));
        })
      });
    }
  }, [loading, typeIdentified]);
  return null;
};

var en = {
	"common.label.baseUrl": "Base URL",
	"common.label.baseUrlDesc": "The URL TE Exam should use to connect to the TimeEdit server",
	"common.label.baseUrlRequired": "Base URL is required",
	"common.label.certificate": "Certificate key",
	"common.label.certificateDesc": "The certificate key TE Exam should use to authenticate with the TimeEdit server",
	"common.label.certificateRequired": "Certificate key is required",
	"common.label.configureIntegrationSettings": "Configure the integration settings for communicating with TE Server",
	"common.label.password": "Password",
	"common.label.passwordDesc": "The password TE Exam should use to authenticate with the TimeEdit server",
	"common.label.passwordRequired": "Password is required",
	"common.label.proceedWithCaution": "Editing properties here can break your connection with the TimeEdit server. Proceed with caution",
	"common.label.saveChanges": "Save changes",
	"common.label.username": "Username",
	"common.label.usernameDesc": "The username TE Exam should use to authenticate with the TimeEdit server",
	"common.label.usernameRequired": "Username is required"
};

var sv = {
	"common.label.baseUrl": "SOAP-adress",
	"common.label.baseUrlDesc": "Ange adressen TE Exam behöver för att kopplas mot TE Server",
	"common.label.baseUrlRequired": "SOAP-adress krävs",
	"common.label.certificate": "Certifikat",
	"common.label.certificateDesc": "Ange certifikatet TE Exam behöver för autentifikation mot TE Server",
	"common.label.certificateRequired": "Certifikat krävs",
	"common.label.configureIntegrationSettings": "Integrationsinställningar",
	"common.label.password": "Lösenord",
	"common.label.passwordDesc": "Ange lösenordet TE Exam behöver för autentifikation mot TE Server",
	"common.label.passwordRequired": "Lösenord krävs",
	"common.label.proceedWithCaution": "Fortsätt med försiktighet",
	"common.label.saveChanges": "Spara ändringar",
	"common.label.username": "Användarnamn",
	"common.label.usernameDesc": "Ange användarnamnet TE Exam behöver för autentifikation mot TE Server",
	"common.label.usernameRequired": "Användarnamn krävs"
};

var nb = {
	
};

var translateMessage = { en: en, sv: sv, nb: nb };

// Configure store and attach to window object
var store = configureStore();

var ConnectionSettings$1 = function ConnectionSettings(_ref) {
  var language = _ref.language;
  return React.createElement(
    Provider,
    { store: store },
    React.createElement(
      IntegrationContainer.Consumer,
      null,
      function (_ref2) {
        var appName = _ref2.appName,
            organizationId = _ref2.organizationId,
            language = _ref2.language;

        return React.createElement(
          TE18inProvider$1,
          { lang: language, translateMessage: translateMessage },
          React.createElement(_ConnectionSettings, { organizationId: organizationId })
        );
      }
    )
  );
};

ConnectionSettings$1.propTypes = {
  language: PropTypes.string.isRequired
};
ConnectionSettings$1.defaultProps = {
  language: 'en'
};

var Mapping$1 = function Mapping(_ref3) {
  var appName = _ref3.appName,
      rest = _objectWithoutProperties(_ref3, ['appName']);

  return React.createElement(
    Provider,
    { store: store },
    React.createElement(
      IntegrationContainer.Consumer,
      null,
      function (_ref4) {
        var organizationId = _ref4.organizationId;

        return React.createElement(_Mapping, _extends$1({ appName: appName, organizationId: organizationId }, rest));
      }
    )
  );
};
Mapping$1.propTypes = {
  appName: PropTypes.string.isRequired
};

var Relations$1 = function Relations$$1(_ref5) {
  var appName = _ref5.appName,
      rest = _objectWithoutProperties(_ref5, ['appName']);

  return React.createElement(
    Provider,
    { store: store },
    React.createElement(
      IntegrationContainer.Consumer,
      null,
      function (_ref6) {
        var organizationId = _ref6.organizationId;
        return React.createElement(Relations, _extends$1({ appName: appName, organizationId: organizationId }, rest));
      }
    )
  );
};
Relations$1.propTypes = {
  appName: PropTypes.string.isRequired
};

var ReservationSettings$1 = function ReservationSettings(_ref7) {
  var appName = _ref7.appName,
      onSaveExamShouldPublish = _ref7.onSaveExamShouldPublish;
  return React.createElement(
    Provider,
    { store: store },
    React.createElement(
      IntegrationContainer.Consumer,
      null,
      function (_ref8) {
        var organizationId = _ref8.organizationId;

        return React.createElement(_ReservationSettings, {
          appName: appName,
          organizationId: organizationId,
          onSaveExamShouldPublish: onSaveExamShouldPublish
        });
      }
    )
  );
};

ReservationSettings$1.propTypes = {
  appName: PropTypes.string.isRequired,
  onSaveExamShouldPublish: PropTypes.func
};

ReservationSettings$1.defaultProps = {
  onSaveExamShouldPublish: null
};

var ObjectTypesGetter = function ObjectTypesGetter(_ref9) {
  var appName = _ref9.appName,
      objectPath = _ref9.objectPath,
      onInitialized = _ref9.onInitialized;
  return React.createElement(
    Provider,
    { store: store },
    React.createElement(
      IntegrationContainer.Consumer,
      null,
      function (_ref10) {
        var organizationId = _ref10.organizationId;

        return React.createElement(ObjectTypeGetter, { appName: appName, objectPath: objectPath, organizationId: organizationId, onInitialized: onInitialized });
      }
    )
  );
};

ObjectTypesGetter.propTypes = {
  appName: PropTypes.string.isRequired,
  objectPath: PropTypes.string,
  onInitialized: PropTypes.func.isRequired
};

var ObjectFieldsGetter$1 = function ObjectFieldsGetter$$1(_ref11) {
  var appName = _ref11.appName,
      onInitialized = _ref11.onInitialized,
      fields = _ref11.fields,
      refetchTrigger = _ref11.refetchTrigger,
      withRelated = _ref11.withRelated;
  return React.createElement(
    Provider,
    { store: store },
    React.createElement(
      IntegrationContainer.Consumer,
      null,
      function (_ref12) {
        var organizationId = _ref12.organizationId;

        return React.createElement(ObjectFieldsGetter, {
          appName: appName,
          organizationId: organizationId,
          onInitialized: onInitialized,
          fields: fields,
          refetchTrigger: refetchTrigger,
          withRelated: withRelated
        });
      }
    )
  );
};

ObjectFieldsGetter$1.propTypes = {
  appName: PropTypes.string.isRequired,
  onInitialized: PropTypes.func.isRequired,
  fields: PropTypes.array,
  refetchTrigger: PropTypes.bool,
  withRelated: PropTypes.bool
};
ObjectFieldsGetter$1.defaultProps = {
  fields: [],
  refetchTrigger: false,
  withRelated: false
};

var ReservationSituationsGetter$1 = function ReservationSituationsGetter$$1(_ref13) {
  var appName = _ref13.appName,
      onInitialized = _ref13.onInitialized,
      reservationSituationKind = _ref13.reservationSituationKind;
  return React.createElement(
    Provider,
    { store: store },
    React.createElement(
      IntegrationContainer.Consumer,
      null,
      function (_ref14) {
        var organizationId = _ref14.organizationId;

        return React.createElement(ReservationSituationsGetter, { appName: appName, organizationId: organizationId, onInitialized: onInitialized, reservationSituationKind: reservationSituationKind });
      }
    )
  );
};

ReservationSituationsGetter$1.propTypes = {
  appName: PropTypes.string.isRequired,
  onInitialized: PropTypes.func.isRequired,
  reservationSituationKind: PropTypes.string
};
ReservationSituationsGetter$1.propTypes = {
  reservationSituationKind: null
};

var RelationsGetter$1 = function RelationsGetter$$1(_ref15) {
  var appName = _ref15.appName,
      onInitialized = _ref15.onInitialized;
  return React.createElement(
    Provider,
    { store: store },
    React.createElement(
      IntegrationContainer.Consumer,
      null,
      function (_ref16) {
        var organizationId = _ref16.organizationId;

        return React.createElement(RelationsGetter, { appName: appName, organizationId: organizationId, onInitialized: onInitialized });
      }
    )
  );
};

RelationsGetter$1.propTypes = {
  appName: PropTypes.string.isRequired,
  onInitialized: PropTypes.func.isRequired
};

var ReservationTypeIdentifiedGetter$1 = function ReservationTypeIdentifiedGetter$$1(_ref17) {
  var appName = _ref17.appName,
      onInitialized = _ref17.onInitialized;
  return React.createElement(
    Provider,
    { store: store },
    React.createElement(
      IntegrationContainer.Consumer,
      null,
      function (_ref18) {
        var organizationId = _ref18.organizationId;

        return React.createElement(ReservationTypeIdentifiedGetter, { appName: appName, organizationId: organizationId, onInitialized: onInitialized });
      }
    )
  );
};

ReservationTypeIdentifiedGetter$1.propTypes = {
  appName: PropTypes.string.isRequired,
  onInitialized: PropTypes.func.isRequired
};

export { IntegrationContainer, ConnectionSettings$1 as ConnectionSettings, Mapping$1 as Mapping, Relations$1 as Relations, ReservationSettings$1 as ReservationSettings, ObjectTypesGetter, ObjectFieldsGetter$1 as ObjectFieldsGetter, ReservationSituationsGetter$1 as ReservationSituationsGetter, RelationsGetter$1 as RelationsGetter, ReservationTypeIdentifiedGetter$1 as ReservationTypeIdentifiedGetter, EXAM_RESERVATION_MODE_FIELD };
//# sourceMappingURL=index.es.js.map
